import ToggleInput from "./inputs/ToggleInput";
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState, useCallback } from "react";
import { AnimatePresence, motion } from 'framer-motion';
import unidecode from "unidecode-plus";
import { ReactComponent as PencilIcon } from "../images/icons/pencil.svg";
import { ReactComponent as TokenIcon } from '../images/icons/promptus-token.svg';
// import TokenIcon from '../images/icons/promptus-token.svg';
import { ReactComponent as HistoryIcon } from '../images/icons/history.svg';
import { ReactComponent as CloseIcon } from "../images/icons/white-close.svg";
import { ReactComponent as AdvancedSettingsIcon } from '../images/icons/advanced-settings-expand-arrow.svg';
import { useGenerateDispatch, useGenerateStatus } from "../context/GenerateContext";
import { usePromptusAPIState, usePromptusAPIDispatch } from "../context/PromptusAPIContext";
import { useDriverContext, useDriverContextDispatch } from "../context/DriverContext";
import { useCollectionContext, useCollectionContextDispatch } from "../context/CollectionContext";
import { useAccountContext } from "../context/AccountContext";
import ImageUpload from "./ImageUpload";
import { db, extractCosyflowMeta } from "../db";
import DrawingInput from "./inputs/DrawingInput";
import PromptHistory from "./PromptHistory";
import { getLoras, getModels, getServerStatus, revealLocator, isLocalServerBusy, getRecommendedSettings, getCosyflows, getCosyflowData, getApiBaseUrl } from "../api-helper";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import { ReactComponent as InfoIcon } from "../images/icons/info.svg"
import { ReactComponent as HowToIconActive } from "../images/icons/nav-icons/nav-icon-how-to-active.svg";
import { ReactComponent as RecordingIcon } from "../images/icons/input-bar-icons/icon-input-bar-voice.svg";
import { ReactComponent as StopRecordingIcon } from "../images/icons/input-bar-icons/icon-input-bar-voice-recording.svg";
import { ReactComponent as AccountIcon } from "../images/icons/promptus-profile-pic.svg";
import { ReactComponent as RefreshIcon } from "../images/icons/refresh.svg";
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';
import { debounce } from 'lodash';
import { usePromptContext } from '../context/PromptContext';
import { isUndefined } from "cropperjs";
import Select, { components } from 'react-select';
import makeAnimated from 'react-select/animated'
import Image from "image-js";
import { memo } from "react";
import Video from "./Video";
import Audio from "./Audio";
import axios from "axios";
import DynamicPromptFormExperiment from "./DynamicPromptFormExperiment";
import electronBridge from '../utils/electronBridge';
import { SlMenu } from "react-icons/sl";
import Logo from "../images/logo_light_grey.png";
import eventBus from '../utils/eventBus';
import * as LottiePlayer from "@lottiefiles/lottie-player";
import PromptSpin from "../images/prompts.lottie";

console.log('🚨🚨🚨 SCHEDULER TEST - If you see this, the new code is loaded! 🚨🚨🚨');

const schedulerOptions = [
    'Linear Multistep Scheduler',
    'Denoising Diffusion Implicit',
    'DPM-Solver',
    'DPM++ 2M Karras',
    'DPM++ SDE Karras',
    'DPM++ 2M SDE Karras',
    'Euler',
    'Euler 2',
    'Euler a',
    'Heun',
    'Pseudo Numerical',
    'Denoising Diffusion Probabilistic',
    'Ancestral Euler',
    'LCM',
    'DDIM',
    'UniPC'
];

console.log('[PromptHeader] schedulerOptions array loaded with', schedulerOptions.length, 'options:', schedulerOptions);

// List of default models to randomly select from
const DEFAULT_MODEL_LIST = [
    '(cosy) Flux Schnell fp8',
    '(AI-Horde) Flux.1-Schnell fp8 (Compact)',
    '(GenAI) Nano Banana 2.5 Flash',
    '(cosy) Flux Dev fp8'
];

const DEFAULT_VIDEO_MODEL = [
    '(GenAI) Veo 3 (preview) Text to Video'
]

const DEFAULT_AUDIO_MODEL = [
    '(Udio) Chirp v3.5 Music Generation'
]

// List of fallback models to try on "Model unavailable" error
const MODEL_FALLBACK_LIST = [...DEFAULT_MODEL_LIST];

// Helper function to randomly select a default model (offline-aware)
const getAvailableDefaultModel = (availableOptions = [], isOnline = true) => {
    console.log(`[DEFAULT MODEL] Getting default model - Online: ${isOnline}, Available options: ${availableOptions.length}`);

    // If offline and no options available yet, return empty to prevent online model contamination
    if (!isOnline && (!availableOptions || availableOptions.length === 0)) {
        console.log('[DEFAULT MODEL] Offline mode with no models loaded yet - returning empty to prevent contamination');
        return '';
    }

    console.log('[DEFAULT MODEL] Checking for MOMM image in sessionStorage...');
        
        // Check for image from MOMM in sessionStorage
        const sessionImageData = sessionStorage.getItem('imageToUse');
        
        if (sessionImageData) {
            try {
                const imageData = JSON.parse(sessionImageData);
                console.log('[DEFAULT MODEL] Found image data from MOMM:', imageData);
                
                // Only process if it's from MOMM and needs model selection
                if (imageData.fromMOMM && imageData.needsImageModel) {
                    console.log('[DEFAULT MODEL] Processing MOMM image with model selection...');
                    
                    const targetModel = imageData.preferredModel || "(GenAI) Nano Banana 2.5 Flash";
                    console.log('[DEFAULT MODEL] Switching to image-compatible model:', targetModel);
                    // Clear sessionStorage after processing
                    // sessionStorage.removeItem('imageToUse');
                    // console.log('[DEFAULT MODEL] Cleared sessionStorage');
                    return targetModel
                    
                }
            } catch (error) {
                console.error('[DEFAULT MODEL] Error processing MOMM image:', error);
                sessionStorage.removeItem('imageToUse'); // Clear corrupted data
            }
        }
    console.log('[DEFAULT MODEL] Selecting random default model');
    
    // If we have available options, find which default models exist
    if (availableOptions && availableOptions.length > 0) {
        // Filter to find which default models are actually available
        const availableDefaults = DEFAULT_MODEL_LIST.filter(modelName => 
            availableOptions.some(opt => opt.value === modelName)
        );
        
        // If we found any available default models, pick one randomly
        if (availableDefaults.length > 0) {
            const randomIndex = Math.floor(Math.random() * availableDefaults.length);
            const selectedModel = availableDefaults[randomIndex];
            console.log(`[DEFAULT MODEL] Randomly selected available model: ${selectedModel}`);
            return selectedModel;
        }
        
        console.log('[DEFAULT MODEL] No default models found in available options, picking random fallback');
    }
    
    // If no options available or no default models found, pick a random one from the list
    const randomIndex = Math.floor(Math.random() * DEFAULT_MODEL_LIST.length);
    const fallbackModel = DEFAULT_MODEL_LIST[randomIndex];
    console.log(`[DEFAULT MODEL] Using random fallback model: ${fallbackModel}`);
    return fallbackModel;
};

// Helper function to check if the model requires a mask (from DynamicPromptForm.jsx)
const checkIfModelRequiresMask = (schema) => {
  if (!schema || typeof schema !== 'object') {
    return false;
  }

  return Object.values(schema).some(field => {
    return (
      field.type === 'b64data' &&
      field.importance === 5 &&
      (field.require_mask === true || field.require_alpha === true)
    );
  });
};

// Helper function to check if an image has transparent pixels (alpha channel)
const checkForAlphaChannel = async (base64Image) => {
  console.log('[checkForAlphaChannel] Starting alpha channel check');

  if (!base64Image || typeof base64Image !== 'string') {
    console.log('[checkForAlphaChannel] Invalid base64 image data');
    return false;
  }

  const imageSizeMB = base64Image.length / (1024 * 1024);
  console.log('[checkForAlphaChannel] Image size:', imageSizeMB.toFixed(2), 'MB');

  // For large images, we'll resize them for validation to prevent timeouts
  const isLargeImage = base64Image.length > 1024 * 1024; // >1MB
  if (isLargeImage) {
    console.log('[checkForAlphaChannel] Large image detected, will resize for validation');
  }

  try {
    console.log('[checkForAlphaChannel] Creating canvas and image elements');
    // Create canvas and load image
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const img = new Image();
    img.src = `data:image/png;base64,${base64Image}`;
    console.log('[checkForAlphaChannel] Image src set to base64 data (length:', base64Image.length, ')');

    // Dynamic timeout based on image size
    const timeoutMs = Math.min(15000, Math.max(5000, imageSizeMB * 2000)); // 5-15 seconds based on size
    console.log('[checkForAlphaChannel] Using timeout of', timeoutMs, 'ms for this image size');

    console.log('[checkForAlphaChannel] Loading image...');
    await Promise.race([
      new Promise((resolve, reject) => {
        img.onload = () => {
          console.log('[checkForAlphaChannel] Image loaded successfully');
          resolve();
        };
        img.onerror = (error) => {
          console.error('[checkForAlphaChannel] Image load error:', error);
          reject(error);
        };
      }),
      new Promise((_, reject) =>
        setTimeout(() => {
          console.error('[checkForAlphaChannel] Image load timeout after', timeoutMs, 'ms');
          reject(new Error('Image load timeout'));
        }, timeoutMs)
      )
    ]);

    console.log('[checkForAlphaChannel] Setting canvas dimensions and drawing image');

    // For large images, resize to a smaller size for validation (preserves alpha channel accuracy)
    let canvasWidth, canvasHeight;
    if (isLargeImage && (img.width > 512 || img.height > 512)) {
      // Resize to max 512px while maintaining aspect ratio
      const aspectRatio = img.width / img.height;
      if (img.width > img.height) {
        canvasWidth = 512;
        canvasHeight = 512 / aspectRatio;
      } else {
        canvasHeight = 512;
        canvasWidth = 512 * aspectRatio;
      }
      console.log('[checkForAlphaChannel] Resizing large image from', img.width + 'x' + img.height, 'to', Math.round(canvasWidth) + 'x' + Math.round(canvasHeight), 'for validation');
    } else {
      canvasWidth = img.width;
      canvasHeight = img.height;
      console.log('[checkForAlphaChannel] Using original image size:', canvasWidth + 'x' + canvasHeight);
    }

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight);

    console.log('[checkForAlphaChannel] Getting image data');
    // Get image data and check for transparency
    const imageData = ctx.getImageData(0, 0, canvasWidth, canvasHeight);
    const pixels = imageData.data;

    console.log('[checkForAlphaChannel] Checking pixels for transparency (looking for alpha = 0)');
    let transparentCount = 0;
    let semiTransparentCount = 0;
    let totalPixels = pixels.length / 4;

    // Check if any pixel has alpha = 0 (fully transparent, indicating mask)
    for (let i = 3; i < pixels.length; i += 4) { // Alpha channel is every 4th value
      if (pixels[i] === 0) {
        transparentCount++;
      } else if (pixels[i] < 255) {
        semiTransparentCount++;
      }
    }

    console.log('[checkForAlphaChannel] Pixel analysis:');
    console.log('  - Total pixels:', totalPixels);
    console.log('  - Fully transparent (alpha=0):', transparentCount);
    console.log('  - Semi-transparent (0<alpha<255):', semiTransparentCount);

    // For masked images, we should have at least some fully transparent pixels
    if (transparentCount > 0) {
      console.log('[checkForAlphaChannel] Found', transparentCount, 'fully transparent pixels (masked areas)');
      return true; // Found masked areas
    }

    console.log('[checkForAlphaChannel] No fully transparent pixels found - no mask detected');
    return false; // No masked areas found
  } catch (error) {
    console.error('[checkForAlphaChannel] Error checking alpha channel:', error);
    return false;
  }
};

// Helper function to validate mask presence using schema properties
const validateMaskPresence = async (formData, cosyflowVariables) => {
  console.log('[validateMaskPresence] Starting validation with formData keys:', Object.keys(formData));
  console.log('[validateMaskPresence] cosyflowVariables keys:', Object.keys(cosyflowVariables || {}));

  if (!cosyflowVariables || typeof cosyflowVariables !== 'object') {
    console.log('[validateMaskPresence] No cosyflowVariables, returning valid');
    return { isValid: true, message: '' };
  }

  // Find fields that require masks
  const maskRequiredFields = [];
  const alphaRequiredFields = [];

  for (const [fieldKey, fieldConfig] of Object.entries(cosyflowVariables)) {
    if (fieldConfig.require_mask === true) {
      maskRequiredFields.push({ key: fieldKey, config: fieldConfig });
      console.log('[validateMaskPresence] Found require_mask field:', fieldKey);
    }
    if (fieldConfig.require_alpha === true) {
      alphaRequiredFields.push({ key: fieldKey, config: fieldConfig });
      console.log('[validateMaskPresence] Found require_alpha field:', fieldKey);
    }
  }

  console.log('[validateMaskPresence] Total require_mask fields:', maskRequiredFields.length);
  console.log('[validateMaskPresence] Total require_alpha fields:', alphaRequiredFields.length);

  // Check require_mask fields
  for (const field of maskRequiredFields) {
    const maskData = formData[field.key];
    if (!maskData || typeof maskData !== 'string' || maskData.trim() === '') {
      return {
        isValid: false,
        message: `This model requires a mask image. Please upload an image and add a mask by clicking on it.`
      };
    }
  }

  // Check require_alpha fields
  for (const field of alphaRequiredFields) {
    console.log('[validateMaskPresence] Checking require_alpha field:', field.key);
    const imageData = formData[field.key];
    console.log('[validateMaskPresence] Image data type:', typeof imageData);
    console.log('[validateMaskPresence] Image data length:', imageData ? imageData.length : 'null');

    if (!imageData || typeof imageData !== 'string' || imageData.trim() === '') {
      console.log('[validateMaskPresence] No image data found for require_alpha field:', field.key);
      return {
        isValid: false,
        message: `This model requires an image with transparency (alpha channel). Please upload an image and add a mask by clicking on it.`
      };
    }

    console.log('[validateMaskPresence] Checking alpha channel for field:', field.key);
    // Check if the image actually has transparency
    const hasAlpha = await checkForAlphaChannel(imageData);
    console.log('[validateMaskPresence] Alpha channel check result:', hasAlpha);

    if (!hasAlpha) {
      console.log('[validateMaskPresence] No alpha channel found for field:', field.key);
      return {
        isValid: false,
        message: `This model requires an image with transparency (alpha channel). Please click on your uploaded image to add a mask.`
      };
    }
    console.log('[validateMaskPresence] Alpha validation passed for field:', field.key);
  }

  return { isValid: true, message: '' };
};

function AnimatedInputGroup(props) {
    return (
        <motion.div
            variants={{ collapsed: { opacity: 0, height: 0 }, open: { opacity: 1, height: 'auto' } }}
            transition={{ duration: 0.2, delay: 0.2 }}
            id={props.id || ''}
            className={props.className || ''}
        >
            {props.children}
        </motion.div>
    )
}


let default_values = {
    seed: "",
    seed_mode: "random",
    negativeKeywords: "",
    steps: 12,
    guidance: 8,
    imageCount: 1,
    imageWidth: 512,
    imageHeight: 512,
    // scheduler: "DPM-Solver",
}

const CustomMenuList = (props) => {
    const menuListRef = useRef(null);
    useEffect(() => {
        if (menuListRef.current) {
            menuListRef.current.scrollTop = 0;
        }
    }, [props.selectProps.inputValue]);

    return (
        <components.MenuList {...props} innerRef={menuListRef}>
            {props.children}
        </components.MenuList>
    );
};

const animatedComponents = makeAnimated()

export default function PromptHeaderExperiment(props) {
    let { defaultPrompt, deepLinkModel } = props;
    const generateStatus = useGenerateStatus();
    const generateStatusDispatch = useGenerateDispatch();
    const promptusAPIState = usePromptusAPIState();
    const promptusAPIDispatch = usePromptusAPIDispatch();
    const driverContext = useDriverContext();
    const driverContextDispatch = useDriverContextDispatch();
    const collectionContext = useCollectionContext();
    const collectionContextDispatch = useCollectionContextDispatch();
    const accountContext = useAccountContext();
    const [settingsOpen, setSettingsOpen] = useState(true); // Open by default since we removed top prompt bar
    const [settings, setSettings] = useState([]);
    const [inPaint, setInPaint] = useState(false);
    const [maskImage, setMaskImage] = useState(null);
    const [openHistory, setOpenHistory] = useState(false);
    const [controlnetDisplay, setControlnetDisplay] = useState("");
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const [audioPrompt, setAudioPrompt] = useState("");
    const [profilePhoto, setProfilePhoto] = useState(localStorage.getItem("profilePhoto") || "");
    const [saveStatus, setSaveStatus] = useState(''); // 'saved', 'error', or ''
    const [activeMediaType, setActiveMediaType] = useState('image'); // Track active media type
    const advancedSettingsRef = useRef(null);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [hasInternet, setHasInternet] = useState(false);
    const [options, setOptions] = useState([]);
    const [modelsLoading, setModelsLoading] = useState(true);
    const [allWorkflows, setAllWorkflows] = useState([]);
    const [promptMappings, setPromptMappings] = useState([]);
    const [dynamic_inputs, setDynamic_Inputs] = useState(default_values);
    const [selectedWorkflow, setSelectedWorkflow] = useState("");

    // Add back missing state variables
    const [promptOutput, setPromptOutput] = useState('text-image');
    const [submitPrompt, setSubmitPrompt] = useState(defaultPrompt.prompt.prompt);
    const [seed, setSeed] = useState(defaultPrompt.prompt.params.seed_value);
    const [negativeKeywords, setNegativeKeywords] = useState(defaultPrompt.prompt.negative_prompt);
    const [steps, setSteps] = useState(defaultPrompt.prompt.params.num_inference_steps);
    const [guidance, setGuidance] = useState(defaultPrompt.prompt.params.guidance_scale);
    const [imageCount, setImageCount] = useState(1);
    const [imageWidth, setImageWidth] = useState(defaultPrompt.prompt.params.width);
    const [imageHeight, setImageHeight] = useState(defaultPrompt.prompt.params.height);

    // State for tracking uploaded b64data values to persist across form re-renders
    const [uploadedB64Data, setUploadedB64Data] = useState({});
    const [selectedModel, setSelectedModel] = useState(getAvailableDefaultModel([], promptusAPIState.online));
    const [selectedScheduler, setSelectedScheduler] = useState(defaultPrompt.prompt.params.scheduler);
    const [tile, setTile] = useState(defaultPrompt.prompt.params.tile);
    const [shuffle, setShuffle] = useState(defaultPrompt.prompt.params.shuffle);
    const [upscale, setUpScale] = useState(defaultPrompt.prompt.params.upscale_factor);
    const [pix2pix, setPix2Pix] = useState(false);
    const [controlNet, setControlNet] = useState("");
    const [onlineState, setOnlineState] = useState(promptusAPIState.online);
    const [image, setImage] = useState(null);
    const [enhancePrompt, setEnhancePrompt] = useState(false);
    const [imageNets, setImageNets] = useState("");
    const [tag, setTag] = useState("");
    const [inputTag, setInputTag] = useState("");
    const [managerOpen, setManagerOpen] = useState(false);
    const [apiLocalGPU, setApiLocalGPU] = useState("");
    const [apiLocalCPU, setApiLocalCPU] = useState("");
    const [apiLocalCosy, setApiLocalCosy] = useState("");
    const [onceTime, setOnceTime] = useState(false);
    const [selectedLora, setSelectedLora] = useState("");
    const [loraWeight, setLoraWeight] = useState(0);
    const { contextSubmitPrompt } = usePromptContext();
    const [memePrompt, setMemePrompt] = useState("");
    const [cosyUI, setCosyUI] = useState(false);
    const [onlineCosyUI, setOnlineCosyUI] = useState(false);
    console.log('[State Init] cosyUI initialized as false');

    const [input_json, setInput_json] = useState({});
    const [test_json, setTest_json] = useState({});

    const inputGroupRef = useRef();

    const [recording, setRecording] = useState(false);
    const [audioBlob, setAudioBlob] = useState(null);
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const [audioURL, setAudioURL] = useState('');
    const [isGenerating, setIsGenerating] = useState(false);
    const [logLoading, setLogLoading] = useState(false);

    const [jobRequestPending, setJobRequestPending] = useState(false);

    const ipcRenderer = electronBridge.ipcRenderer
    const [loadedModelData, setLoadedModelData] = useState(null); // Track which model's data is loaded

    const [modelInvalidCheck, setModelInvalidCheck] = useState(false)
    const [testCheck, setTestCheck] = useState(false)

    // Add validation abort controller for cancelling ongoing validation
    const validationAbortController = useRef(null)

    const tryProtocolWithFallback = (protocolUrl, fallbackUrl) => {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);

        try {
            iframe.contentWindow.location.href = protocolUrl;
        } catch (e) {
            console.log('[tryProtocolWithFallback] Protocol error:', e);
            window.open(fallbackUrl, '_blank');
        }

        setTimeout(() => {
            if (iframe.parentNode) {
                document.body.removeChild(iframe);
            }
        }, 1000);
    };

    // ========== MOMM IMAGE HANDLING HELPER FUNCTIONS ==========
    // Helper function to check if current model accepts images
    const checkModelAcceptsImages = (schema) => {
        if (!schema) return false;
        
        for (const [key, field] of Object.entries(schema)) {
            if (field.type === 'file' || 
                field.type === 'b64' || 
                field.type === 'b64data' || 
                field.type === 'IMAGE' ||
                (field.accept && field.accept.includes('image'))) {
                console.log('[MOMM_IMAGE] Model accepts images, found field:', key);
                return true;
            }
        }
        return false;
    };

    // Helper function to find first image field in schema
    const findImageField = (schema) => {
        if (!schema) return null;
        console.log('[MOMM_IMAGE] Finding image field in schema: ', schema);
        
        for (const [key, field] of Object.entries(schema)) {
            if (field.type === 'file' || 
                field.type === 'b64' || 
                field.type === 'b64data' || 
                field.type === 'IMAGE' ||
                (field.accept && field.accept.includes('image'))) {
                console.log('[MOMM_IMAGE] Found image field:', key);
                return key;
            }
        }
        return null;
    };

    // Helper function to process image after model is ready
    const processImageAfterModelSwitch = async(imageUrl, modelName) => {
        console.log('[MOMM_IMAGE] Processing image after model switch...');
        
        // 2. Find image field in current schema
        // Fetch cosyflow variables to check field types
        let newCosyVars = null;
        try {
            // Use indexed lookup for O(log n) performance instead of O(n)
            const matchingCosyflow = await db.cosyflows.where('data.title').equals(modelName).first();
            if (matchingCosyflow && matchingCosyflow.data.variables) {
                newCosyVars = matchingCosyflow.data.variables;
            }
        } catch (error) {
            console.error('[MODEL FALLBACK] Error fetching cosyflow variables:', error);
        }
        const imageFieldKey = findImageField(newCosyVars);
        
        if (imageFieldKey) {
            console.log('[MOMM_IMAGE] Setting image to field:', imageFieldKey);
            
            // Extract base64 from URL if needed
            let processedImage = imageUrl;
            if (imageUrl.startsWith('data:')) {
                // Extract just the base64 part if it's a data URL
                const base64Match = imageUrl.match(/base64,(.+)/);
                if (base64Match) {
                    processedImage = base64Match[1];
                }
            }
            
            // 3. Set image to dynamic input state
            setUploadedB64Data(prev => ({
                ...prev,
                [imageFieldKey]: processedImage
            }));
            
            // 4. Update form if available
            setTimeout(() => {
                if (inputGroupRef.current && inputGroupRef.current.setValue) {
                    inputGroupRef.current.setValue(imageFieldKey, processedImage);
                    console.log('[MOMM_IMAGE] Set image to form field:', imageFieldKey);
                }
            }, 100);
            
            console.log('[MOMM_IMAGE] Successfully set image from MOMM');
            // 1. Open settings panel if not already open
            if (!settingsOpen) {
                console.log('[MOMM_IMAGE] Opening settings panel...');
                setSettingsOpen(true);
                driverContextDispatch({type: 'advanced'});
            }
        } else {
            console.warn('[MOMM_IMAGE] No image field found in current model schema');
        }
    };
    // ========== END MOMM IMAGE HANDLING HELPER FUNCTIONS ==========

    // Helper function to extract prompts from current model using importance levels
    const extractPromptsFromCurrentModel = async (promptData) => {
        const prompts = {
            positive: '',
            negative: ''
        };
        
        if (!promptData?.prompt) return prompts;
        
        const prompt = promptData.prompt;
        
        // Get cosyflow variables for current model using indexed lookup
        const currentCosyflow = await db.cosyflows.where('data.title').equals(selectedModel).first();
        
        if (currentCosyflow?.data?.variables) {
            const variables = currentCosyflow.data.variables;
            
            // Find positive prompt (importance: 5)
            for (const [key, variable] of Object.entries(variables)) {
                if (variable.importance === 5 && prompt[key]) {
                    prompts.positive = prompt[key];
                    console.log(`[EXTRACT] Found positive prompt in field "${key}"`);
                    break;
                }
            }
            
            // Find negative prompt (importance: 4 or common field names)
            for (const [key, variable] of Object.entries(variables)) {
                if ((variable.importance === 4 || 
                     key.includes('negative') || 
                     key === 'negative_prompt') && 
                    prompt[key]) {
                    prompts.negative = prompt[key];
                    console.log(`[EXTRACT] Found negative prompt in field "${key}"`);
                    break;
                }
            }
        }
        
        // Fallback to common field names if no importance levels found
        if (!prompts.positive) {
            prompts.positive = prompt.prompt || prompt.text || submitPrompt || '';
        }
        if (!prompts.negative) {
            prompts.negative = prompt.negative_prompt || prompt.negative || '';
        }
        
        console.log('[EXTRACT] Extracted prompts:', prompts);
        return prompts;
    };

    // Helper function to apply extracted prompts to new model's schema
    const applyPromptsToNewModel = async (prompts, model) => {
        console.log(`[APPLY] Applying prompts to model: ${model}`, prompts);
        
        // Get the new model's schema using indexed lookup
        const newCosyflow = await db.cosyflows.where('data.title').equals(model).first();
        
        if (newCosyflow?.data?.variables) {
            const variables = newCosyflow.data.variables;
            const updates = {};
            
            // Find and set positive prompt field
            for (const [key, variable] of Object.entries(variables)) {
                if (variable.importance === 5) {
                    updates[key] = prompts.positive;
                    console.log(`[APPLY] Setting positive prompt to field "${key}"`);
                    break;
                }
            }
            
            // Find and set negative prompt field
            for (const [key, variable] of Object.entries(variables)) {
                if (variable.importance === 4 || 
                    key.includes('negative') || 
                    key === 'negative_prompt') {
                    updates[key] = prompts.negative;
                    console.log(`[APPLY] Setting negative prompt to field "${key}"`);
                    break;
                }
            }
            
            // Apply updates to form
            if (inputGroupRef.current && inputGroupRef.current.resetForm) {
                const currentValues = inputGroupRef.current.getValues();
                inputGroupRef.current.resetForm({
                    ...currentValues,
                    ...updates
                });
            }
            
            // Also update submitPrompt for fallback
            setSubmitPrompt(prompts.positive);
        } else {
            // Fallback: just set the main prompt
            setSubmitPrompt(prompts.positive);
        }
    };

    useEffect(() => {
        const handler = () => setJobRequestPending(false); // or whatever args you want
        eventBus.on('request_pending', handler);
        return () => eventBus.off('request_pending', handler);
    }, []);

    // Listen for useImage event from CollectionImage
    useEffect(() => {
        const handleUseImage = (imageData) => {
            console.log('[PromptHeader] Received useImage event with data:', imageData);
            
            // Ensure settings are open first so the form exists
            if (!settingsOpen) {
                setSettingsOpen(true);
                driverContextDispatch({type: 'advanced'});
            }
            
            // Wait for form to be ready
            setTimeout(() => {
                // Find the first image input field in the current schema
                const currentSchema = promptMappings;
                let imageFieldKey = null;
                
                // Look for fields that accept images
                for (const [key, field] of Object.entries(currentSchema || {})) {
                    if (field.type === 'file' || field.type === 'b64' || 
                        field.type === 'b64data' || field.type === 'image' || 
                        field.type === 'IMAGE' ||
                        (field.accept && field.accept.includes('image'))) {
                        imageFieldKey = key;
                        console.log(`[EVENT useImage] Found image field: ${key}`);
                        break;
                    }
                }
                
                if (imageFieldKey) {
                    // Set the image data to the appropriate field
                    setUploadedB64Data(prev => ({
                        ...prev,
                        [imageFieldKey]: imageData.image
                    }));
                    
                    // Trigger a re-render of the form with the new data
                    if (inputGroupRef.current && inputGroupRef.current.setValue) {
                        inputGroupRef.current.setValue(imageFieldKey, imageData.image);
                        console.log(`[EVENT useImage] Set image to dynamic field: ${imageFieldKey}`);
                    } else {
                        console.log('[EVENT useImage] Form not ready yet, image saved to uploadedB64Data');
                    }
                } else {
                    console.warn('[EVENT useImage] No image input field found in current schema');
                }
            }, 500); // Give time for form to render
        };
        
        eventBus.on('useImage', handleUseImage);
        return () => eventBus.off('useImage', handleUseImage);
    }, [settingsOpen, promptMappings]);
    
    // ========== MOMM IMAGE HANDLING USEEFFECT ==========
    // Handle images coming from MOMM page via sessionStorage
    // useEffect(() => {
    //     console.log('[MOMM_IMAGE] Checking for MOMM image in sessionStorage...');
        
    //     // Check for image from MOMM in sessionStorage
    //     const sessionImageData = sessionStorage.getItem('imageToUse');
        
    //     if (!sessionImageData) {
    //         return; // No image from MOMM
    //     }
        
    //     try {
    //         const imageData = JSON.parse(sessionImageData);
    //         console.log('[MOMM_IMAGE] Found image data from MOMM:', imageData);
            
    //         // Only process if it's from MOMM and needs model selection
    //         if (imageData.fromMOMM && imageData.needsImageModel) {
    //             console.log('[MOMM_IMAGE] Processing MOMM image with model selection...');
                
    //             // 1. Check if current model accepts images
    //             const currentAcceptsImages = checkModelAcceptsImages(promptMappings);
    //             console.log('[MOMM_IMAGE] Current model accepts images:', currentAcceptsImages);
                
    //             // 2. If current model doesn't accept images, switch to one that does
    //             if (!currentAcceptsImages) {
    //                 const targetModel = imageData.preferredModel || "(geminiimages) Nano Banana 2.5 Flash";
    //                 console.log('[MOMM_IMAGE] Switching to image-compatible model:', targetModel);
                    
    //                 // Switch to image-compatible model
    //                 setSelectedModel(targetModel);
                    
    //                 // Trigger schema loading for new model
    //                 handleRecommendedSettings(targetModel);
                    
    //                 // Wait for model to load before setting image
    //                 setTimeout(() => {
    //                     processImageAfterModelSwitch(imageData.url);
    //                 }, 1000); // Give time for schema to load
    //             } else {
    //                 // Current model already accepts images, just set the image
    //                 processImageAfterModelSwitch(imageData.url);
    //             }
                
    //             // Clear sessionStorage after processing
    //             sessionStorage.removeItem('imageToUse');
    //             console.log('[MOMM_IMAGE] Cleared sessionStorage');
    //         }
    //     } catch (error) {
    //         console.error('[MOMM_IMAGE] Error processing MOMM image:', error);
    //         sessionStorage.removeItem('imageToUse'); // Clear corrupted data
    //     }
    // }, []); // Run once on component mount
    // ========== END MOMM IMAGE HANDLING USEEFFECT ==========
    
    // Listen for selectModel event to change models programmatically
    useEffect(() => {
        const handleSelectModel = ({ modelName, openSettings = false }) => {
            console.log('[EVENT selectModel] Received selectModel event:', modelName);
            
            // Open settings first if requested (ensures form exists)
            if (openSettings && !settingsOpen) {
                console.log('[EVENT selectModel] Opening settings panel');
                setSettingsOpen(true);
                driverContextDispatch({type: 'advanced'});
            }
            
            // Set the model (will trigger handleRecommendedSettings via existing useEffect)
            console.log('[EVENT selectModel] Setting model to:', modelName);
            setSelectedModel(modelName);
            handleRecommendedSettings(modelName);
        };
        
        eventBus.on('selectModel', handleSelectModel);
        return () => eventBus.off('selectModel', handleSelectModel);
    }, [settingsOpen]);

    // Listen for model_unavailable event from Generate.jsx
    useEffect(() => {
        const handleModelUnavailable = async (data) => {
            console.log('[MODEL FALLBACK] Received model unavailable event', data);
            
            const { attemptedModels = [], originalPrompt } = data;
            
            // Extract current prompts using form values
            const currentFormValues = inputGroupRef.current ? inputGroupRef.current.getValues() : {};
            console.log('[MODEL FALLBACK] currentFormValues', currentFormValues);
            const promptData = { prompt: currentFormValues };
            console.log('[MODEL FALLBACK] promptData', promptData);
            const currentPrompts = await extractPromptsFromCurrentModel(promptData);
            console.log('[MODEL FALLBACK] currentPromptst', currentPrompts);

            // Fetch cosyflow variables to check field types
            let currentCosyVars = null;
            try {
                // Use indexed lookup for O(log n) performance
                const matchingCosyflow = await db.cosyflows.where('data.title').equals(data.currentModel).first();
                if (matchingCosyflow && matchingCosyflow.data.variables) {
                    currentCosyVars = matchingCosyflow.data.variables;
                }
            } catch (error) {
                console.error('[MODEL FALLBACK] Error fetching cosyflow variables:', error);
            }


            let currentMainPrompt;

            const searchMainPrompt = (promptData, cosyVars, edit, newValue = null) => {
                // Try to get the cosyflow variables which contain the importance metadata
                if (cosyVars) {
                    console.log('[MODEL FALLBACK] Using cosyflow variables to find main prompt field: ', promptData, ' | ', cosyVars);
                    
                    // Find fields with importance: 5 (main prompt fields)
                    const mainPromptFields = [];
                    for (const [key, variable] of Object.entries(cosyVars)) {
                        if (variable.importance === 5) {
                            mainPromptFields.push(key);
                            console.log(`[MODEL FALLBACK] Found field with importance 5: "${key}"`);
                        }
                    }
                    
                    // Check if any of the main prompt fields have valid content or need to be set
                    for (const fieldName of mainPromptFields) {
                        if (edit === true && newValue !== null) {
                            // Edit mode: Set the prompt value
                            console.log(`[MODEL FALLBACK] Setting prompt in field "${fieldName}" to: "${newValue.substring(0, 50)}..."`);
                            inputGroupRef.current.setValue(fieldName, newValue);
                            return promptData; // Return modified data
                        } else if (edit === false) {
                            // Read mode: Get the prompt value
                            if (fieldName in promptData) {
                                if (typeof promptData[fieldName] === 'string' && promptData[fieldName].trim() !== '') {
                                    console.log(
                                        `[MODEL FALLBACK] Found valid prompt in importance:5 field "${fieldName}": "${promptData[fieldName].substring(0, 50)}..."`
                                    );
                                    return promptData[fieldName];
                                     // Return the found value
                                }
                            }
                        }
                    }
                    
                    // If in edit mode and no existing field found, still set it in the first importance:5 field
                    if (edit === true && newValue !== null && mainPromptFields.length > 0) {
                        const firstField = mainPromptFields[0];
                        console.log(`[MODEL FALLBACK] Setting prompt in first importance:5 field "${firstField}"`);
                        promptData[firstField] = newValue;
                        return promptData;
                    }
                }
                
                return edit ? promptData : null; // Return data if editing, null if not found when reading
            }

            currentMainPrompt = searchMainPrompt(currentFormValues, currentCosyVars, false, null)
            console.log('[MODEL FALLBACK] Found Main Prompt: ', currentMainPrompt);
            
            // Find next available model
            const availableModels = MODEL_FALLBACK_LIST.filter(
                model => !attemptedModels.includes(model) && !attemptedModels.includes(data.currentModel)
            );
            
            if (availableModels.length === 0 || attemptedModels.length >= 4) {
                console.error('[MODEL FALLBACK] All fallback models exhausted');
                Swal.fire({
                    title: "All Models Unavailable",
                    text: "All fallback models are currently unavailable. Please try again later or contact support.",
                    icon: "error",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#FFB02E"
                });
                generateStatusDispatch({ type: 'ready' });
                return;
            }
            
            // Select next model
            const nextModel = availableModels[Math.floor(Math.random() * availableModels.length)];
            console.log(`[MODEL FALLBACK] Attempting with model: ${nextModel} (attempt ${attemptedModels.length + 1}/5)`);
            
            // Show user feedback
            generateStatusDispatch({ 
                type: 'info', 
                message: `Original model unavailable, trying ${nextModel}...` 
            });
            
            // Switch to new model and load its schema
            setSelectedModel(nextModel);

            // Fetch cosyflow variables to check field types
            let newCosyVars = null;
            try {
                // Use indexed lookup for O(log n) performance
                const matchingCosyflow = await db.cosyflows.where('data.title').equals(nextModel).first();
                if (matchingCosyflow && matchingCosyflow.data.variables) {
                    newCosyVars = matchingCosyflow.data.variables;
                }
            } catch (error) {
                console.error('[MODEL FALLBACK] Error fetching cosyflow variables:', error);
            }
            
            // Wait for schema to load
            await handleRecommendedSettings(nextModel);
            
            // Small delay to ensure form is ready
            setTimeout(() => {
                // Apply preserved prompts to new model
                // applyPromptsToNewModel(currentPrompts, nextModel);
                
                // Get current form values for retry
                const currentValues = inputGroupRef.current ? inputGroupRef.current.getValues() : {};
                let newData = searchMainPrompt(currentValues,newCosyVars,true,currentMainPrompt)
                console.log('[MODEL FALLBACK] Attempt at editing the current prompt into new model: ', newData);
                
                const finalData = inputGroupRef.current ? inputGroupRef.current.getValues() : {};
                // Flatten nested params object if it exists (React Hook Form creates nested structure for dotted field names)
                if (finalData.params && typeof finalData.params === 'object') {
                    console.log('[PARAMS FIX] Found nested params object, flattening it...');
                    // Extract all fields from params object
                    Object.entries(finalData.params).forEach(([key, value]) => {
                        finalData[`params.${key}`] = value;
                        console.log(`[PARAMS FIX] Flattened params.${key} =`, value);
                    });
                    // Remove the nested params object
                    delete finalData.params;
                    console.log('[PARAMS FIX] Removed nested params object');
                }
                
                console.log('[MODEL FALLBACK] Final Object before generation: ', finalData);

                const retryPrompt = {
                    prompt: finalData,
                    _attemptedModels: [...attemptedModels, data.currentModel],
                    _isRetry: true
                };
                
                // Small delay to ensure prompts are applied
                setTimeout(() => {
                    // Trigger generate with new model
                    console.log('[MODEL FALLBACK] Retrying generation with new model');
                    props.handleGenerate(retryPrompt, false, null);
                }, 200);
            }, 1000);
        };
        
        eventBus.on('model_unavailable', handleModelUnavailable);
        return () => eventBus.off('model_unavailable', handleModelUnavailable);
    }, [selectedModel, props]);

    // Skeleton Loader Component for Dynamic Inputs
    const DynamicInputsSkeleton = () => {
        return (
            <div className="flex flex-row flex-wrap gap-5">
                {/* Create 6 skeleton input fields */}
                {[1, 2, 3, 4, 5, 6].map((index) => (
                    <div key={index} className="animate-pulse">
                        {/* Skeleton for label */}
                        <div className="h-4 bg-gray-300 rounded w-24 mb-2"></div>
                        {/* Skeleton for input field */}
                        <div className="h-10 bg-gray-200 rounded w-40"></div>
                    </div>
                ))}
            </div>
        );
    };

    // Lottie Animation Loader Component
    const LottieLoader = () => {
        return (
            <div className="flex justify-center items-center p-10">
                <div style={{ width: '200px', height: '200px' }}>
                    <lottie-player
                        autoplay
                        loop
                        mode="normal"
                        src={PromptSpin}
                        style={{ width: '100%', height: '100%' }}
                    ></lottie-player>
                </div>
            </div>
        );
    };

    useEffect(() => {
        const updateOnlineStatus = () => {
            setIsOnline(navigator.onLine);
        };

        window.addEventListener('online', updateOnlineStatus);
        window.addEventListener('offline', updateOnlineStatus);

        return () => {
            window.removeEventListener('online', updateOnlineStatus);
            window.removeEventListener('offline', updateOnlineStatus);
        };

    }, []);

    useEffect(() => {
        const checkInternetConnection = async () => {
            try {
                const response = await fetch('https://www.google.com', { mode: 'no-cors' });
                setHasInternet(true);
                console.log("Internet connection is available");
            } catch (error) {
                console.log("no internet available");
                setHasInternet(false);
            }
        };

        if (isOnline) {
            console.log("Checking internet connection");
            checkInternetConnection();
        } else {
            console.log("No internet connection");
            setHasInternet(false);
        }

        // setOptions(promptusAPIState.models.map(model => ({ value: model, label: model })));
    }, [isOnline]);

    const openFile = (imageData) => {
        let imageDetails;
        try {
            imageDetails = JSON.parse(imageData);
        } catch (error) {
            console.error("Error opening file: ", error)
        }
        console.log("Image details: ", imageDetails);
        if (imageDetails['Promptus v1.0']) {
            setPromptinalPrompts(imageDetails['Promptus v1.0']);
        } else {
            setWholePrompt(imageDetails, false, true);
        }
    };

    const setPromptinalPrompts = (promptinal) => {
        let includeImages = false;
        let notFound = true;
        if (promptinal.generate.prompt) {
            setSubmitPrompt(promptinal.generate.prompt);
        }
        setSeed(promptinal.generate.seed);
        setNegativeKeywords(promptinal.generate.negative_prompt);
        setSelectedLora(promptinal.generate.lora);
        setSelectedScheduler(promptinal.generate.scheduler);
        setSteps(promptinal.generate.num_inference_steps);
        setGuidance(promptinal.generate.guidance_scale);
        setImageCount(1);
        setImageWidth(promptinal.generate.width);
        setImageHeight(promptinal.generate.height);
        promptusAPIState.models.map(model => {
            console.log("Model: ", model);
            if (promptinal.generate.model == model) {
                setSelectedModel(model);
                notFound = false;
            }
        })
        if (notFound) {
            Swal.fire({
                title: "Model not found",
                text: "The model you are trying to use is not available. Please select another model.",
                icon: "error",
                timer: 1500,
                showConfirmButton: false
            }).then(() => {
                setSettingsOpen(true);
                // setSelectedModel("stable-diffusion-v1-5");
            });
        }
        if (prompt.prompt.params.tile == "0" || prompt.prompt.params.tile.toLowercase() == "false" || prompt.prompt.params.tile == false || prompt.prompt.params.tile == "" || prompt.prompt.params.tile == "n/p") {
            setTile(false);
        } else {
            setTile(true);
        }
        if (prompt.prompt.params.shuffle == "0" || prompt.prompt.params.shuffle.toLowercase() == "false" || prompt.prompt.params.shuffle == false || prompt.prompt.params.shuffle == "" || prompt.prompt.params.shuffle == "n/p") {
            setShuffle(false);
        } else {
            setShuffle(true);
        }
        // setUpScale(promptinal.generate.upscale);
        if (promptinal.sources.source_image && includeImages) {
            setImage(promptinal.sources.source_image);
            setControlNet(promptinal.sources.control_net);
        }
        if (promptinal.sources.mask_image) {
            // setMaskImage(promptinal.sources.mask_image); // Nice to have when functional
        }
    }

    useEffect(() => {
        if (electronBridge.isElectron) {
            const openFileListener = (e, imageData) => {
                console.log(`open file listener triggered`);
                openFile(imageData);
            };

            const openPromptinalListener = (e, promptinal) => {
                let imageDetails = JSON.parse(promptinal);
                console.log("Promptinal details: ", imageDetails['Promptus v1.0']);
                setPromptinalPrompts(imageDetails['Promptus v1.0']);
            };

            if (window.electron && window.electron.ipcRenderer) {
                window.electron.ipcRenderer.on("open-file", openFileListener);
                window.electron.ipcRenderer.on("open-promptinal", openPromptinalListener);

                return () => {
                    window.electron.ipcRenderer.removeListener("open-file", openFileListener);
                    window.electron.ipcRenderer.removeListener("open-promptinal", openPromptinalListener);
                }
            }
        }
    }, []);

    /**
     * Get the server
     * @returns {Promise<*>}
     */
    const getServer = async () => {
        return await db.settings
            .where("key")
            .equals("api_host")
            .first(setting => setting.value)
    }

    async function checkIfHostsMatch(mainHost, host) {
        const records = await db.settings
            .where("key")
            .anyOf([mainHost, host])
            .toArray();

        if (records.length === 2) {
            return records[0].value === records[1].value;
        }

        return false; // One or both keys are missing
    }

    useEffect(() => {
        // let retainedPrompt;
        // try {
        //     retainedPrompt = JSON.parse(localStorage.getItem("Generate"))
        // } catch (error) {
        //     console.error("Error fetching the saved prompt: ", error)
        // }
        // if (retainedPrompt) {
        //     setSubmitPrompt(retainedPrompt.prompt);
        //     setEnhancePrompt(retainedPrompt.enhancePrompt);
        //     setSeed(retainedPrompt.seed);
        //     setNegativeKeywords(retainedPrompt.negativeKeywords);
        //     setSteps(retainedPrompt.steps);
        //     setGuidance(retainedPrompt.guidance);
        //     setImageCount(retainedPrompt.imageCount);
        //     setImageWidth(retainedPrompt.imageWidth);
        //     setImageHeight(retainedPrompt.imageHeight);
        //     if (retainedPrompt.selectedModel && retainedPrompt.selectedModel.trim() !== '') {
        //         setSelectedModel(retainedPrompt.selectedModel);
        //     } else {
        //         // If no valid model in retained prompt, don't use retained dimensions
        //         // Let the default model's recommended settings load instead
        //         console.log('[Retained Prompt] No valid model found, will use default model dimensions');
        //         // Reset dimensions to defaults so handleRecommendedSettings can set them correctly
        //         setImageWidth(defaultPrompt.prompt.params.width);
        //         setImageHeight(defaultPrompt.prompt.params.height);
        //     }
        //     setSelectedScheduler(retainedPrompt.selectedScheduler);
        //     setTile(retainedPrompt.tile);
        //     setShuffle(retainedPrompt.shuffle);
        //     setUpScale(retainedPrompt.upscale);
        // }
        db.settings.toArray(settings => {
            settings.forEach(setting => {
                switch (setting.key) {
                    case "local_gpu":
                        setApiLocalGPU(setting.value);
                        break;
                    case "local_cpu":
                        setApiLocalCPU(setting.value);
                        break;
                    case "local_cosy":
                        setApiLocalCosy(setting.value);
                        break;
                    default:
                        // do nothing.
                        return;
                }
            });
        });

        checkIfHostsMatch(promptusAPIState.host, "local_cosy").then((matches) => {
            console.log('[Component Mount] checkIfHostsMatch result:', matches, 'host:', promptusAPIState.host);
            setCosyUI(matches)
        })

        // Log initial state
        console.log('[Component Mount] Initial state:', {
            selectedModel: defaultPrompt.prompt.params.model || getAvailableDefaultModel([], promptusAPIState.online),
            cosyUI: false, // Initial value
            promptusAPIState_host: promptusAPIState.host
        });
    }, [])

    // Clear uploaded b64data only when switching to a different model
    useEffect(() => {
        // Don't clear on initial mount
        const defaultModel = getAvailableDefaultModel(options, promptusAPIState.online);
        if (selectedModel === defaultPrompt.prompt.params.model || 
            selectedModel === defaultModel) {
            return;
        }
        
        // Clear uploaded data when model actually changes
        // This will be repopulated by handleRecommendedSettings if the model has saved images
        console.log('[IMAGE CLEAR] Clearing uploadedB64Data due to model change to:', selectedModel);
        setUploadedB64Data({});
    }, [selectedModel]);

    /**
     * Get the login method
     * @returns {Promise<*>}
     */
    const checkServer = async (localhost) => {
        if (localhost === apiLocalGPU) {
            db.settings.put({ key: 'api_host', value: apiLocalGPU })
            // promptusAPIDispatch({type: 'setHost', host: apiLocalCPU});
            return apiLocalGPU
        } else if (localhost === apiLocalCPU) {
            db.settings.put({ key: 'api_host', value: apiLocalCPU })
            // promptusAPIDispatch({type: 'setHost', host: apiLocalGPU});
            return apiLocalCPU
        }
    }

    const toggleOffline = async (checked) => {
        generateStatusDispatch({ type: 'clearError' });

        // Immediately abort any ongoing validation to allow instant offline switching
        if (validationAbortController.current) {
            validationAbortController.current.abort();
            console.log('[TOGGLE OFFLINE] Aborted ongoing validation for instant mode switch');
        }

        // Reset validation state to allow immediate model loading
        setModelInvalidCheck(false);
        setTestCheck(true);

        if (checked) {
            promptusAPIDispatch({ type: 'online' });
            setCosyUI(false);
        } else {
            // Clear current model selection to force fresh offline selection
            setSelectedModel('');
            setOptions([]);

            try {
                const count = await db.settings.where("key").equals("api_host").count();
                if (count === 0) {
                    Swal.fire({
                        title: "Save your server settings",
                        text: "Your server settings is not saved onto the app. Please do so before proceeding.",
                        icon: "error",
                        confirmButtonText: "Ok",
                        confirmButtonColor: "#FFB02E"
                    });
                    return;
                }
    
                const apihost = await getServer();
                let localhost = apihost;
    
                if (!localhost) {
                    if (apiLocalGPU) {
                        localhost = apiLocalGPU;
                    } else if (apiLocalCPU) {
                        localhost = apiLocalCPU;
                    } else {
                        localhost = apiLocalCosy;
                    }
                }
    
                if (localhost) {
                    await fetch(localhost, { mode: "no-cors" });
                    promptusAPIDispatch({ type: 'offline' });
    
                    if (localhost === apiLocalGPU) {
                        promptusAPIDispatch({ type: 'setActiveGPU', server: true });
                    } else if (localhost === apiLocalCPU) {
                        promptusAPIDispatch({ type: 'setActiveCPU', server: true });
                    } else if (localhost === apiLocalCosy) {
                        promptusAPIDispatch({ type: 'setActiveCosy', server: true });
                    }
                }
            } catch (err) {
                Swal.fire({
                    title: "Check local server",
                    text: "The local server was not found. Please open promptus manager to start the server.",
                    icon: "error",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#FFB02E",
                    showDenyButton: true,
                    denyButtonText: "Open Manager",
                    denyButtonColor: "#190A4E"
                }).then((result) => {
                    if (result.isDenied) {
                        if (electronBridge.isElectron) {
                            window.electron && window.electron.ipcRenderer && window.electron.ipcRenderer.send('open-pmanager', accountContext.accountDetails.accountNo, accountContext.accountDetails.alias, window.localStorage.getItem('longLifeAPIKey'));
                        } else {
                            const protocolUrl = `promptus-pm:/accountNo=${accountContext.accountDetails.accountNo},alias=${accountContext.accountDetails.alias},apiKey=${window.localStorage.getItem('longLifeAPIKey')}`;
                            const fallbackUrl = `https://login.promptus.ai/auto-signin?v=${accountContext.accountDetails.verificationToken}&e=${accountContext.accountDetails.emailHash}&a=${accountContext.accountDetails.accountNo}&r=/subscriptions`;
                            tryProtocolWithFallback(protocolUrl, fallbackUrl);
                        }
                    }
                });
                return; // Stop execution if server not found
            }
        }
    
        // This part now runs after awaiting the fetch
        // console.log(`[toggleOffline] Options length before random selection: ${options.length}`);
        // if (options.length > 0) {
        //     const idx = Math.floor(Math.random() * options.length);
        //     const first = options[idx].value;
        //     setSelectedModel(first);
        //     handleRecommendedSettings(first);
        // }
    };

    const help = (e) => {
        const driver = new Driver({
            onReset: () => { driverContextDispatch({ type: 'off' }); }
        });
        driverContextDispatch({ type: 'on' });
        setTimeout(() => {
            helpOverlays(e, driver);
            if (driverContext.advanced == true) {
                driver.start(9);
            }
            if (driverContext.controlNet == true) {
                driver.start(19);
            }
            if (driverContext.advanced == false && driverContext.controlNet == false) {
                driver.start();
            }
        }, 1)
    }

    const handleUpscale = (value) => {
        const newValue = Number(value);
        if (newValue === 6) {
            setUpScale(8);
        } else if (newValue >= 2) {
            setUpScale(newValue);
        } else if (newValue < 2) {
            setUpScale(0);
        }
        // Store the scale value in localStorage to persist across tab switches
        localStorage.setItem('uiScale', newValue.toString());
    }

    // Add useEffect to initialize scale from localStorage
    useEffect(() => {
        const savedScale = localStorage.getItem('uiScale');
        if (savedScale !== null) {
            handleUpscale(savedScale);
        }
    }, []);

    useEffect(() => {
        if (pix2pix || controlNet) {
            setUpScale(0);
            localStorage.setItem('uiScale', '0');
        }
    }, [controlNet, pix2pix])

    useEffect(() => {
        if (contextSubmitPrompt.length > 0) setSubmitPrompt(contextSubmitPrompt);
    });

    useEffect(() => {
        if (maskImage) {
            setPromptOutput("image-in-paint");
        }
        if (image && !maskImage) {
            setPromptOutput("image-image")
        }
    }, [maskImage, image])

    useEffect(() => {
        if (generateStatus.status === "error" && generateStatus.message === "Out of Credits") {
            Swal.fire({
                title: "Credits Error",
                html: `You are Out of Credits. Please click <a style="color:blue" href="${process.env.REACT_APP_PROMPTUS_MAIN_WEBSITE_LIVE}/payments" target="_blank" rel="noopener noreferrer">here</a> to top up.`,
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E"
            })
        }
    }, [generateStatus])

    // useEffect(() => {
    //     if (selectedModel.toLowerCase().includes("xl")) {
    //         if (selectedModel.toLowerCase().includes("turbo")) {
    //             setImageWidth(512)
    //             setImageHeight(512)
    //             setSteps(2)
    //             setGuidance(0)
    //             setSelectedScheduler("LCM")
    //         } else {
    //             setImageWidth(1024)
    //             setImageHeight(1024)
    //             setGuidance(7.5)
    //             setSteps(20)
    //             setSelectedScheduler("DPM-Solver")
    //         }
    //     } else if (selectedModel.toLowerCase().includes("cascade")) {
    //         setImageHeight(1024)
    //         setImageWidth(1024)
    //     } 
    //     else {
    //         setImageWidth(512)
    //         setImageHeight(512)
    //         setGuidance(7.5)
    //         setSteps(12)
    //         setSelectedScheduler("DPM-Solver")
    //     }
    // },[selectedModel])

    useEffect(() => {
        if (controlNet !== "") {
            setImageNets("");
        }
        setControlnetDisplay(controlNet)
        if (controlNet === 'mlsd') {
            setControlnetDisplay("Straight Lines")
        }

        if (controlNet === 'pose-to-image') {
            setControlnetDisplay("Pose to Image")
        }
    }, [controlNet])

    useEffect(() => {
        if (promptOutput !== "text-image") {
            setImageNets(promptOutput);
        }

        if (promptOutput === 'image-in-paint') {
            setImageNets("In-Paint Image")
            setSelectedModel("stable-diffusion-inpainting")
        }

        if (promptOutput === 'image-image') {
            setImageNets("Image to Image")
            if (promptusAPIState.online) {
                setSelectedModel("(AI-Horde) Stable Cascade 1.0")
            }
        }
    }, [promptOutput])


    useEffect(() => {
        (async () => {
            const settings = await db.settings.toArray();
            setSettings(settings);
        })();
        if (generateStatus.status === "loading" && submitPrompt.length === 0) {
            (async () => {
                const prompts = await db.collection.where('uid').equals(generateStatus.uid).toArray();
                if (prompts.length > 0 && prompts[0] && prompts[0].prompt) {
                    setWholePrompt(prompts[0].prompt, false, true);
                } else {
                    console.warn("No prompts found for generateStatus.uid:", generateStatus.uid);
                }
            })();
        }
    }, []);

    const setWholePrompt = async (prompt, history, includeImages = false) => {
        console.log("setWholePrompt", prompt);

        // Add validation for undefined/null prompt
        if (!prompt) {
            console.error("setWholePrompt called with undefined/null prompt");
            return;
        }

        let imageDetails;
        let notFound = true;
        if (history) {
            setSubmitPrompt(prompt)
        } else {
            // Add validation for nested prompt structure
            if (!prompt.prompt) {
                console.error("Invalid prompt structure - missing prompt.prompt");
                return;
            }

            if (typeof (prompt.prompt.prompt) === "string") {
                imageDetails = prompt.prompt;
            } else if (typeof (prompt.prompt.prompt) === "object") {
                imageDetails = prompt.prompt.prompt;
            } else {
                console.error("Invalid prompt structure - prompt.prompt.prompt is neither string nor object");
                return;
            }

            // Validate imageDetails before using it
            if (!imageDetails || !imageDetails.prompt) {
                console.error("Invalid imageDetails structure");
                return;
            }

            setSubmitPrompt(imageDetails.prompt);

            // Set negative keywords if available
            if (imageDetails.negative_prompt !== undefined) {
                setNegativeKeywords(imageDetails.negative_prompt);
            }

            // Validate params object exists before accessing its properties
            if (imageDetails.params) {
                if (imageDetails.params.lora !== undefined) setSelectedLora(imageDetails.params.lora);
                if (imageDetails.params.scheduler !== undefined) setSelectedScheduler(imageDetails.params.scheduler);
                if (imageDetails.params.num_inference_steps !== undefined) setSteps(imageDetails.params.num_inference_steps);
                if (imageDetails.params.guidance_scale !== undefined) setGuidance(imageDetails.params.guidance_scale);
                if (imageDetails.params.count !== undefined) setImageCount(imageDetails.params.count);
                if (imageDetails.params.width !== undefined) setImageWidth(imageDetails.params.width);
                if (imageDetails.params.height !== undefined) setImageHeight(imageDetails.params.height);
            } else {
                console.warn("imageDetails.params is undefined, skipping parameter updates");
            }
            // Check model if params exists
            if (imageDetails.params && imageDetails.params.model) {
                await fetchModels()
                    .then(() => {
                        const matchedModel = options?.find(opt => opt.value === imageDetails.params.model);
                        if (matchedModel) {
                            setSelectedModel(matchedModel.value);
                            notFound = false;
                        }
                        // promptusAPIState.models.map(model => {
                        //     if (imageDetails.params.model == model) {
                        //         setSelectedModel(model);
                        //         notFound = false;
                        //     }
                        // })
                    })
            }
            if (notFound) {
                Swal.fire({
                    title: "Model not found",
                    text: "The model you are trying to use is not available. Please select another model.",
                    icon: "error",
                    timer: 1500,
                    showConfirmButton: false
                }).then(() => {
                    setSettingsOpen(true);
                    setSelectedModel(getAvailableDefaultModel(options, promptusAPIState.online));
                });
            }
            // Validate params object exists before accessing tile and shuffle properties
            if (imageDetails.params) {
                const tileValue = imageDetails.params.tile;
                if (typeof tileValue === 'number') {
                    setTile(false);
                } else if (tileValue == "0" || (tileValue && tileValue.toLowerCase && tileValue.toLowerCase() == "false") || tileValue == false || tileValue == "" || tileValue == "n/p") {
                    setTile(false);
                } else {
                    setTile(true);
                }

                const shuffleValue = imageDetails.params.shuffle;
                if (typeof shuffleValue === 'number') {
                    setShuffle(false);
                } else if (shuffleValue == "0" || (shuffleValue && shuffleValue.toLowerCase && shuffleValue.toLowerCase() == "false") || shuffleValue == false || shuffleValue == "" || shuffleValue == "n/p") {
                    setShuffle(false);
                } else {
                    setShuffle(true);
                }
                // setUpScale(imageDetails.params.upscale);
                if (imageDetails.params.input_image && includeImages) {
                    setImage(imageDetails.params.input_image);
                    setControlNet(imageDetails.params.control_net);
                }
                if (imageDetails.params.mask_image) {
                    // setMaskImage(imageDetails.params.mask_image); // Nice to have when functional
                }
            } else {
                console.warn("imageDetails.params is undefined, skipping tile/shuffle/image updates");
            }
        }
    };

    const setSeedPrompt = (prompt, seed) => {
        setSubmitPrompt(prompt);
        setSeed(seed);
    }

    const handleAdvancedSettings = async () => {
        setSettingsOpen(!settingsOpen)

        if (!cosyUI) {
            fetchModels()
        }

        if (promptusAPIState.host == apiLocalCosy) {
            setCosyUI(true)
        }

        // Check if models are still loading
        if (modelsLoading) {
            console.log('[handleAdvancedSettings] Models are still loading, please wait...');
            return;
        }

        // If opening advanced settings and we have a selected model, ensure its data is loaded
        if (!settingsOpen && selectedModel) {
            console.log('[handleAdvancedSettings] Opening settings with model:', selectedModel);
            console.log('[handleAdvancedSettings] Last loaded model data:', loadedModelData);
            console.log('[handleAdvancedSettings] Current dynamic_inputs:', dynamic_inputs);
            console.log('[handleAdvancedSettings] Models loading status:', modelsLoading);
            console.log('[handleAdvancedSettings] Options count:', options.length);

            // Debug: Check what's in IndexedDB
            try {
                const cosyflowCount = await db.cosyflows.count();
                console.log('[handleAdvancedSettings] Total cosyflows in IndexedDB:', cosyflowCount);

                const allCosyflows = await db.cosyflows.toArray();
                console.log('[handleAdvancedSettings] Cosyflow titles in IndexedDB:');
                allCosyflows.forEach((record, index) => {
                    if (record.data && record.data.title) {
                        console.log(`  ${index}: "${record.data.title}"`);
                    }
                });
            } catch (e) {
                console.error('[handleAdvancedSettings] Error checking IndexedDB:', e);
            }

            // Check if dynamic_inputs still has default values (indicating data hasn't been loaded)
            const hasDefaultValues =
                dynamic_inputs.imageWidth === default_values.imageWidth &&
                dynamic_inputs.imageHeight === default_values.imageHeight &&
                dynamic_inputs.steps === default_values.steps &&
                dynamic_inputs.guidance === default_values.guidance;

            // Check if we need to load data for this model
            if (loadedModelData !== selectedModel || hasDefaultValues) {
                console.log('[handleAdvancedSettings] Model data not loaded or has default values - loading now');
                console.log('[handleAdvancedSettings] loadedModelData:', loadedModelData, 'hasDefaultValues:', hasDefaultValues);
                await handleRecommendedSettings(selectedModel);
            } else {
                console.log('[handleAdvancedSettings] Model data already loaded with non-default values');
            }
        }

        if (settingsOpen === false) {
            driverContextDispatch({ type: 'advanced' });
        }
        if (settingsOpen === true) {
            driverContextDispatch({ type: 'reset' });
        }
    }

    useEffect(() => {
        let { uid } = generateStatus;

        if (props.uid && !uid) {
            uid = props.uid;
        }
        if (uid) {
            (async () => {
                const promptDetails = await db.collection.where("uid").equals(uid).first();
                console.log("Prompt Details From Prompt Click:", promptDetails);
                if (promptDetails && promptDetails.prompt) {
                    if (promptDetails.prompt.prompt && promptDetails.prompt.prompt.prompt) {
                        setSubmitPrompt(promptDetails.prompt.prompt.prompt);
                    }
                    setWholePrompt(promptDetails.prompt, false);
                } else {
                    console.warn("No prompt details found for uid:", uid);
                }
            })();
        }
    }, [props.uid, generateStatus.uid])

    const toFileUrl = (filePath) => {
        return filePath;
    }

    useEffect(() => {
        if (props.prompt && props.prompt !== "") {
            db.images.where("hash").equals(props.prompt).first(imageDetails => {
                console.log("Image Details From Prompt Click:", imageDetails);
                if (imageDetails) {
                    setSubmitPrompt(imageDetails.prompt);
                    setSelectedModel(imageDetails.model || "");

                    if (imageDetails.image) {
                        (async () => await Image.load(imageDetails.image && imageDetails.image.includes(":\\") ? toFileUrl(imageDetails.image) : `data:image/png;base64,${imageDetails.image}`).then((image) => {
                            setImageWidth(Number(image.width));
                            setImageHeight(Number(image.height));
                        }).catch(err => console.error("Error loading image:", err)))();
                    }
                }
            });
        }
    }, [props.prompt])

    useEffect(() => {
        if (props.seed) {
            setSeed(props.seed);
        }
    }, [props.seed]);

    // Handle collection image (keeping this for backward compatibility with collection context)
    useEffect(() => {
        if (collectionContext.collectionImage) {
            console.log("Setting image from collectionContext:", collectionContext.collectionImage);

            // Extract the image data
            let imageData = null;
            if (typeof collectionContext.collectionImage === 'string') {
                imageData = collectionContext.collectionImage;
            } else if (collectionContext.collectionImage.image && typeof collectionContext.collectionImage.image === 'string') {
                imageData = collectionContext.collectionImage.image;
            } else {
                console.log("Unknown collectionImage format:", collectionContext.collectionImage);
            }

            if (imageData) {
                // Set to old state for backward compatibility
                setImage(imageData);

                // Use a small delay to ensure form is ready
                setTimeout(() => {
                    // Also integrate with dynamic inputs system
                    const currentSchema = promptMappings;
                    let imageFieldKey = null;
                    
                    // Look for fields that accept images in the schema
                    for (const [key, field] of Object.entries(currentSchema || {})) {
                        if (field.type === 'file' || field.type === 'b64' || 
                            field.type === 'b64data' || field.type === 'image' || 
                            field.type === 'IMAGE' ||
                            (field.accept && field.accept.includes('image'))) {
                            imageFieldKey = key;
                            console.log(`[IMAGE INTEGRATION] Found image field in schema: ${key}`);
                            break;
                        }
                    }
                    
                    if (imageFieldKey) {
                        // Set the image data to the dynamic inputs
                        setUploadedB64Data(prev => ({
                            ...prev,
                            [imageFieldKey]: imageData
                        }));
                        
                        // Update the form if it's available
                        if (inputGroupRef.current && inputGroupRef.current.setValue) {
                            inputGroupRef.current.setValue(imageFieldKey, imageData);
                            console.log(`[IMAGE INTEGRATION] Set collection image to dynamic field: ${imageFieldKey}`);
                        }
                        
                        // Open settings to show the image was loaded
                        setSettingsOpen(true);
                    } else {
                        console.log('[IMAGE INTEGRATION] No image field found in current schema, keeping in old system');
                    }
                }, 100);
            }
        }
    }, [collectionContext.collectionImage, promptMappings]);

    // useEffect(() => {
    //     if (inputTag !== "") {
    //         setTag("")
    //     }

    //     if (tag !== "") {
    //         setInputTag("")
    //     }
    // },[tag, inputTag])

    // THIS ARRAY IS FOR THE SORTING OF THE MODEL LIST WHICH DETERMINES THE ORDER OF THE MODEL BEING DISPLAYED ACCORDING TO THIS ARRAY FROM TOP TO BOTTOM
    // SO IF ANYTHING IS ADDED OR REMOVED KEEP IN MIND THE ORDER OF THE ARRAY VALUES IS THE ORDER OF THE MODEL LIST
    const sortingRules = [
        {
            name: "No Prefix",
            match: (item) => !item.startsWith('('), // No (cosy) or (AI-Horde)
        },
        {
            name: "Stable Diffusion",
            match: (item) => item.toLowerCase().includes('stable_diffusion'),
        },
        {
            name: "Contains 'stable cascade'",
            match: (item) => item.toLowerCase().includes('stable cascade'),
        },
        {
            name: "Contains 'flux'",
            match: (item) => item.toLowerCase().includes('flux'),
        },
        {
            name: "Default",
            match: (item) => true, // Anything else
        }
    ];

    // THIS SORT FUNCTION USES THE ABOVE ARRAY TO SORT THE MODELS IN ITS ORDER
    function customSort(arr) {
        const grouped = sortingRules.map(() => []); // one array per rule

        arr.forEach((item) => {
            for (let i = 0; i < sortingRules.length; i++) {
                if (sortingRules[i].match(item)) {
                    grouped[i].push(item);
                    break;
                }
            }
        });

        // Flatten groups
        return grouped.flat();
    }

    /**
     * Validates models for disallowed data types using IndexedDB (optimized - no API calls)
     * @param {Array} models - Array of model names to validate
     * @param {Object} promptusAPIState - API state for online/offline checking
     * @returns {Object} { validModels: Array, invalidModels: Array, cached: boolean }
     */
    const validateModelsForDisallowedTypes = async (models, promptusAPIState) => {
        // Skip validation if offline
        if (!promptusAPIState.online) {
            return { validModels: models, invalidModels: [], cached: false };
        }

        const startTime = performance.now();
        console.log(`[MODEL VALIDATION - OPTIMIZED] Starting IndexedDB validation for ${models.length} models`);

        const ALLOWED_TYPES = [
            'FLOAT', 'INT', 'BOOLEAN', 'number', 'boolean',
            'BOOL', 'bool', 'seed', 'STRING', 'prompt',
            'text', 'enum', 'COMBO', 'b64data', 'IMAGE', 'model'
        ];

        // Check cache first
        const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours
        const now = Date.now();

        try {
            // Get cached validation results
            const cachedResults = await db.settings.get({ key: 'model_validation_cache' });
            if (cachedResults && cachedResults.value) {
                const cache = JSON.parse(cachedResults.value);
                if (cache.timestamp && (now - cache.timestamp) < CACHE_DURATION) {
                    // Check if model list has changed
                    const cachedModelSet = new Set(cache.validModels || []);
                    const currentModelSet = new Set(models);

                    // Check for any differences in model lists
                    const hasChanges = models.length !== (cache.validModels?.length || 0) ||
                        models.some(m => !cachedModelSet.has(m)) ||
                        (cache.validModels?.some(m => !currentModelSet.has(m)) || false);

                    if (hasChanges) {
                        console.log('[MODEL VALIDATION - OPTIMIZED] Model list changed, invalidating cache');
                        console.log('[MODEL VALIDATION - OPTIMIZED] Current models:', models.length, 'Cached models:', cache.validModels?.length || 0);
                        // Continue with fresh validation - don't return here
                    } else {
                        console.log('[MODEL VALIDATION - OPTIMIZED] Using cached validation results. Cached Invalid Models:', cache.invalidModels);
                        return {
                            validModels: cache.validModels || [],
                            invalidModels: cache.invalidModels || [],
                            cached: true
                        };
                    }
                }
            }
        } catch (error) {
            console.warn('[MODEL VALIDATION - OPTIMIZED] Error reading cache:', error);
        }

        // Perform validation using IndexedDB (no API calls)
        const validModels = [];
        const invalidModels = [];

        for (const model of models) {
            try {
                // Direct IndexedDB lookup - O(log n) performance
                const modelData = await db.cosyflows.where('data.title').equals(model).first();

                if (modelData?.data?.variables) {
                    let isValid = true;

                    // Check for disallowed types using same logic as before
                    for (const [key, variable] of Object.entries(modelData.data.variables)) {
                        if (variable.type && !ALLOWED_TYPES.includes(variable.type)) {
                            console.log(`[MODEL VALIDATION - OPTIMIZED] Model "${model}" has disallowed type: ${variable.type} in variable "${key}"`);
                            invalidModels.push({ model, reason: `Disallowed type: ${variable.type}` });
                            isValid = false;
                            break;
                        }
                    }

                    if (isValid) {
                        validModels.push(model);
                    }
                } else {
                    // No workflow data found in IndexedDB, assume valid (fallback behavior)
                    validModels.push(model);
                }
            } catch (error) {
                console.warn(`[MODEL VALIDATION - OPTIMIZED] Error checking model ${model}:`, error);
                validModels.push(model); // Assume valid on error
            }
        }

        const endTime = performance.now();

        console.log(`[MODEL VALIDATION - OPTIMIZED] Completed in ${(endTime - startTime).toFixed(2)}ms`);
        console.log(`[MODEL VALIDATION - OPTIMIZED] Valid: ${validModels.length}, Invalid: ${invalidModels.length}`);

        if (invalidModels.length > 0) {
            console.log('[MODEL VALIDATION - OPTIMIZED] Invalid models:', invalidModels);
        }

        // Cache the results
        try {
            const cacheData = {
                timestamp: now,
                validModels: validModels,
                invalidModels: invalidModels.map(item => item.model)
            };
            await db.settings.put({
                key: 'model_validation_cache',
                value: JSON.stringify(cacheData)
            });
            console.log('[MODEL VALIDATION - OPTIMIZED] Results cached successfully');
        } catch (error) {
            console.warn('[MODEL VALIDATION - OPTIMIZED] Error caching results:', error);
        }

        return { validModels: validModels, invalidModels, cached: false };
    };

    const fetchModels = async () => {
        console.log("IUBBIUOBYIUVITRUIRTICCRITICTRCRUI:  ", cosyUI);
        setModelsLoading(true);

        await getModels(promptusAPIState, generateStatusDispatch)
            .then(async data => {
                console.log("Retrieved models data:", data); // Add this log
                
                let models = data.models;
                let filters = [];

                let setting = await db.settings.get({ key: 'use_aihorde_models' });
                console.log("use_aihorde_models setting:", setting);
                // if (setting) filters.push("Dall-e");

                setting = await db.settings.get({ key: 'use_openai_models' });
                console.log("use_openai_models setting:", setting);
                //if (setting) filters.push("(SH)");

                console.log("Filters array:", filters);
                console.log("Models pre filter", models);

                if (filters.length > 0) {
                    try {
                        models = models.filter(model => {
                            console.log("Filtering model:", model); // Log each model being filtered
                            const includesFilter = filters.some(filter => model.includes(filter));
                            console.log(`Model includes filter (${includesFilter}):`, model);
                            return !includesFilter;
                        });
                    } catch (error) {
                        console.error("Error during filtering:", error); // Capture any errors during filtering
                    }
                }

                console.log("Models post filter", models);

                // IMMEDIATELY show all models and set loading to false - don't wait for validation
                const sortedModels = customSort(models);
                setOptions(sortedModels.map(model => ({ value: model, label: model })));
                promptusAPIDispatch({type: 'setModels', models: models});
                setModelsLoading(false);

                if (testCheck) {
                    const idx = Math.floor(Math.random() * sortedModels.length);
                    console.log(`[RANDOM MODEL SELECT] sortedModels: `, sortedModels, ` Randomly selected model: ${sortedModels[idx]}`);
                    
                    setSelectedModel(sortedModels[idx]);
                    handleRecommendedSettings(sortedModels[idx]);
                    setTestCheck(false)
                }

                // Check if validation is enabled via settings
                const validationEnabled = await db.settings.get({ key: 'model_validation_enabled' });
                const shouldValidate = validationEnabled ? validationEnabled.value !== false : true; // Default to true

                // Run optimized validation in background (non-blocking) - only if online
                if (shouldValidate && promptusAPIState.online) {
                    // Create abort controller for this validation session
                    validationAbortController.current = new AbortController();

                    // Run validation in background without blocking UI
                    (async () => {
                        try {
                            console.log('[FETCH MODELS] Starting optimized validation in background');
                            const validationResult = await validateModelsForDisallowedTypes(models, promptusAPIState);

                            // Only update UI if validation found invalid models and wasn't aborted
                            if (!validationAbortController.current?.signal.aborted && validationResult.invalidModels.length > 0) {
                                console.log(`[FETCH MODELS] Validation completed - filtering out ${validationResult.invalidModels.length} invalid models`);
                                const sortedValidModels = customSort(validationResult.validModels);
                                setOptions(sortedValidModels.map(model => ({ value: model, label: model })));
                                promptusAPIDispatch({type: 'setModels', models: validationResult.validModels});
                            } else if (validationResult.invalidModels.length === 0) {
                                console.log('[FETCH MODELS] Validation completed - all models are valid');
                            }
                        } catch (error) {
                            if (error.name !== 'AbortError') {
                                console.error('[FETCH MODELS] Validation error:', error);
                            } else {
                                console.log('[FETCH MODELS] Validation aborted for mode switch');
                            }
                        }
                    })();
                }
            })
            .catch(error => {
                console.error("Error in getModels:", error); // Add this log to catch errors
                promptusAPIDispatch({ type: 'setModels', models: [] });
                // No need to set modelInvalidCheck here since validation wasn't started
                setModelsLoading(false);
            });
    }

    useEffect(() => {
        (async () => {
            if (promptusAPIState.host) {
                if (promptusAPIState.host === apiLocalCosy) {
                    await fetchWorkflows();
                } else {
                    await fetchModels();
                    promptusAPIDispatch({ type: 'setLoras', models: [] })
                    // await getLoras(promptusAPIState, generateStatusDispatch)
                    // .then(data => {
                    //     promptusAPIDispatch({type: 'setLoras', loras: data.loras});
                    // })
                    // .catch(() => promptusAPIDispatch({type: 'setLoras', models: []}));
                }
            }
        })();
        setOnlineState(promptusAPIState.online);
        // Initialize options with an empty array if no models are available
        if (!Array.isArray(promptusAPIState.models)) {
            setOptions([]);
        }
    }, [promptusAPIState.host]);

    // Clear selectedModel if it doesn't exist in current options
    useEffect(() => {
        if (selectedModel && options.length > 0) {
            const modelExists = options.some(opt => opt.value === selectedModel);
            if (!modelExists) {
                console.log(`[Model Mismatch] Clearing selectedModel "${selectedModel}" as it doesn't exist in current options`);
                setSelectedModel('');
            }
        }
    }, [options, selectedModel]);

    useEffect(() => {
        if (
            (generateStatus.loading && settingsOpen) ||
            (generateStatus.status === 'done' && settingsOpen)
        ) {
            setSettingsOpen(false);
        }
        if (generateStatus.status === 'done') {
            setEnhancePrompt(false);
        }
        if (image && !generateStatus.loading && generateStatus.status === 'ready') {
            setSettingsOpen(true);
        }
    }, [generateStatus.loading, generateStatus.status, image]);

    // Sync options with promptusAPIState.models when they're available
    useEffect(() => {
        if (promptusAPIState.models && Array.isArray(promptusAPIState.models) && promptusAPIState.models.length > 0) {
            console.log('[Model Dropdown] Syncing options with API models');
            const sortedModels = customSort(promptusAPIState.models);
            setOptions(sortedModels.map(model => ({ value: model, label: model })));
            // If models are already available, set loading to false
            setModelsLoading(false);
        }
    }, [promptusAPIState.models]);

    // Ensure selectedModel is in options array
    useEffect(() => {
        // Check if selectedModel is valid (not empty string)
        if (selectedModel && selectedModel.trim() !== '') {
            if (options.length > 0) {
                const modelExists = options.some(opt => opt.value === selectedModel);
                if (!modelExists) {
                    console.log('[Model Dropdown] Adding selectedModel to options:', selectedModel);
                    setOptions(prevOptions => [{ value: selectedModel, label: selectedModel }, ...prevOptions]);
                }
            } else {
                // If options is empty but we have a selectedModel, add it temporarily
                console.log('[Model Dropdown] Creating temporary option for selectedModel:', selectedModel);
                setOptions([{ value: selectedModel, label: selectedModel }]);
            }
        } else if (!selectedModel || selectedModel.trim() === '') {
            // Only set default if we have options OR if we're online
            if (options.length > 0 || promptusAPIState.online) {
                console.log('[Model Dropdown] Setting to default model');
                setSelectedModel(getAvailableDefaultModel(options, promptusAPIState.online));
            } else {
                console.log('[Model Dropdown] Offline with no models - waiting for model load');
            }
        }
    }, [selectedModel, options.length, promptusAPIState.online]); // Watch options.length instead of options to avoid infinite loop

    // Force model reload when switching to offline mode or navigating to page in offline mode
    useEffect(() => {
        // Check if we just navigated to this page while in offline mode
        if (!promptusAPIState.online && options.length === 0 && !modelsLoading) {
            console.log('[OFFLINE NAVIGATION] Detected offline mode navigation - forcing model reload');
            fetchModels();
        }
    }, [promptusAPIState.online, options.length, modelsLoading]);

    // Call handleRecommendedSettings when models finish loading
    // Commented out to prevent duplicate calls to handleRecommendedSettings
    // The useEffect watching selectedModel changes already handles this
    // useEffect(() => {
    //     if (!modelsLoading && selectedModel && options.length > 0) {
    //         console.log('[Models Loaded] Models finished loading, calling handleRecommendedSettings');
    //         console.log('[Models Loaded] selectedModel:', selectedModel);
    //         console.log('[Models Loaded] options count:', options.length);

    //         // Check if the selectedModel exists in options
    //         const modelExists = options.some(opt => opt.value === selectedModel);
    //         if (modelExists) {
    //             console.log('[Models Loaded] Model exists in options, loading recommended settings');
    //             handleRecommendedSettings(selectedModel);
    //         } else {
    //             console.log('[Models Loaded] Model not found in options, skipping settings load');
    //         }
    //     }
    // }, [modelsLoading]); // Only trigger when modelsLoading changes

    const handleClearParams = () => {
        setSubmitPrompt(defaultPrompt.prompt.prompt);
        setSeed(defaultPrompt.prompt.params.seed_value);
        setNegativeKeywords(defaultPrompt.prompt.negative_prompt);
        setSteps(defaultPrompt.prompt.params.num_inference_steps);
        setGuidance(defaultPrompt.prompt.params.guidance_scale);
        setImageCount(1);
        setImageWidth(defaultPrompt.prompt.params.width);
        setImageHeight(defaultPrompt.prompt.params.height);
        setSelectedModel(
            defaultPrompt.prompt.params.model && defaultPrompt.prompt.params.model.trim() !== ''
                ? defaultPrompt.prompt.params.model
                : getAvailableDefaultModel(options, promptusAPIState.online)
        );
        setSelectedScheduler(defaultPrompt.prompt.params.scheduler);
        setTile(defaultPrompt.prompt.params.tile);
        setShuffle(defaultPrompt.prompt.params.shuffle);
        setUpScale(defaultPrompt.prompt.params.upscale_factor)
        setImage(null);
        setControlNet("");
        setMaskImage(null);
        setInPaint(false);
        setPromptOutput("text-image");
        driverContextDispatch({ type: 'advanced' });
        setImageNets("");
    }

    const handleRestoreDefaults = async () => {
        if (!selectedModel) {
            Swal.fire({
                title: "No Model Selected",
                text: "Please select a model first to restore its default values.",
                icon: "warning",
                confirmButtonText: "OK",
                confirmButtonColor: "#FFB02E"
            });
            return;
        }

        // Show loading indicator
        Swal.fire({
            title: "Restoring Defaults",
            text: "Fetching model default values...",
            icon: "info",
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // Always fetch fresh data from API
            console.log("Fetching fresh default values from API for:", selectedModel);
            let cosyflow_variables = null;
            let cosyflow_data = null;

            const apiBase = await getApiBaseUrl();
            const response = await axios.get(`${apiBase}/api/cosyflows/query?title=${encodeURIComponent(selectedModel)}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
                }
            });

            if (response.data.cosyflows && response.data.cosyflows.length > 0) {
                const cosyflow = response.data.cosyflows[0];
                if (cosyflow.cosyflow) {
                    cosyflow_data = typeof cosyflow.cosyflow === 'string'
                        ? JSON.parse(cosyflow.cosyflow)
                        : cosyflow.cosyflow;
                    cosyflow_variables = cosyflow_data.variables;
                    console.log("Successfully fetched fresh cosyflow data from API");

                    // Update IndexedDB with fresh data
                    try {
                        // Use indexed lookup for O(log n) performance
                        const existingCosyflow = await db.cosyflows.where('data.title').equals(selectedModel).first();

                        if (existingCosyflow) {
                            // Update existing record
                            await db.cosyflows.update(existingCosyflow.id, {
                                data: cosyflow_data,
                                meta: extractCosyflowMeta(cosyflow),
                                timestamp: Date.now()
                            });
                            console.log("Updated cosyflow in IndexedDB with fresh data");
                        } else {
                            // Add new record
                            await db.cosyflows.add({
                                data: cosyflow_data,
                                meta: extractCosyflowMeta(cosyflow),
                                timestamp: Date.now()
                            });
                            console.log("Added new cosyflow to IndexedDB");
                        }
                    } catch (dbError) {
                        console.error("Error updating IndexedDB:", dbError);
                        // Continue even if DB update fails
                    }
                }
            }

            if (cosyflow_variables) {
                // Extract default values from cosyflow variables
                const restoredValues = {};

                for (const [key, variable] of Object.entries(cosyflow_variables)) {
                    if (variable.default !== undefined) {
                        // Handle seed_mode specifically to ensure it's 'random'
                        if (key === 'seed_mode' && variable.default === 'fixed') {
                            restoredValues[key] = 'random';
                        } else {
                            restoredValues[key] = variable.default;
                        }
                    }
                }

                // Update dynamic_inputs state for cosyUI models
                if (cosyUI) {
                    setDynamic_Inputs(prevState => ({
                        ...prevState,
                        ...restoredValues
                    }));
                } else {
                    // For non-cosy models, update individual state variables
                    if (restoredValues.steps !== undefined) setSteps(restoredValues.steps);
                    if (restoredValues.guidance !== undefined) setGuidance(restoredValues.guidance);
                    if (restoredValues.imageWidth !== undefined) setImageWidth(restoredValues.imageWidth);
                    if (restoredValues.imageHeight !== undefined) setImageHeight(restoredValues.imageHeight);
                    if (restoredValues.imageCount !== undefined) setImageCount(restoredValues.imageCount);
                    if (restoredValues.negativeKeywords !== undefined) setNegativeKeywords(restoredValues.negativeKeywords);
                    if (restoredValues.scheduler !== undefined) setSelectedScheduler(restoredValues.scheduler);

                    // Handle seed based on seed_mode
                    if (restoredValues.seed_mode === 'random' || restoredValues.seed_mode === undefined) {
                        setSeed("");
                    } else if (restoredValues.seed !== undefined) {
                        setSeed(restoredValues.seed);
                    }
                }

                // Success message
                Swal.fire({
                    title: "Defaults Restored",
                    text: `Default values for ${selectedModel} have been restored successfully.`,
                    icon: "success",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#FFB02E",
                    timer: 2000,
                    timerProgressBar: true
                });

                console.log("Restored default values:", restoredValues);
            } else {
                throw new Error("No default values found for this model");
            }
        } catch (error) {
            console.error("Error restoring defaults:", error);
            Swal.fire({
                title: "Error",
                text: "Failed to restore default values. Please try again.",
                icon: "error",
                confirmButtonText: "OK",
                confirmButtonColor: "#FFB02E"
            });
        }
    }

    const setRevealPrompt = (prompt) => {
        console.log("setRevealPrompt", prompt);
        let notFound = true;
        let includeImages = false;

        if (prompt.prompt) {
            setSubmitPrompt(prompt.prompt);
        }
        setSeed(prompt.seed);
        setNegativeKeywords(prompt.negative_prompt);
        setSelectedLora(prompt.lora);
        setSelectedScheduler(prompt.scheduler);
        setSteps(prompt.num_inference_steps);
        setGuidance(prompt.guidance_scale);
        setImageCount(1);
        let dimensions = prompt.image_size.split("x");
        setImageWidth(dimensions[0]);
        setImageHeight(dimensions[1]);
        setSelectedModel(prompt.model);
        // promptusAPIState.models.map(model => {
        //     if (prompt.model == model) {
        //         setSelectedModel(model);
        //         notFound = false;
        //     }
        // })
        // if (notFound) {
        //     Swal.fire({
        //         title: "Model not found",
        //         text: "The model you are trying to use is not available. Please select another model.",
        //         icon: "error",
        //         timer: 1500,
        //         showConfirmButton: false
        //     }).then(() => {
        //         setSettingsOpen(true);
        //         setSelectedModel("stable-diffusion-v1-5");
        //     });
        // }

        const tileValue = prompt.params.tile;
        if (typeof tileValue === 'number') {
            setTile(false);
        } else if (tileValue == "0" || tileValue.toLowercase() == "false" || tileValue == false || tileValue == "" || tileValue == "n/p") {
            setTile(false);
        } else {
            setTile(true);
        }

        const shuffleValue = prompt.params.shuffle;
        if (typeof shuffleValue === 'number') {
            setShuffle(false);
        } else if (shuffleValue == "0" || shuffleValue.toLowercase() == "false" || shuffleValue == false || shuffleValue == "" || shuffleValue == "n/p") {
            setShuffle(false);
        } else {
            setShuffle(true);
        }

        // setUpScale(prompt.upscale);
        if (prompt.input_image && includeImages) {
            setImage(prompt.input_image);
            setControlNet(prompt.control_net);
        }
        if (prompt.mask_image) {
            // setMaskImage(prompt.mask_image); // Nice to have when functional
        }
    }

    const getCategorySetting = async () => {
        return await db.settings
            .where("key")
            .equals("category_popup")
            .first(setting => setting.value)
    }

    const checkHostbeforeGenerate = () => {
        if (promptusAPIState.host.includes("localhost")) {
            return false;
        } else if (promptusAPIState.host.includes("promptus")) {
            return true;
        }
    }

    const numberOfAttemptsRef = useRef(1);

    const handleTagModal = () => {
        setJobRequestPending(true);
        numberOfAttemptsRef.current = 1;

        if (accountContext.loggedIn) {
            getCategorySetting().then(async categoryBool => {
                if (submitPrompt) {
                    // let amount = imageCount * 5
                    // if (accountContext.accountDetails.tokens - amount < 0) {
                    //     Swal.fire({
                    //         color: "£190A4E",
                    //         title: "Not enough tokens",
                    //         text: "You do not have enough tokens for the amount of images you are trying to generate",
                    //         icon: "error",
                    //         confirmButtonText: 'OK',
                    //         confirmButtonColor: "#FFB02E"
                    //     })
                    // } else {
                    if (checkHostbeforeGenerate() == false) {
                        await isLocalServerBusy(promptusAPIState).then(async (data) => {
                            console.log("Local server busy data: ", data);
                            if (data.busy == false || data.busy == "false") {
                                if (submitPrompt.slice(-2) === "i0") {
                                    revealLocator(submitPrompt).then((response) => {
                                        console.log("response", response);
                                        setRevealPrompt(response["Promptinals v1.0"]);
                                    })
                                } else {

                                    if (categoryBool) {
                                        setOpen(true)
                                    } else {
                                        handleSubmitPrompt();
                                    }
                                }
                            }
                            if (categoryBool) {
                                setOpen(true)
                            } else {
                                handleSubmitPrompt();
                            }
                            // else {
                            //     Swal.fire({
                            //         title: "Local server is busy",
                            //         text: "Please try again later",
                            //         icon: "error",
                            //         confirmButtonText: "OK",
                            //         confirmButtonColor: "#FFB02E",
                            //     });
                            // }
                        }).catch((e) => {
                            console.error("Local server is busy error", e);
                        });
                    } else {
                        if (submitPrompt.slice(-2) === "i0") {
                            revealLocator(submitPrompt).then((response) => {
                                console.log("response", response);
                                setRevealPrompt(response["Promptinals v1.0"]);
                            })
                        } else {

                            if (categoryBool) {
                                setOpen(true)
                            } else {
                                handleSubmitPrompt();
                            }
                        }
                    }
                    // }
                } else {
                    if (cosyUI) {
                        handleSubmitPrompt();
                    } else {
                        setJobRequestPending(false);
                        Swal.fire({
                            color: "#190A4E",
                            title: "No Prompt",
                            icon: "error",
                            timer: 1500,
                            showConfirmButton: false
                        })
                    }
                }
            })
        } else {
            setJobRequestPending(false);
            Swal.fire({
                color: "#190A4E",
                title: "Please register an account before generating images here",
                icon: "error",
                confirmButtonText: 'OK',
                confirmButtonColor: "#FFB02E",
                showDenyButton: true,
                denyButtonText: "I'm already registered!",
                denyButtonColor: "#190A4E",
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/profile');
                }
                if (result.isDenied) {
                    navigate('/profile');
                }
            })
        }
    }

    const handleSubmitPrompt = async () => {
        props.pageNumber(0);
        props.setCategory("All");
        let prompt_output = promptOutput;

        let generatePrompt = {};
        // ALL models now use cosy structure
        if (!inputGroupRef.current) {
            console.error('Form not available - settings panel must be open');
            return;
        }
        // No longer need to copy from main prompt bar - using only dynamic prompt field now
        console.log('[PROMPT HANDLING] Using dynamic form prompt fields only - no main prompt bar sync needed');
        // Then get the updated values
        const cosy_prompt = inputGroupRef.current.getValues();
        console.log(`[JOB REQUEST] Getting form values for job request:`, cosy_prompt);
        console.log(`[JOB REQUEST] These values include saved data from IndexedDB plus any user changes`);

        // Flatten nested params object if it exists (React Hook Form creates nested structure for dotted field names)
        if (cosy_prompt.params && typeof cosy_prompt.params === 'object') {
            console.log('[PARAMS FIX] Found nested params object, flattening it...');
            // Extract all fields from params object
            Object.entries(cosy_prompt.params).forEach(([key, value]) => {
                cosy_prompt[`params.${key}`] = value;
                console.log(`[PARAMS FIX] Flattened params.${key} =`, value);
            });
            // Remove the nested params object
            delete cosy_prompt.params;
            console.log('[PARAMS FIX] Removed nested params object');
        }

        console.log(`[DEBUG] cosy_prompt keys:`, Object.keys(cosy_prompt));
        // Ensure cosyflow field is set to the selected model
        if (!cosy_prompt.cosyflow) {
            cosy_prompt.cosyflow = selectedModel;
            console.log(`[COSY MODEL] Added missing cosyflow field with model: ${selectedModel}`);
        }
        // Fetch cosyflow variables to check field types
        let cosyflowVariables = null;
        try {
            // Use indexed lookup for O(log n) performance
            const matchingCosyflow = await db.cosyflows.where('data.title').equals(selectedModel).first();
            if (matchingCosyflow && matchingCosyflow.data.variables) {
                cosyflowVariables = matchingCosyflow.data.variables;
            }
        } catch (error) {
            console.error('[handleSubmitPrompt] Error fetching cosyflow variables:', error);
        }

        // Generate new random seed if in random mode (only for type 'seed' fields)
        if (cosyflowVariables) {
            for (const [key, variable] of Object.entries(cosyflowVariables)) {
                // Only process fields with type 'seed'
                if (variable.type === 'seed') {
                    const modeKey = `${key}_mode`;
                    if (cosy_prompt[modeKey] === 'random' && cosy_prompt.hasOwnProperty(key)) {
                        // Check if field is named 'seed_value' - use empty string for string seeds (AI Horde/legacy models)
                        if (key === 'seed_value') {
                            cosy_prompt[key] = "";  // Empty string triggers server-side random generation for each image
                            console.log(`[handleSubmitPrompt] Set ${key} to empty string for server-side random generation`);
                        } else {
                            const newSeed = generateRandomSeed();
                            cosy_prompt[key] = newSeed;
                            console.log(`[handleSubmitPrompt] Generated new random seed for ${key}: ${newSeed}`);
                        }
                    }
                }
            }
        }
        // Build prompt object from cosyflows data
        const flatFields = {};
        Object.entries(cosy_prompt).forEach(([key, value]) => {
            // Check if we have uploaded b64data for this non-prefixed field
            if (uploadedB64Data[key]) {
                flatFields[key] = uploadedB64Data[key];
                console.log(`[PARAMS RESTRUCTURE] Using uploaded b64data for regular field ${key}`);
            } else {
                flatFields[key] = value;
            }
        });
        // Separate params-prefixed fields from regular fields
        const regularFields = {};
        const paramsFields = {};
        Object.entries(flatFields).forEach(([key, value]) => {
            if (key.startsWith('params.')) {
                // Extract the parameter name after 'params.'
                const paramName = key.substring('params.'.length);
                paramsFields[paramName] = value;
                console.log(`[PARAMS RESTRUCTURE] Moving ${key} to params.${paramName}`);
            } else if (key !== 'params') {
                regularFields[key] = value;
            }
        });
        // Build the prompt object with proper structure (without model/cosyflow at this level)
        const promptObject = {
            ...regularFields,  // Spread only non-param fields
            // "count": cosy_prompt.batch_size || cosy_prompt.imageCount || cosy_prompt.count || 1
            "count": cosy_prompt.batch_size || cosy_prompt.imageCount || cosy_prompt.count || cosy_prompt["params.count"] || 1

        };
        // console.log("ghme",cosy_prompt.params.count)
        // Add params object if there are any params fields
        if (Object.keys(paramsFields).length > 0) {
            promptObject.params = paramsFields;
            console.log(`[PARAMS RESTRUCTURE] Created params object with ${Object.keys(paramsFields).length} fields:`, paramsFields);
        }
        // Create the final structure
        generatePrompt = {
            "prompt": promptObject
        };

        console.log(`[JOB REQUEST] Final prompt object being sent to API with saved values:`, JSON.stringify(generatePrompt, null, 2));
        // Handle special modes
        if (controlNet !== "" || pix2pix === true) {
            generatePrompt.prompt.prompt_output = "image-image";
        }
        // Add enhanced and meme prompt if needed
        if (enhancePrompt) {
            generatePrompt.prompt.enhanced = enhancePrompt;
        }
        if (memePrompt) {
            generatePrompt.prompt.meme_prompt = memePrompt;
        }
        // Not sure how this can co-exist with cosyflow dynamic inputs, where we have more freedom to express safety tolerance
        // Perhaps this is just to ask the API server to do its first-pass safety check?
        let safeMode = true;
        if (settings.find(setting => setting.key === "safe_mode")) {
            safeMode = settings.find(setting => setting.key === "safe_mode").value;
        }
        if (safeMode) {
            generatePrompt.prompt.safe_mode = safeMode;
        }

        console.log('[ALL MODELS] Final generatePrompt structure:', JSON.stringify(generatePrompt, null, 2));
        
        // Convert any seed fields to integers if they can be converted
        const convertSeedToInteger = (obj, path = '') => {
            Object.keys(obj).forEach(key => {
                const fullPath = path ? `${path}.${key}` : key;
                const value = obj[key];
                
                // Check if this field looks like a seed field
                if ((key.toLowerCase().includes('seed') || key === 'noise_seed') && value !== null && value !== undefined && value !== '') {
                    // Try to convert to integer
                    const numValue = Number(value);
                    if (!isNaN(numValue) && isFinite(numValue)) {
                        // Convert to integer (truncate decimals)
                        obj[key] = Math.floor(numValue);
                        console.log(`[SEED CONVERSION] Converted ${fullPath} from "${value}" to ${obj[key]}`);
                    } else if (typeof value === 'string' && value.trim() !== '') {
                        // If it's a non-numeric string that can't be converted, log a warning
                        console.warn(`[SEED CONVERSION] Could not convert ${fullPath} value "${value}" to integer, keeping as-is`);
                    }
                } else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                    // Recursively check nested objects
                    convertSeedToInteger(value, fullPath);
                }
            });
        };
        
        // Apply seed conversion to the entire generatePrompt object
        if (generatePrompt && generatePrompt.prompt) {
            convertSeedToInteger(generatePrompt.prompt);
        }
        
        console.log('[SEED CONVERSION] Final generatePrompt after seed conversion:', JSON.stringify(generatePrompt, null, 2));

        // Add Nano Banana prompt modification logic
        if (selectedModel && selectedModel.includes('Nano Banana')) {
            console.log('[NANO BANANA] Detected Nano Banana model, checking for prompt modification');

            if (generatePrompt && generatePrompt.prompt) {
                const prompt = generatePrompt.prompt;

                // Find the main prompt field using the same logic as validation
                const promptFields = ['positive_prompt', 'text_0', 'text', 'prompt'];
                let mainPromptField = null;
                let currentPromptText = '';

                // Find the first non-empty prompt field
                for (const fieldName of promptFields) {
                    if (fieldName in prompt && typeof prompt[fieldName] === 'string' && prompt[fieldName].trim() !== '') {
                        mainPromptField = fieldName;
                        currentPromptText = prompt[fieldName].trim();
                        console.log(`[NANO BANANA] Found main prompt field: "${fieldName}" with text: "${currentPromptText.substring(0, 50)}..."`);
                        break;
                    }
                }

                if (mainPromptField && currentPromptText) {
                    // Check if an image is present using cosyflow schema detection
                    const hasInputImage = () => {
                        if (!cosyflowVariables) {
                            console.log('[NANO BANANA] No cosyflowVariables available, falling back to hardcoded fields');
                            // Fallback to hardcoded field names if schema not available
                            const imageFields = ['input_image', 'image', 'init_image', 'image_0'];
                            for (const field of imageFields) {
                                if ((prompt[field] && prompt[field] !== '') ||
                                    (prompt.params && prompt.params[field] && prompt.params[field] !== '')) {
                                    return true;
                                }
                            }
                            return false;
                        }

                        // Use cosyflow schema to find image fields
                        for (const [fieldName, field] of Object.entries(cosyflowVariables)) {
                            if (field.type === 'b64data' || field.type === 'image' ||
                                (field.accept && field.accept.includes('image'))) {
                                console.log(`[NANO BANANA] Checking schema-defined image field: "${fieldName}"`);
                                // Check if this field has content
                                if ((prompt[fieldName] && prompt[fieldName] !== '') ||
                                    (prompt.params && prompt.params[fieldName] && prompt.params[fieldName] !== '')) {
                                    console.log(`[NANO BANANA] Found image content in field: "${fieldName}"`);
                                    return true;
                                }
                            }
                        }
                        console.log('[NANO BANANA] No image content found in any schema-defined image fields');
                        return false;
                    };

                    const imagePresent = hasInputImage();

                    // Determine the appropriate prefix
                    let prefix = '';
                    if (imagePresent) {
                        prefix = 'modify the image to ';
                        console.log('[NANO BANANA] Image detected, will use "modify the image to" prefix');
                    } else {
                        prefix = 'generate an image of ';
                        console.log('[NANO BANANA] No image detected, will use "generate an image of" prefix');
                    }

                    // Check if similar wording already exists in the prompt
                    const currentPromptLower = currentPromptText.toLowerCase();
                    const hasGenerateWording = currentPromptLower.includes('generate') && currentPromptLower.includes('image');
                    const hasModifyWording = currentPromptLower.includes('modify') && currentPromptLower.includes('image');
                    const hasCreateWording = currentPromptLower.includes('create') && currentPromptLower.includes('image');
                    const hasMakeWording = currentPromptLower.includes('make') && currentPromptLower.includes('image');

                    const hasSimilarWording = hasGenerateWording || hasModifyWording || hasCreateWording || hasMakeWording;

                    if (!hasSimilarWording) {
                        // Add the prefix to the prompt
                        const modifiedPrompt = prefix + currentPromptText;
                        prompt[mainPromptField] = modifiedPrompt;
                        console.log(`[NANO BANANA] Modified prompt from "${currentPromptText.substring(0, 30)}..." to "${modifiedPrompt.substring(0, 50)}..."`);
                    } else {
                        console.log('[NANO BANANA] Similar wording already exists in prompt, skipping modification');
                    }
                } else {
                    console.log('[NANO BANANA] No valid prompt field found, skipping modification');
                }
            }
        }

        // Check if a positive prompt has been provided
        const checkForPrompt = () => {
            if (!generatePrompt || !generatePrompt.prompt) {
                return false;
            }
            
            const prompt = generatePrompt.prompt;
            
            // Check various possible prompt field names
            const promptFields = ['positive_prompt', 'text_0', 'text', 'prompt'];
            
            let fieldFound = false;
            for (const fieldName of promptFields) {
                if (fieldName in prompt) {
                    fieldFound = true;
                    if (typeof prompt[fieldName] === 'string' && prompt[fieldName].trim() !== '') {
                        console.log(
                            `[PROMPT CHECK] Found valid prompt in field "${fieldName}": "${prompt[fieldName].substring(0, 50)}..."`
                        );
                        return true;
                    }
                }
            }
            
            // If none of the expected fields were found at all
            if (!fieldFound) {
                console.log("[PROMPT CHECK] No expected prompt fields were found.");
                return false;
            }

            // No longer checking submitPrompt - using only dynamic form fields
            
            return false;
        };
        
        // Dynamic prompt checking function that uses schema importance metadata
        const checkForPromptDynamic = () => {
            if (!generatePrompt || !generatePrompt.prompt) {
                console.log('[PROMPT CHECK DYNAMIC] No generatePrompt structure found');
                return false;
            }
            
            const prompt = generatePrompt.prompt;
            
            // Try to get the cosyflow variables which contain the importance metadata
            if (cosyflowVariables) {
                console.log('[PROMPT CHECK DYNAMIC] Using cosyflow variables to find main prompt field');
                
                // Find fields with importance: 5 (main prompt fields)
                const mainPromptFields = [];
                for (const [key, variable] of Object.entries(cosyflowVariables)) {
                    if (variable.importance === 5) {
                        mainPromptFields.push(key);
                        console.log(`[PROMPT CHECK DYNAMIC] Found field with importance 5: "${key}"`);
                    }
                }
                
                // Check if any of the main prompt fields have valid content
                for (const fieldName of mainPromptFields) {
                    if (fieldName in prompt) {
                        if (typeof prompt[fieldName] === 'string' && prompt[fieldName].trim() !== '') {
                            console.log(
                                `[PROMPT CHECK DYNAMIC] Found valid prompt in importance:5 field "${fieldName}": "${prompt[fieldName].substring(0, 50)}..."`
                            );
                            return true;
                        }
                    }
                }
                
                // If we found importance:5 fields but they're all empty
                if (mainPromptFields.length > 0) {
                    console.log(`[PROMPT CHECK DYNAMIC] Found ${mainPromptFields.length} fields with importance:5 but all are empty`);
                    
                    // No longer using submitPrompt fallback - dynamic form only
                    
                    return false;
                }
                
                console.log('[PROMPT CHECK DYNAMIC] No fields with importance:5 found in schema, falling back to original check');
            } else {
                console.log('[PROMPT CHECK DYNAMIC] No cosyflow variables available, falling back to original check');
            }
            
            // Fall back to the original hardcoded check if no schema-based field found
            return checkForPrompt();
        };
        
        // Validate that a prompt exists before proceeding
        // Try dynamic check first, which will fall back to original if needed
        if (!checkForPromptDynamic()) {
            console.warn('[PROMPT CHECK] No prompt text found in any expected field');
            Swal.fire({
                icon: 'warning',
                title: 'No Prompt Provided',
                text: 'Please enter a prompt to generate images.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#3085d6'
            });
            generateStatusDispatch({ type: 'done' });
            setJobRequestPending(false)
            return;
        }
        
        // Check if an input image is required but not provided
        const checkForInputImage = () => {
            if (!generatePrompt || !generatePrompt.prompt) {
                return true; // No prompt structure yet, skip image check
            }
            
            const prompt = generatePrompt.prompt;
            
            // Check various possible image field names (similar to prompt check)
            const imageFields = ['input_image', 'image', 'init_image', 'image_0'];
            // First check if any of these fields exist in the prompt
            let hasImageField = false;
            let emptyImageField = null;
            
            for (const fieldName of imageFields) {
                // Check if field exists in the prompt structure
                if (fieldName in prompt) {
                    console.log(`[IMAGE CHECK] FieldName "${fieldName}"`);
                    hasImageField = true;
                    // Check if it's empty
                    if (!prompt[fieldName] || prompt[fieldName] === '') {
                        console.log(`[IMAGE CHECK] Found empty image field "${fieldName}"`);
                        emptyImageField = fieldName;
                        break;
                    }
                }
                
                // Also check params.fieldName
                const paramsFieldName = `params.${fieldName}`;
                if (prompt.params && fieldName in prompt.params) {
                    hasImageField = true;
                    if (!prompt.params[fieldName] || prompt.params[fieldName] === '') {
                        console.log(`[IMAGE CHECK] Found empty image field "params.${fieldName}"`);
                        emptyImageField = paramsFieldName;
                        break;
                    }
                }
            }
            
            // If we found an image field but it's empty, return false
            if (hasImageField && emptyImageField) {
                console.warn(`[IMAGE CHECK] Required image field "${emptyImageField}" is empty`);
                return false;
            }
            
            return true; // Either no image field exists (text-to-image) or image is provided
        };
        
        // Check if a mask image is required for inpainting models
        const checkForMaskImage = () => {
            // First check if this is an inpainting model
            const isInpaintingModel = () => {
                // Check model name
                const modelLower = selectedModel ? selectedModel.toLowerCase() : '';
                if (modelLower.includes('inpaint') || modelLower.includes('in-paint')) {
                    return true;
                }
                
                // Check prompt output type
                if (promptOutput === 'image-in-paint') {
                    return true;
                }
                
                // Check cosyflow field
                if (generatePrompt && generatePrompt.prompt && generatePrompt.prompt.cosyflow) {
                    const cosyflowLower = generatePrompt.prompt.cosyflow.toLowerCase();
                    if (cosyflowLower.includes('inpaint')) {
                        return true;
                    }
                }
                
                return false;
            };
            
            // If not an inpainting model, mask is not required
            if (!isInpaintingModel()) {
                return true;
            }
            
            console.log('[MASK CHECK] Inpainting model detected, checking for mask...');
            
            if (!generatePrompt || !generatePrompt.prompt) {
                return false; // Inpainting model but no prompt structure
            }
            
            const prompt = generatePrompt.prompt;
            
            // Check various possible mask field names
            const maskFields = ['mask_image', 'mask', 'mask_0', 'inpaint_mask'];
            let hasMaskField = false;
            let emptyMaskField = null;
            
            for (const fieldName of maskFields) {
                // Check if field exists in the prompt structure
                if (fieldName in prompt) {
                    hasMaskField = true;
                    // Check if it's empty
                    if (!prompt[fieldName] || prompt[fieldName] === '') {
                        console.log(`[MASK CHECK] Found empty mask field "${fieldName}"`);
                        emptyMaskField = fieldName;
                        break;
                    } else {
                        console.log(`[MASK CHECK] Found valid mask in field "${fieldName}"`);
                        return true; // Found a valid mask
                    }
                }
                
                // Also check params.fieldName
                if (prompt.params && fieldName in prompt.params) {
                    hasMaskField = true;
                    if (!prompt.params[fieldName] || prompt.params[fieldName] === '') {
                        console.log(`[MASK CHECK] Found empty mask field "params.${fieldName}"`);
                        emptyMaskField = `params.${fieldName}`;
                        break;
                    } else {
                        console.log(`[MASK CHECK] Found valid mask in field "params.${fieldName}"`);
                        return true; // Found a valid mask
                    }
                }
            }
            
            // If we're here, it's an inpainting model but no valid mask was found
            console.warn(`[MASK CHECK] Inpainting model requires a mask but none provided`);
            return false;
        };
        
        // Validate that input image is provided if required
        if (!checkForInputImage() && !generatePrompt.prompt.cosyflow.includes('Nano Banana')) {
            console.warn('[IMAGE CHECK] Input image required but not provided');
            Swal.fire({
                icon: 'error',
                title: 'Input Image Required',
                text: 'Please provide an input image. This model requires an image to proceed.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#d33'
            });
            generateStatusDispatch({ type: 'done' });
            setJobRequestPending(false);
            return;
        }
        
        // Validate that mask image is provided for inpainting models
        // if (!checkForMaskImage()) {
        //     console.warn('[MASK CHECK] Mask image required for inpainting but not provided');
        //     Swal.fire({
        //         icon: 'error',
        //         title: 'Mask Image Required',
        //         text: 'Please provide a mask image. Inpainting models require both an input image and a mask to specify which areas to modify.',
        //         confirmButtonText: 'OK',
        //         confirmButtonColor: '#d33'
        //     });
        //     generateStatusDispatch({ type: 'done' });
        //     setJobRequestPending(false);
        //     return;
        // }

        // Ensure prompt_output field exists with the correct value
        const ensurePromptOutputField = () => {
            if (!generatePrompt || !generatePrompt.prompt) {
                return; // No prompt structure yet, skip
            }
            
            // Check if the model has a prefix and skip if it's not unprefixed or uncensored
            if (selectedModel) {
                // Check if model starts with a prefix in parentheses
                const prefixMatch = selectedModel.match(/^\(([^)]+)\)/);
                if (prefixMatch) {
                    const prefix = prefixMatch[1].toLowerCase();
                    // Only continue for uncensored prefix, skip for all other prefixes
                    if (prefix !== 'uncensored') {
                        console.log(`[PROMPT OUTPUT] Skipping prompt_output check for model with prefix: (${prefix})`);
                        return;
                    }
                }
                // If no prefix found or prefix is 'uncensored', continue with the check
                console.log('[PROMPT OUTPUT] Model has no prefix or uncensored prefix, proceeding with check');
            }
            
            const prompt = generatePrompt.prompt;
            
            // Check if prompt_output already exists - if it does, don't modify it
            if (prompt['prompt_output'] && typeof prompt['prompt_output'] === 'string' && prompt['prompt_output'].trim() !== '') {
                console.log(`[PROMPT OUTPUT] Field already exists with value: "${prompt['prompt_output']}", not modifying`);
                return;
            }
            
            // prompt_output is missing or empty, determine what it should be
            console.log('[PROMPT OUTPUT] Field is missing or empty, determining correct value...');
            
            // Helper to check if we have an input image
            const hasInputImage = () => {
                const imageFields = ['input_image', 'image', 'init_image', 'image_0'];
                for (const field of imageFields) {
                    if ((prompt[field] && prompt[field] !== '') || 
                        (prompt.params && prompt.params[field] && prompt.params[field] !== '')) {
                        return true;
                    }
                }
                return false;
            };
            
            // Helper to check if we have a mask
            const hasMask = () => {
                const maskFields = ['mask_image', 'mask', 'mask_0', 'inpaint_mask'];
                for (const field of maskFields) {
                    if ((prompt[field] && prompt[field] !== '') || 
                        (prompt.params && prompt.params[field] && prompt.params[field] !== '')) {
                        return true;
                    }
                }
                return false;
            };
            
            // Determine the correct prompt_output value
            let promptOutputValue = "text-image"; // Default
            
            if (hasInputImage() && hasMask()) {
                promptOutputValue = "image-in-paint";
                console.log('[PROMPT OUTPUT] Detected both image and mask - setting to "image-in-paint"');
            } else if (hasInputImage()) {
                promptOutputValue = "image-image";
                console.log('[PROMPT OUTPUT] Detected input image - setting to "image-image"');
            } else {
                console.log('[PROMPT OUTPUT] No input image or mask - setting to "text-image"');
            }
            
            // Set the prompt_output field
            generatePrompt.prompt["prompt_output"] = promptOutputValue;
            console.log(`[PROMPT OUTPUT] Set prompt_output to: "${promptOutputValue}"`);
        };

        // Call the function to ensure prompt_output is set correctly
        ensurePromptOutputField();
        // console.log('[LCHECKL] Final prompt object: ', generatePrompt);

        // Validate mask presence for inpainting models
        console.log('[MASK VALIDATION] Starting mask validation check...');
        const modelRequiresMask = checkIfModelRequiresMask(cosyflowVariables);
        console.log('[MASK VALIDATION] Model requires mask:', modelRequiresMask);

        if (modelRequiresMask) {
            try {
                console.log('[MASK VALIDATION] Starting validation with data:', Object.keys(cosy_prompt));
                const maskValidation = await Promise.race([
                    validateMaskPresence(cosy_prompt, cosyflowVariables),
                    new Promise((_, reject) =>
                        setTimeout(() => reject(new Error('Validation timeout')), 5000)
                    )
                ]);

                if (!maskValidation.isValid) {
                    console.log('[MASK VALIDATION] Validation failed:', maskValidation.message);
                    setJobRequestPending(false);
                    Swal.fire({
                        title: "Mask Required",
                        text: maskValidation.message,
                        icon: "error",
                        confirmButtonText: "Ok",
                        confirmButtonColor: "#FFB02E"
                    });
                    generateStatusDispatch({ type: 'ready' });
                    return; // Stop submission
                }
                console.log('[MASK VALIDATION] Validation passed');
            } catch (error) {
                console.error('[MASK VALIDATION] Error during validation:', error);
                if (error.message === 'Validation timeout') {
                    console.warn('[MASK VALIDATION] Validation timed out, proceeding without validation');
                    // Don't block submission on timeout, just log the issue
                } else {
                    setJobRequestPending(false);
                    Swal.fire({
                        title: "Validation Error",
                        text: "There was an error validating the mask. Please try again.",
                        icon: "error",
                        confirmButtonText: "Ok",
                        confirmButtonColor: "#FFB02E"
                    });
                    generateStatusDispatch({ type: 'ready' });
                    return; // Stop submission
                }
            }
        }
        console.log('[MASK VALIDATION] Mask validation complete, proceeding with submission...');

        generateStatusDispatch({ type: 'loading' });
        getServerStatus(promptusAPIState, generateStatusDispatch)
            .then((data) => {
                if (numberOfAttemptsRef.current === 1) {
                    // Seed values are now automatically saved to IndexedDB via onFieldChange in DynamicPromptForm
                    props.handleGenerate(generatePrompt, false, null);
                    numberOfAttemptsRef.current++;
                }
            });
    };

    const handleControlNetToggle = (checked, value) => {
        if (checked) {
            setControlNet(value);
        } else {
            setControlNet("");
        }
        setPix2Pix(false);
        setPromptOutput("text-image");
    }

    const addTagToImage = () => {
        console.log("add tag to image", tag, inputTag);
        if (tag !== "" && inputTag !== "") {
            let concactedString = tag + "," + inputTag;
            if (concactedString !== "") {
                console.log("concactedString", concactedString);
                generateStatusDispatch({ type: 'tagging', tag: concactedString });
            }
        } else if (tag !== "" && inputTag === "") {
            generateStatusDispatch({ type: 'tagging', tag: tag });
        } else if (tag === "" && inputTag !== "") {
            generateStatusDispatch({ type: 'tagging', tag: inputTag });
        }
        setOpen(false)
        handleSubmitPrompt()
    }

    const handleKeyDown = (e) => {
        if (openHistory) {
            if (e.key === "Escape" || e.keyCode == 27) {
                setOpenHistory(false)
            }
        }
        if (e.key === "Enter") {
            if (open) {
                addTagToImage()
            } else {
                handleTagModal()
            }
        }
    };


    const retainPrompt = () => {
        try {
            localStorage.setItem("Generate", JSON.stringify({
                prompt: submitPrompt,
                enhancePrompt: enhancePrompt,
                seed: seed,
                negativeKeywords: negativeKeywords,
                steps: steps,
                guidance: guidance,
                imageCount: imageCount,
                imageWidth: imageWidth,
                imageHeight: imageHeight,
                selectedModel: selectedModel,
                selectedScheduler: selectedScheduler,
                tile: tile,
                shuffle: shuffle,
                upscale: upscale
            }))
        } catch (error) {
            console.error("Error saving prompt: ", error)
        }
    }

    useEffect(() => {
        if (onceTime === false) {
            // retainPrompt()
            setOnceTime(true)
        } else {
            retainPrompt()
        }
    }, [submitPrompt, enhancePrompt, seed, negativeKeywords, steps, guidance, imageCount, imageWidth, imageHeight, selectedModel, selectedScheduler, tile, shuffle, upscale])


    // Function to save user changes to cosyflow values in IndexedDB
    const saveCosyflowChanges = async (fieldKey, fieldValue) => {
        // Allow saving for all models now that they all use cosyflows
        // For base64 data, only log a preview to avoid console overflow
        const isBase64 = typeof fieldValue === 'string' && fieldValue.length > 1000 && fieldValue.includes('base64');
        const logValue = isBase64 ? `[BASE64 DATA - ${fieldValue.length} chars]` : fieldValue;
        console.log('[saveCosyflowChanges] Saving field change:', { fieldKey, fieldValue: logValue, model: selectedModel });

        try {
            // Get the current cosyflow from IndexedDB using indexed lookup
            const matchingCosyflow = await db.cosyflows.where('data.title').equals(selectedModel).first();

            if (matchingCosyflow) {
                // Update the specific field's default value
                const updatedData = { ...matchingCosyflow.data };

                // Ensure variables exist
                if (!updatedData.variables) {
                    updatedData.variables = {};
                }

                // Update the field's default value
                if (updatedData.variables[fieldKey]) {
                    updatedData.variables[fieldKey] = {
                        ...updatedData.variables[fieldKey],
                        default: fieldValue
                    };
                    
                    // Log if this is an image field being saved
                    const fieldType = updatedData.variables[fieldKey].type;
                    if (fieldType === 'b64data' || fieldType === 'IMAGE' || fieldType === 'file' || fieldType === 'b64') {
                        console.log(`[saveCosyflowChanges] Saving image field ${fieldKey} with type ${fieldType}`);
                    }
                } else {
                    // If field doesn't exist in variables, create it with current promptMapping structure
                    const fieldMapping = promptMappings[fieldKey];
                    if (fieldMapping) {
                        updatedData.variables[fieldKey] = {
                            ...fieldMapping,
                            default: fieldValue
                        };
                    } else {
                        // Create a new field for b64data if no mapping exists
                        console.log(`[saveCosyflowChanges] Creating new field ${fieldKey} for b64data`);
                        updatedData.variables[fieldKey] = {
                            type: 'b64data',
                            default: fieldValue
                        };
                    }
                }

                // Update the record in IndexedDB
                await db.cosyflows.update(matchingCosyflow.id, {
                    data: updatedData,
                    timestamp: Date.now()
                });

                console.log('[saveCosyflowChanges] Successfully saved changes to IndexedDB');
                
                // Log specific success for image fields
                if (isBase64) {
                    console.log(`[saveCosyflowChanges] Successfully saved image data for field: ${fieldKey}`);
                }

                // Optional: Show save indicator
                setSaveStatus('saved');
                setTimeout(() => setSaveStatus(''), 2000);
            } else {
                console.warn('[saveCosyflowChanges] Cosyflow not found in IndexedDB for model:', selectedModel);
                console.log('[saveCosyflowChanges] Creating new cosyflow record for model:', selectedModel);

                // Create a new cosyflow record structure
                const newCosyflowData = {
                    title: selectedModel,
                    variables: {}
                };

                // Build variables from promptMappings
                Object.entries(promptMappings).forEach(([key, mapping]) => {
                    newCosyflowData.variables[key] = {
                        ...mapping,
                        default: mapping.default !== undefined ? mapping.default : null
                    };
                });

                // Set the current field's value
                if (newCosyflowData.variables[fieldKey]) {
                    newCosyflowData.variables[fieldKey].default = fieldValue;
                } else {
                    // If field doesn't exist in promptMappings, create it
                    // Check if this is b64data based on the value
                    const isB64 = typeof fieldValue === 'string' && fieldValue.length > 1000 && fieldValue.includes('base64');
                    newCosyflowData.variables[fieldKey] = {
                        type: isB64 ? 'b64data' : (typeof fieldValue === 'number' ? 'FLOAT' : 'STRING'),
                        default: fieldValue
                    };
                    
                    if (isB64) {
                        console.log(`[saveCosyflowChanges] Creating new b64data field: ${fieldKey}`);
                    }
                }

                // Add the new record to IndexedDB
                try {
                    await db.cosyflows.add({
                        data: newCosyflowData,
                        timestamp: Date.now()
                    });
                    console.log('[saveCosyflowChanges] Successfully created new cosyflow record');
                    setSaveStatus('saved');
                    setTimeout(() => setSaveStatus(''), 2000);
                } catch (error) {
                    console.error('[saveCosyflowChanges] Error creating new cosyflow record:', error);
                    setSaveStatus('error');
                    setTimeout(() => setSaveStatus(''), 2000);
                }
            }
        } catch (error) {
            console.error('[saveCosyflowChanges] Error saving changes:', error);
            setSaveStatus('error');
            setTimeout(() => setSaveStatus(''), 2000);
        }
    };

    // Debounced version of save function for better performance
    const debouncedSaveCosyflowChanges = useCallback(
        debounce((fieldKey, fieldValue) => {
            saveCosyflowChanges(fieldKey, fieldValue);
        }, 500),
        [selectedModel, promptMappings]
    );

    // Function to fetch the latest seed value from IndexedDB for the current model
    const fetchLatestSeedFromDB = async (seedFieldKey = null) => {
        try {
            console.log('[fetchLatestSeedFromDB] Starting fetch:', {
                model: selectedModel,
                seedFieldKey: seedFieldKey,
                timestamp: Date.now()
            });

            // Validate model is selected
            if (!selectedModel) {
                console.warn('[fetchLatestSeedFromDB] No model selected, returning default');
                return '0';
            }

            // Use indexed lookup for O(log n) performance instead of O(n)
            const matchingCosyflow = await db.cosyflows.where('data.title').equals(selectedModel).first();
            console.log('[fetchLatestSeedFromDB] Looking for cosyflow with model:', selectedModel);

            if (!matchingCosyflow) {
                console.log('[fetchLatestSeedFromDB] No cosyflow found for model:', selectedModel);
                return '0';
            }

            if (!matchingCosyflow.data.variables) {
                console.log('[fetchLatestSeedFromDB] No variables found in cosyflow data');
                return '0';
            }

            // If specific seed field key is provided, look for that first
            if (seedFieldKey && matchingCosyflow.data.variables[seedFieldKey]) {
                const seedValue = String(matchingCosyflow.data.variables[seedFieldKey].default || '0');
                console.log(`[fetchLatestSeedFromDB] Found specific seed field '${seedFieldKey}' with value:`, seedValue);
                return seedValue;
            }

            // Otherwise, find any seed field
            const seedFields = [];
            for (const [key, variable] of Object.entries(matchingCosyflow.data.variables)) {
                if (key.toLowerCase().includes('seed') && !key.endsWith('_mode')) {
                    seedFields.push({ key, value: variable.default });
                }
            }

            console.log('[fetchLatestSeedFromDB] Found seed fields:', seedFields);

            if (seedFields.length > 0) {
                // If seedFieldKey was provided but not found, log a warning
                if (seedFieldKey) {
                    console.warn(`[fetchLatestSeedFromDB] Requested field '${seedFieldKey}' not found, using first seed field`);
                }
                const seedValue = String(seedFields[0].value || '0');
                console.log(`[fetchLatestSeedFromDB] Using seed field '${seedFields[0].key}' with value:`, seedValue);
                return seedValue;
            }

            console.log('[fetchLatestSeedFromDB] No seed fields found in variables');
            return '0';
        } catch (error) {
            console.error('[fetchLatestSeedFromDB] Error fetching seed:', error);
            return '0';
        }
    };

    // Helper function to generate random 64-bit seed
    /* global BigInt */
    const generateRandomSeed = () => {
        // Generate a random 64-bit number using BigInt
        const randomBytes = new Uint8Array(8);
        crypto.getRandomValues(randomBytes);
        // Convert bytes to BigInt
        let randomBigInt = 0n;
        for (let i = 0; i < 8; i++) {
            randomBigInt = (randomBigInt << 8n) | BigInt(randomBytes[i]);
        }
        // Ensure positive and within 64-bit signed range (0 to 2^63-1)
        const maxInt64 = (1n << 63n) - 1n;
        randomBigInt = randomBigInt & maxInt64;
        return randomBigInt.toString();
    };

    const handleRecommendedSettings = async (model = selectedModel) => {
        // Start performance tracking
        const startTime = performance.now();
        const timings = {};
        
        //console.log(db.table('recommendedSettings').schema.indexes)
        //console.log(typeof selectedModel)
        console.log("MODEL: ", model + " | SELECTED WORKFLOW: " + selectedWorkflow);
        console.log('[PromptHeader] handleRecommendedSettings called for model:', model);
        console.log('🔴 [CRITICAL] handleRecommendedSettings EXECUTING - model:', model);
        console.log(`[TIMING] Function started at: ${new Date().toISOString()}`);

        // Only update selectedModel if it's actually changing
        if (model !== selectedModel) {
            console.log('[PromptHeader] Updating selectedModel from:', selectedModel, 'to:', model);
            setSelectedModel(model);
        } else {
            console.log('[PromptHeader] selectedModel is already:', model, '- not updating');
        }

        let cosyflow_variables = null;

        // ALL models now use cosyflows, not just (cosy) models
        console.log("FETCH COSY UI TRUE");
        setLogLoading(true);

        // Wrap entire cosyflow loading in try-catch for better error handling
        try {
            const cosyflowStartTime = performance.now();
            console.log("[Cosyflow] Starting cosyflow loading process for model:", model);

            // First, try to get cosyflow from IndexedDB
            try {
                const dbFetchStartTime = performance.now();
                console.log("[Cosyflow Debug] Looking for model:", model);

                // Define normalizeString function for use throughout the matching logic
                const normalizeString = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');

                // Declare cosyflowRecords variable in proper scope
                let cosyflowRecords = null;

                // Try exact match first using indexed lookup (O(log n))
                let matchingCosyflow = await db.cosyflows.where('data.title').equals(model).first();
                timings.dbFetchDuration = performance.now() - dbFetchStartTime;
                console.log(`[TIMING] Initial indexed lookup took: ${timings.dbFetchDuration.toFixed(2)}ms`);

                // If no exact match, fall back to full table scan for fuzzy matching
                if (!matchingCosyflow) {
                    console.log("[Cosyflow Debug] No exact match, falling back to fuzzy matching...");
                    const fallbackStartTime = performance.now();
                    cosyflowRecords = await db.cosyflows.toArray();

                    // Debug: Log all available titles
                    console.log("[Cosyflow Debug] Total cosyflows in IndexedDB:", cosyflowRecords.length);
                    console.log("[Cosyflow Debug] All available titles:");
                    cosyflowRecords.forEach((record, index) => {
                        if (record.data && record.data.title) {
                            console.log(`[Cosyflow Debug] ${index}: "${record.data.title}"`);
                        }
                    });

                    // Try case-insensitive match
                    console.log("[Cosyflow Debug] Trying case-insensitive match...");
                    matchingCosyflow = cosyflowRecords.find(record =>
                        record.data && record.data.title &&
                        record.data.title.toLowerCase() === model.toLowerCase()
                    );

                    const fallbackDuration = performance.now() - fallbackStartTime;
                    console.log(`[TIMING] Fallback fuzzy matching took: ${fallbackDuration.toFixed(2)}ms`);
                }

                // If still no match, try normalized matching (removing special characters)
                if (!matchingCosyflow && cosyflowRecords) {
                    console.log("[Cosyflow Debug] No case-insensitive match, trying normalized...");
                    const normalizedModel = normalizeString(model);

                    matchingCosyflow = cosyflowRecords.find(record => {
                        if (record.data && record.data.title) {
                            const normalizedTitle = normalizeString(record.data.title);
                            return normalizedTitle === normalizedModel;
                        }
                        return false;
                    });
                }

                // If still no match, try without parentheses content
                if (!matchingCosyflow && cosyflowRecords) {
                    console.log("[Cosyflow Debug] No normalized match, trying without parentheses...");
                    const modelWithoutParens = model.replace(/\([^)]*\)/g, '').trim();
                    const modelWithoutParensNorm = normalizeString(modelWithoutParens);

                    matchingCosyflow = cosyflowRecords.find(record => {
                        if (!record.data || !record.data.title) return false;
                        const titleWithoutParens = record.data.title.replace(/\([^)]*\)/g, '').trim();
                        const titleWithoutParensNorm = normalizeString(titleWithoutParens);
                        return titleWithoutParensNorm === modelWithoutParensNorm;
                    });

                    if (matchingCosyflow) {
                        console.log('[Cosyflow Debug] Found match without parentheses:', matchingCosyflow.data.title);
                    }
                }

                // If still no match, try partial matching for key model names
                if (!matchingCosyflow && cosyflowRecords) {
                    console.log("[Cosyflow Debug] No match without parentheses, trying partial match...");
                    // Extract key parts (e.g., "Flux.1-Schnell fp8" from "(AI-Horde) Flux.1-Schnell fp8 (Compact)")
                    const keyParts = model.match(/Flux\.?1[^()]*|SDXL[^()]*|stable[^()]*|cascade[^()]*/gi);
                    if (keyParts && keyParts.length > 0) {
                        const keyPart = normalizeString(keyParts[0]);
                        console.log('[Cosyflow Debug] Trying partial match with key part:', keyParts[0]);

                        matchingCosyflow = cosyflowRecords.find(record => {
                            if (!record.data || !record.data.title) return false;
                            const titleNorm = normalizeString(record.data.title);
                            return titleNorm.includes(keyPart);
                        });

                        if (matchingCosyflow) {
                            console.log('[Cosyflow Debug] Found partial match:', matchingCosyflow.data.title);
                        }
                    }
                }

                if (matchingCosyflow) {
                    console.log("[Cosyflow Debug] ✅ Found match in IndexedDB");
                    console.log("[Cosyflow Debug] Matched title:", matchingCosyflow.data.title);
                    console.log("Found cosyflow in IndexedDB:", matchingCosyflow);
                    let cosyflow_data = matchingCosyflow.data;
                    
                    // Helper function to validate if a default value matches the field type
                    const isValidDefaultForType = (value, type) => {
                        if (type === undefined || type === null) return true; // Can't validate without type
                        
                        switch(type) {
                            case 'BOOLEAN':
                            case 'boolean':
                            case 'BOOL':
                            case 'bool':
                                // Boolean fields should only have boolean values
                                return typeof value === 'boolean' || value === 1 || value === 0 || 
                                       value === 'true' || value === 'false' || value === true || value === false;
                            
                            case 'INT':
                            case 'number':
                                // Should be a number or numeric string, but not empty string
                                return !isNaN(value) && value !== '';
                                
                            case 'FLOAT':
                                // Should be a number or numeric string, but not empty string
                                return !isNaN(value) && value !== '';
                                
                            case 'STRING':
                            case 'prompt':
                            case 'text':
                                // Strings can be anything
                                return true;
                                
                            case 'seed':
                                // Seeds should be numeric or numeric strings (empty string allowed for seeds)
                                return !isNaN(value) || value === '';
                                
                            case 'enum':
                            case 'COMBO':    
                                // Enum values are typically strings, so accept anything
                                return true;
                                
                            case 'b64data':
                            case 'IMAGE':
                            case 'file':
                            case 'b64':
                                // File/image fields can be empty strings or base64 data
                                return true;
                                
                            default:
                                // For unknown types, accept the value
                                return true;
                        }
                    };

                    // Now check if we need to update the schema from API
                    try {
                        const schemaUpdateStartTime = performance.now();
                        console.log("[Schema Update] ========== STARTING SCHEMA UPDATE CHECK ==========");
                        console.log("[Schema Update] Checking for schema updates from API for model:", model);
                        console.log("[Schema Update] Current schema keys:", cosyflow_data.variables ? Object.keys(cosyflow_data.variables) : 'No variables');
                        // Find record matching this model
                        const record = await db.cosyflows
                            .filter(r => r.data?.title === model)
                            .first();

                        if (!record) {
                            console.warn(`[Schema Update] ⚠️ No record found for model: ${model}`);
                            return;
                        }

                        // 🔹 Capture old defaults
                        const oldDefaults = {};
                        if (record.data.variables) {
                            for (const [key, obj] of Object.entries(record.data.variables)) {
                            if (obj && typeof obj === "object" && "default" in obj) {
                                const shortKey = key.includes(".") ? key.split(".")[1] : key;
                                oldDefaults[shortKey] = obj.default;
                            }
                            }
                        }

                        const apiStartTime = performance.now();
                        const apiBase = await getApiBaseUrl();
                        const response = await axios.get(`${apiBase}/api/cosyflows/query?title=${encodeURIComponent(model)}`, {
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
                            }
                        });
                        timings.apiCallDuration = performance.now() - apiStartTime;
                        console.log(`[TIMING] API call took: ${timings.apiCallDuration.toFixed(2)}ms`);
                        
                        if (response.data.cosyflows && response.data.cosyflows.length > 0) {
                            const cosyflow = response.data.cosyflows[0];
                            if (cosyflow.cosyflow) {
                              const newCosyflowData = typeof cosyflow.cosyflow === 'string'
                                ? JSON.parse(cosyflow.cosyflow)
                                : cosyflow.cosyflow;

                              console.log("[Schema Update] Cosyflow Data", newCosyflowData);
                              console.log("[Schema Update] New schema from API keys:", newCosyflowData.variables ? Object.keys(newCosyflowData.variables) : 'No variables');
                              console.log("[Schema Update] Comparing schemas...");
                              
                              // Log differences
                              const oldKeys = cosyflow_data.variables ? Object.keys(cosyflow_data.variables) : [];
                              const newKeys = newCosyflowData.variables ? Object.keys(newCosyflowData.variables) : [];
                              const addedKeys = newKeys.filter(k => !oldKeys.includes(k));
                              const removedKeys = oldKeys.filter(k => !newKeys.includes(k));
                              
                              if (addedKeys.length > 0) console.log("[Schema Update] 🆕 Added fields:", addedKeys);
                              if (removedKeys.length > 0) console.log("[Schema Update] 🚫 Removed fields:", removedKeys);
                      
                              // 🔹 Restore defaults into newCosyflowData
                                if (newCosyflowData.variables) {
                                    console.log("[Schema Update] Checking and preserving valid user defaults from old schema...");
                                    for (const [key, obj] of Object.entries(newCosyflowData.variables)) {
                                    if (obj && typeof obj === "object" && "default" in obj) {
                                        const shortKey = key.includes(".") ? key.split(".")[1] : key;
                                        for (const [oldKey, oldDefault] of Object.entries(oldDefaults)) {
                                        if (shortKey === oldKey) {
                                            // Validate that the old default matches the new field's type
                                            if (isValidDefaultForType(oldDefault, obj.type)) {
                                                const isBoolean = ['BOOLEAN', 'boolean', 'BOOL', 'bool'].includes(obj.type);
                                                if (isBoolean) {
                                                    // For boolean fields, use the API default instead of converting old values
                                                    console.log(`[Schema Update] ✅ Using API default for boolean ${key} (type: ${obj.type}): ${obj.default} (ignoring old value: ${oldDefault})`);
                                                    // obj.default remains unchanged from API
                                                } else {
                                                    console.log(`[Schema Update] ✅ Preserving valid default for ${key} (type: ${obj.type}): ${oldDefault}`);
                                                    obj.default = oldDefault;
                                                }
                                            } else {
                                                console.log(`[Schema Update] ⚠️ Rejecting invalid default for ${key} (type: ${obj.type}): "${oldDefault}"`);
                                                console.log(`[Schema Update] Using new schema's default instead: ${obj.default}`);
                                                // Don't preserve - let the new schema's default be used
                                            }
                                            break;
                                        }
                                        }
                                    }
                                    }
                                }
                            
                                // 🔹 Save updated record
                                const updateStartTime = performance.now();
                                await db.cosyflows.update(record.id, {
                                    data: newCosyflowData,
                                    meta: extractCosyflowMeta(cosyflow),
                                    timestamp: Date.now(),
                                });
                                timings.dbUpdateDuration = performance.now() - updateStartTime;
                                console.log(`[TIMING] IndexedDB update took: ${timings.dbUpdateDuration.toFixed(2)}ms`);
                                
                                // CRITICAL FIX: Refetch the updated data instead of using old cosyflow_data
                                console.log("[Schema Update] Refetching updated cosyflow from IndexedDB...");
                                const updatedRecord = await db.cosyflows.get(record.id);
                                if (updatedRecord && updatedRecord.data) {
                                    cosyflow_data = updatedRecord.data;
                                    console.log("[Schema Update] ✅ Successfully fetched updated schema");
                                    console.log("[Schema Update] Updated schema keys:", cosyflow_data.variables ? Object.keys(cosyflow_data.variables) : 'No variables');
                                } else {
                                    console.error("[Schema Update] ⚠️ Failed to refetch updated record!");
                                }
                      
                            //   console.log(`✅ Successfully updated model: ${modelTitle}`);
                            }
                          }
                          console.log(`[Schema Update] ✅ Successfully completed schema update for model: ${model}`);
                          console.log("[Schema Update] ========== SCHEMA UPDATE COMPLETE ==========");
                          timings.schemaUpdateTotal = performance.now() - schemaUpdateStartTime;
                          console.log(`[TIMING] Total schema update took: ${timings.schemaUpdateTotal.toFixed(2)}ms`);
                        } catch (error) {
                          console.error(`[Schema Update] ❌ Failed to update model: ${model}`, error);
                          console.log("[Schema Update] ========== SCHEMA UPDATE FAILED ==========");
                        }
                    
                    console.log("[Schema Update] Final cosyflow_data being used:", cosyflow_data ? `${Object.keys(cosyflow_data).length} keys` : 'null');
                    console.log("[SAVED VALUES] Loading cosyflow values for model:", model);
                    cosyflow_variables = cosyflow_data.variables;
                    
                    
                    // If schema was updated, we need to ensure the form will re-render with new fields
                    // This is handled by the subsequent setPromptMappings and setDynamic_Inputs calls below
                } else {
                    console.log("[Cosyflow Debug] ❌ No exact match found for:", model);

                    // Debug: Check for similar titles (case-insensitive) - only if we have cosyflowRecords
                    const similarTitles = cosyflowRecords ? cosyflowRecords.filter(record => {
                        if (record.data && record.data.title) {
                            const title = record.data.title.toLowerCase();
                            const searchModel = model.toLowerCase();
                            return title.includes(searchModel) || searchModel.includes(title);
                        }
                        return false;
                    }) : [];

                    if (similarTitles.length > 0) {
                        console.log("[Cosyflow Debug] Found similar titles:");
                        similarTitles.forEach(record => {
                            console.log(`  - "${record.data.title}"`);
                        });
                    }

                    console.log("Cosyflow not found in IndexedDB, falling back to API");
                    // 2. Online API fallback
                    try {
                        if (promptusAPIState.online) {
                            const apiBase = await getApiBaseUrl();
                            const response = await axios.get(`${apiBase}/api/cosyflows/query?title=${encodeURIComponent(model)}`, {
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
                                }
                            });
                            console.log(response);

                            // Check if we got a valid response with cosyflows data
                            if (response.data.cosyflows && response.data.cosyflows.length > 0) {
                                const cosyflow = response.data.cosyflows[0];
                                if (cosyflow.cosyflow) {
                                    const cosyflow_data = typeof cosyflow.cosyflow === 'string'
                                        ? JSON.parse(cosyflow.cosyflow)
                                        : cosyflow.cosyflow;
                                    console.log("Cosyflow Data from API: " + JSON.stringify(cosyflow_data));
                                    cosyflow_variables = cosyflow_data.variables;

                                    // Store in IndexedDB for future use (will be updated with seed values later)
                                    try {
                                        await db.cosyflows.add({
                                            data: cosyflow_data,
                                            meta: extractCosyflowMeta(cosyflow),
                                            timestamp: Date.now()
                                        });
                                        console.log("Stored new cosyflow in IndexedDB for future use");
                                    } catch (storeError) {
                                        console.error("Error storing cosyflow in IndexedDB:", storeError);
                                    }
                                }
                            }
                        } else {
                            throw new Error('OFFLINE_MODE');
                        }
                    } catch (onlineApiError) {
                        console.error("Online API call failed:", onlineApiError);

                        // 3. Localhost API fallback for offline models
                        try {
                            console.log("[Cosyflow] Trying localhost API fallback...");
                            const localhostResponse = await axios.get(
                                `${promptusAPIState.host}/api/generate/get-cosyflow-variables?model=${encodeURIComponent(model)}`,
                                { timeout: 5000 }
                            );

                            if (localhostResponse.data?.variables) {
                                console.log("[Cosyflow] Found variables from localhost API:", localhostResponse.data.variables);
                                cosyflow_variables = localhostResponse.data.variables;

                                // Store in IndexedDB for future use
                                try {
                                    await db.cosyflows.add({
                                        data: { title: model, variables: cosyflow_variables },
                                        timestamp: Date.now()
                                    });
                                    console.log("[Cosyflow] Stored localhost variables in IndexedDB for future use");
                                } catch (storeError) {
                                    if (storeError.name !== 'ConstraintError') {
                                        console.error("[Cosyflow] Error storing localhost variables:", storeError);
                                    }
                                }
                            }
                        } catch (localhostError) {
                            console.error("[Cosyflow] All methods failed - IndexedDB, online API, and localhost API:", localhostError);
                        }
                    }
                }
            } catch (error) {
                console.error("Error accessing cosyflows:", error);
                // If IndexedDB fails, try API as last resort
                try {
                    const apiBase = await getApiBaseUrl();
                    const response = await axios.get(`${apiBase}/api/cosyflows/query?title=${encodeURIComponent(model)}`, {
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${process.env.REACT_APP_API_TOKEN}`
                        }
                    });
                    console.log(response);

                    if (response.data.cosyflows && response.data.cosyflows.length > 0) {
                        const cosyflow = response.data.cosyflows[0];
                        if (cosyflow.cosyflow) {
                            const cosyflow_data = typeof cosyflow.cosyflow === 'string'
                                ? JSON.parse(cosyflow.cosyflow)
                                : cosyflow.cosyflow;
                            console.log("Cosyflow Data from API (after IndexedDB error): " + JSON.stringify(cosyflow_data));
                            cosyflow_variables = cosyflow_data.variables;
                        }
                    }
                } catch (apiError) {
                    console.error("API call also failed:", apiError);

                    // 3. NEW: Localhost API fallback for offline models
                    try {
                        console.log("[Cosyflow] Trying localhost API fallback...");
                        const localhostResponse = await axios.get(
                            `${promptusAPIState.host}/api/generate/get-cosyflow-variables?model=${encodeURIComponent(model)}`,
                            { timeout: 5000 }
                        );

                        if (localhostResponse.data?.variables) {
                            console.log("[Cosyflow] Found variables from localhost API:", localhostResponse.data.variables);
                            cosyflow_variables = localhostResponse.data.variables;

                            // Store in IndexedDB for future use
                            try {
                                await db.cosyflows.add({
                                    data: { title: model, variables: cosyflow_variables },
                                    timestamp: Date.now()
                                });
                                console.log("[Cosyflow] Stored localhost variables in IndexedDB for future use");
                            } catch (storeError) {
                                if (storeError.name !== 'ConstraintError') {
                                    console.error("[Cosyflow] Error storing localhost variables:", storeError);
                                }
                            }
                        }
                    } catch (localhostError) {
                        console.error("[Cosyflow] All methods failed - IndexedDB, online API, and localhost API:", localhostError);
                    }
                }
            }

            console.log("[Cosyflow] cosyflow_variables is:", cosyflow_variables !== null ? "FOUND" : "NULL");
            console.log("[Cosyflow] About to process cosyflow_variables, value:", cosyflow_variables);

            if (cosyflow_variables !== null) {
                console.log("[Cosyflow] Processing cosyflow variables - will set cosyUI to true");
                let new_input_json = {}
                let new_prompt_mappings = {}

                console.log("Cosyflow Data: " + cosyflow_variables);
                for (const key in cosyflow_variables) {
                    if (!excludedKeys.includes(key) && !excludedTypes.includes(cosyflow_variables[key].type)) {
                        console.log(`[SAVED VALUES] Found ${key} with saved value from IndexedDB: ${cosyflow_variables[key].default}`);

                        // Check if this is a seed field (type 'seed')
                        if (cosyflow_variables[key].type === 'seed') {
                            // Always default to 'random' mode for seed fields
                            const modeKey = `${key}_mode`;

                            // Generate a new random seed value
                            const newSeedValue = generateRandomSeed();
                            new_input_json[key] = newSeedValue;
                            new_input_json[modeKey] = 'random';

                            console.log(`Generated new random seed for ${key}: ${newSeedValue}`);
                        } else if (key.endsWith('_mode')) {
                            // Skip _mode fields - they are handled with their corresponding fields
                            console.log(`Skipping ${key} - mode fields are handled separately`);
                        } else {
                            new_input_json[key] = cosyflow_variables[key].default;
                        }

                        new_prompt_mappings[key] = cosyflow_variables[key];
                    }
                }
                console.log(`Cosyflow variables: ${JSON.stringify(new_prompt_mappings)}`);
                console.log(`[SAVED VALUES] Cosyflow new_input_json with saved values: ${JSON.stringify(new_input_json)}`);

                // Restore b64data/image fields to uploadedB64Data state
                const b64DataFields = {};
                for (const [key, variable] of Object.entries(cosyflow_variables)) {
                    if (variable.type === 'b64data' || variable.type === 'IMAGE' || 
                        variable.type === 'file' || variable.type === 'b64') {
                        if (variable.default && variable.default !== '') {
                            b64DataFields[key] = variable.default;
                            console.log(`[IMAGE RESTORE] Found saved image for field ${key}, restoring to uploadedB64Data`);
                        }
                    }
                }
                
                // Set the uploaded b64 data if any images were found
                if (Object.keys(b64DataFields).length > 0) {
                    setUploadedB64Data(b64DataFields);
                    console.log(`[IMAGE RESTORE] Restored ${Object.keys(b64DataFields).length} saved image(s) to uploadedB64Data`);
                }

                // Add scheduler field from default mapping if not present in Cosy variables
                // if (!('scheduler' in new_prompt_mappings) && 'scheduler' in default_promptMapping) {
                //     new_prompt_mappings.scheduler = default_promptMapping.scheduler;
                //     new_input_json.scheduler = default_promptMapping.scheduler.default;
                //     console.log('[PromptHeader] Added scheduler to Cosy promptMappings:', {
                //         schedulerOptions: new_prompt_mappings.scheduler.options,
                //         optionsLength: new_prompt_mappings.scheduler.options?.length,
                //         defaultValue: new_input_json.scheduler
                //     });
                // }

                console.log('[DynamicPromptForm Props] ========== SETTING FORM PROPS ==========' );
                console.log('[DynamicPromptForm Props] Setting Cosy promptMappings:', {
                    hasScheduler: 'scheduler' in new_prompt_mappings,
                    schedulerOptions: new_prompt_mappings.scheduler?.options,
                    allKeys: Object.keys(new_prompt_mappings),
                    totalFields: Object.keys(new_prompt_mappings).length
                });
                console.log('[DynamicPromptForm Props] Schema being passed to form:', new_prompt_mappings);
                setPromptMappings(new_prompt_mappings)

                new_input_json.cosyflow = model
                // new_input_json.text1 = ""
                console.log(`NInput JSON: ${JSON.stringify(new_input_json)}`);
                setInput_json(new_input_json)
                setDynamic_Inputs(new_input_json)
                
                // Log to verify state updates will trigger re-render
                console.log('[DynamicPromptForm Props] State updates complete. Form should re-render with:', {
                    schemaFieldCount: Object.keys(new_prompt_mappings).length,
                    initialValuesCount: Object.keys(new_input_json).length,
                    timestamp: Date.now()
                });
                console.log(`Input JSON: ${JSON.stringify(input_json)}`);
                console.log(`[DEBUG] Setting dynamic_inputs with seed_mode:`, new_input_json.seed_mode || 'NOT SET');
                setSelectedWorkflow(model)

                // Force form to reset with the loaded saved values
                // Use a small delay to ensure form is ready
                setTimeout(() => {
                    if (inputGroupRef.current && inputGroupRef.current.resetForm) {
                        console.log("[SAVED VALUES] Resetting form with saved values from IndexedDB:", new_input_json);
                        inputGroupRef.current.resetForm(new_input_json);
                    }
                }, 100);

                setOnlineCosyUI(true)
                setCosyUI(true)
                setSelectedWorkflow(model)

                // Save the updated cosyflow with generated seed values back to IndexedDB
                try {
                    // Use indexed lookup for O(log n) performance
                    const matchingCosyflow = await db.cosyflows.where('data.title').equals(model).first();

                    if (matchingCosyflow) {
                        // Update the cosyflow with new seed values
                        const updatedData = { ...matchingCosyflow.data };

                        // Update variables with generated values
                        for (const key in new_input_json) {
                            if (updatedData.variables && updatedData.variables[key]) {
                                updatedData.variables[key].default = new_input_json[key];
                            }
                        }

                        // Update the record in IndexedDB
                        await db.cosyflows.update(matchingCosyflow.id, {
                            data: updatedData,
                            timestamp: Date.now()
                        });

                        console.log("Updated cosyflow in IndexedDB with generated seed values");

                        // Force form to reset with the updated values including new seeds
                        // Use a small delay to ensure form is ready
                        setTimeout(() => {
                            if (inputGroupRef.current && inputGroupRef.current.resetForm) {
                                console.log("[SAVED VALUES] Resetting form after updating seed values:", new_input_json);
                                inputGroupRef.current.resetForm(new_input_json);
                            }
                        }, 100);
                    }
                } catch (updateError) {
                    console.error("Error updating cosyflow with seed values:", updateError);
                }

                // Mark that we successfully loaded data for this model
                setLoadedModelData(model);
                console.log('[handleRecommendedSettings] Successfully loaded cosyflow data for model:', model);
            } else {
                console.log("[Cosyflow] ⚠️ ENTERING DEFAULT BRANCH - No cosyflow variables found for the model:", model);
                console.log("[Cosyflow] Creating default cosyflow record - will set cosyUI to true");
                console.log("Creating default cosyflow record for non-API model:", model);
                console.log("[Cosyflow] Current UI states - cosyUI:", cosyUI, "onlineCosyUI:", onlineCosyUI);

                // Create a default cosyflow record for models without API data
                const defaultCosyflowData = {
                    title: model,
                    variables: {}
                };

                // Use promptMappings to create default variables
                // Object.entries(default_promptMapping).forEach(([key, mapping]) => {
                //     defaultCosyflowData.variables[key] = {
                //         ...mapping,
                //         default: mapping.default !== undefined ? mapping.default : null
                //     };
                // });

                // Store the default cosyflow in IndexedDB
                try {
                    await db.cosyflows.add({
                        data: defaultCosyflowData,
                        timestamp: Date.now()
                    });
                    console.log("Created default cosyflow record in IndexedDB for model:", model);
                } catch (storeError) {
                    console.error("Error creating default cosyflow record:", storeError);
                }

                // Set UI state to true so dynamic form is shown and values can be saved
                setOnlineCosyUI(true)
                setCosyUI(true)
                setSelectedWorkflow("")

                // Generate default inputs with random seed
                let default_inputs = {};
                // let updated_promptMapping = { ...default_promptMapping };

                // for (const key in default_promptMapping) {
                //     const mapping = default_promptMapping[key];
                //     const isSeedField = key === 'seed' || 
                //                       key === 'seed_value' || 
                //                       key.toLowerCase().includes('seed') ||
                //                       mapping.title?.toLowerCase().includes('seed');

                //     if (isSeedField) {
                //         // Generate random seed for seed fields
                //         const modeKey = `${key}_mode`;
                //         default_inputs[key] = generateRandomSeed();
                //         default_inputs[modeKey] = 'random';

                //         console.log(`Generated new random seed for ${key}: ${default_inputs[key]}`);
                //     } else {
                //         default_inputs[key] = mapping.default;
                //     }
                // }

                setInput_json(default_inputs)
                setDynamic_Inputs(default_inputs)
                // setPromptMappings(updated_promptMapping)

                // Force form to reset with the default values
                // Use a small delay to ensure form is ready
                setTimeout(() => {
                    if (inputGroupRef.current && inputGroupRef.current.resetForm) {
                        console.log("[SAVED VALUES] Resetting form with default values:", default_inputs);
                        inputGroupRef.current.resetForm(default_inputs);
                    }
                }, 100);

                // Mark that we successfully loaded data for this model (even if it's default data)
                setLoadedModelData(model);
                console.log('[handleRecommendedSettings] Successfully created default cosyflow for model:', model);
                console.log('[handleRecommendedSettings] Final dynamic_inputs after default creation:', dynamic_inputs);
                console.log('[handleRecommendedSettings] Final UI states - cosyUI:', cosyUI, 'onlineCosyUI:', onlineCosyUI);
            }

        } catch (error) {
            console.error("[Cosyflow] Fatal error in cosyflow loading:", error);
            console.error("[Cosyflow] Stack trace:", error.stack);
            // Set default values on error
            setCosyUI(false);
            setOnlineCosyUI(false);
        } finally {
            setLogLoading(false);
            
            // Calculate and log total execution time
            const totalTime = performance.now() - startTime;
            console.log('[handleRecommendedSettings] Completed processing for model:', model);
            console.log('[TIMING] ========== PERFORMANCE SUMMARY ==========');
            console.log(`[TIMING] Total execution time: ${totalTime.toFixed(2)}ms`);
            if (timings.apiCallDuration) console.log(`[TIMING]   - API call: ${timings.apiCallDuration.toFixed(2)}ms`);
            if (timings.dbUpdateDuration) console.log(`[TIMING]   - DB update: ${timings.dbUpdateDuration.toFixed(2)}ms`);
            if (timings.schemaUpdateTotal) console.log(`[TIMING]   - Schema update total: ${timings.schemaUpdateTotal.toFixed(2)}ms`);
            console.log('[TIMING] ========================================');
            
            // Verify what was set
            console.log('[VERIFICATION] Final state set:', {
                cosyUI: cosyUI,
                promptMappingsKeys: promptMappings ? Object.keys(promptMappings).length : 0,
                dynamicInputsKeys: dynamic_inputs ? Object.keys(dynamic_inputs).length : 0
            });
        }
    };

    const currentModelSelected = () => {
        console.log("Current model selected:", selectedModel);
        // Return the currently selected model formatted for the Select component
        if (!selectedModel) {
            return options && options.length > 0 ? options[0] : { value: "", label: "Select a model" };
        }

        // Find the option that matches the selected model
        const modelOption = options.find(opt => opt.value === selectedModel);

        // If found, return it; otherwise create a new option
        if (modelOption) {
            return modelOption;
        } else {
            return { value: selectedModel, label: selectedModel };
        }
    }

    useEffect(() => {
        if (isUndefined(promptusAPIState.models)) {
            setSelectedModel(options[0])
        }
        // else {
        //     // Don't reset the model if it's a cosy model
        //     if (!promptusAPIState.models.includes(selectedModel) && promptusAPIState.models.length > 0 && promptusAPIState.online && !selectedModel.includes("(cosy)")) {
        //         // setSelectedModel(promptusAPIState.models[0]); // Sets to the first model available if the current selectedModel is not valid
        //         setSelectedModel(getAvailableDefaultModel(options, promptusAPIState.online)); // Sets to the first model available if the current selectedModel is not valid

        //     }

        // }
    }, [promptusAPIState.models]);


    useEffect(() => {
        console.log("[UseEffect Model Change] selectedModel:", selectedModel, "type:", typeof selectedModel);
        console.log("[UseEffect Model Change] props.fetchingUndelivered:", props.fetchingUndelivered);

        if (selectedModel && selectedModel.trim() !== '') {
            console.log("[Model Change] Loading recommended settings for:", selectedModel);
            handleRecommendedSettings(selectedModel);
        } else {
            console.log("[Model Change] Skipping - selectedModel is empty or invalid");
        }
    }, [selectedModel, props.fetchingUndelivered]); // This useEffect will now trigger anytime `selectedModel` changes

    // Load default model data on component mount with a small delay to ensure IndexedDB is ready
    useEffect(() => {
        const loadInitialModelData = async () => {
            // Small delay to ensure IndexedDB is initialized
            await new Promise(resolve => setTimeout(resolve, 100));

            if (selectedModel && selectedModel.trim() !== '') {
                console.log('[Component Mount] Loading initial model data for:', selectedModel);
                await handleRecommendedSettings(selectedModel);
            }
        };

        loadInitialModelData();
    }, []); // Empty dependency array - runs once on mount

    // Handle deep link model
    const [deepLinkProcessed, setDeepLinkProcessed] = useState(false);
    const [pendingDeepLinkModel, setPendingDeepLinkModel] = useState(null);

    // Function to open advanced settings programmatically
    const openAdvancedSettingsForDeepLink = () => {
        if (!settingsOpen && !generateStatus.loading && !cosyUI) {
            // Fetch models first if needed
            fetchModels();
            // Open settings
            setSettingsOpen(true);
            // Update driver context
            driverContextDispatch({ type: 'advanced' });
        }
    };

    // Store deep link model if received before models are loaded
    useEffect(() => {
        if (deepLinkModel && !deepLinkProcessed) {
            if (options.length === 0) {
                // Models not loaded yet, store for later
                console.log("Models not loaded yet, storing deep link model for later:", deepLinkModel);
                setPendingDeepLinkModel(deepLinkModel);
                // Trigger model fetch
                fetchModels();
            } else {
                // Process immediately if models are loaded
                setPendingDeepLinkModel(null);
            }
        }
    }, [deepLinkModel]);

    // Process deep link when models are loaded
    useEffect(() => {
        // Reset processed flag when deepLinkModel is cleared
        if (!deepLinkModel && !pendingDeepLinkModel && deepLinkProcessed) {
            setDeepLinkProcessed(false);
        }

        const modelToProcess = pendingDeepLinkModel || deepLinkModel;

        if (modelToProcess && options.length > 0 && !deepLinkProcessed) {
            console.log("Deep link model received in PromptHeader:", modelToProcess);

            // Mark as processed immediately to prevent re-runs
            setDeepLinkProcessed(true);

            // Check if the model exists in the available options
            const modelExists = options.some(opt => opt.value === modelToProcess);

            if (modelExists) {
                console.log("Setting model from deep link:", modelToProcess);
                setSelectedModel(modelToProcess);

                // Open advanced settings after a short delay to ensure model is set
                setTimeout(() => {
                    openAdvancedSettingsForDeepLink();
                }, 500);

                // Show notification that model was set
                Swal.fire({
                    title: 'Model Selected',
                    text: `Model "${modelToProcess}" has been selected from deep link`,
                    icon: 'success',
                    timer: 3000,
                    showConfirmButton: false
                });
            } else {
                console.log("Deep link model not found in available models:", modelToProcess);

                // Open advanced settings to show available models
                setTimeout(() => {
                    openAdvancedSettingsForDeepLink();
                }, 500);

                // Show error notification
                Swal.fire({
                    title: 'Model Not Found',
                    text: `The model "${modelToProcess}" is not available. Using default model instead.`,
                    icon: 'warning',
                    timer: 4000,
                    showConfirmButton: true
                });
            }

            // Clear pending model after processing
            setPendingDeepLinkModel(null);
        }
    }, [deepLinkModel, pendingDeepLinkModel, options, deepLinkProcessed]);



    const setMemePromptOptions = useCallback((memePrompt) => {
        setMemePrompt(memePrompt)
        console.log("setting model")
        if (promptusAPIState.online && memePrompt) {
            setSettingsOpen(false)
            setSelectedModel("(aimlapi) FLUX.1 schnell");
        }
    }, [promptusAPIState.online, setSettingsOpen, setSelectedModel]);

    const handleEscapeKey = (e) => {
        console.log("Key pressed: ", e);

        if (e.key === "Escape") {
            setOpenHistory(false)
        }
    }

    useEffect(() => {
        if (openHistory) {
            window.addEventListener('keydown', handleEscapeKey);
        }

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleEscapeKey);
        };
    }, [openHistory]);


    const clearHistory = async () => {
        console.log("Clear History");
        await db.transaction('rw', db.history, async () => {
            await db.history.clear();
        })
            .then(() => {
                Swal.fire({
                    title: 'History Cleared Succesfully',
                    timer: 2000,
                    showConfirmButton: false
                })
                setOpenHistory(false)
            })
    }

    const fetchWorkflows = async() => {
        if (cosyUI) {
            await getCosyflows(promptusAPIState, generateStatusDispatch)
            .then(async(data) => {
                console.log("Retreived cosyflows data: ", data);
                if (data && !isUndefined(data)) {
                    const installedNodes = data.filter(cosyflow => cosyflow.install_status === 'INSTALLED');
                    setOptions(installedNodes.map(cosyflow => ({ value: cosyflow.title, label: cosyflow.title })))

                    if (testCheck) {
                        const idx = Math.floor(Math.random() * installedNodes.length);
                        console.log(`[RANDOM MODEL SELECT] installedNodes: `, installedNodes, ` Randomly selected model: ${installedNodes[idx].title}`);
                        
                        setSelectedModel(installedNodes[idx].title);
                        handleRecommendedSettings(installedNodes[idx].title);
                        setTestCheck(false)
                    }
                }
                // setOptions(data.map(cosyflow => ({ value: cosyflow.title, label: cosyflow.title })))
                // const values = data.map(cosyflow => {
                //     return cosyflow.title
                // })
                // console.log(values);
                // const morevals = values.map((workflow, index) => {
                //     return workflow
                // })
                // console.log(morevals);
                // setAllWorkflows(data.map(cosyflow => cosyflow.title))
            })
        } else {
            setAllWorkflows([])
            console.log("No cosyflows found")
        }
        // console.log("Comfy workflows: ", workflows);
        // // setAllWorkflows(workflows)
        // setAllWorkflows(workflows.map(workflow => ({ value: workflow, label: workflow })))
    }

    const excludedKeys = []
    const excludedTypes = ["model"]

    const handleWorkflow = async (cosyflowName = selectedWorkflow) => {
        console.log(`Fetching Cosyflow data for ${cosyflowName}`);
        let new_input_json = {}
        let new_prompt_mappings = {}

        await getCosyflowData(cosyflowName, promptusAPIState, generateStatusDispatch)
            .then((data) => {
                console.log("Cosyflow Data: " + JSON.stringify(data));
                for (const key in data) {
                    console.log(`Found ${key} with default value: ${data[key].default}`);
                    if (!excludedKeys.includes(key) && !excludedTypes.includes(data[key].type)) {
                        console.log(`Found ${key} with default value: ${data[key].default}`);

                        // Check if this is a seed field (type 'seed')
                        if (data[key].type === 'seed') {
                            // Always default to 'random' mode for seed fields
                            const modeKey = `${key}_mode`;

                            // Generate a new random seed value
                            const newSeedValue = generateRandomSeed();
                            new_input_json[key] = newSeedValue;
                            new_input_json[modeKey] = 'random';

                            console.log(`Generated new random seed for ${key}: ${newSeedValue}`);
                        } else if (key.endsWith('_mode')) {
                            // Skip _mode fields - they are handled separately
                            console.log(`Skipping ${key} - mode fields are handled separately`);
                        } else {
                            new_input_json[key] = data[key].default;
                        }

                        new_prompt_mappings[key] = data[key];
                    }

                }
            })
        setPromptMappings(new_prompt_mappings)

        new_input_json.cosyflow = cosyflowName
        // new_input_json.text1 = ""
        console.log(`NInput JSON: ${JSON.stringify(new_input_json)}`);
        setInput_json(new_input_json)
        setDynamic_Inputs(new_input_json)
        console.log(`Input JSON: ${JSON.stringify(input_json)}`);
        setSelectedWorkflow(cosyflowName)

        // ✅ Force form to reset to new input values
        if (inputGroupRef.current) {
            console.log("Resetting form with new_input_json:", new_input_json);
            inputGroupRef.current.resetForm(new_input_json);
        }
    }

    const handleNumChange = (e) => {
        let newValue = e.target.value;

        // Remove leading zeros but allow the user to type
        if (newValue.startsWith("0")) {
            newValue = newValue.replace(/^0+/, "") || "0"; // Keep at least "0" if all characters are removed
        }

        setImageCount(newValue);
    };

    const handleNumImages = () => {
        let numValue = parseInt(imageCount, 10); // Convert to number, removing leading zeros

        if (isNaN(numValue) || numValue <= 0) {
            numValue = 1; // Ensure the number is never less than or equal to 0
        }

        setImageCount(numValue);

    }

    const handleRemoveImage = () => {
        setImage(null);
        setControlNet("");
        setMaskImage(null);
        setInPaint(false);
        setPromptOutput("text-image");
        driverContextDispatch({ type: 'advanced' });
        setImageNets("");
    }

    const startRecording = async () => {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const mediaRecorder = new MediaRecorder(stream);

        mediaRecorder.ondataavailable = (event) => {
            audioChunksRef.current.push(event.data);
        };

        mediaRecorder.onstop = () => {
            const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
            setAudioBlob(blob);
            setAudioURL(URL.createObjectURL(blob));
            audioChunksRef.current = [];
        };

        mediaRecorder.start();
        mediaRecorderRef.current = mediaRecorder;
        setRecording(true);
    };

    const stopRecording = () => {
        console.log(`Stopping recording`);

        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            setRecording(false);

            if (!audioBlob) return;

            const reader = new FileReader();
            reader.readAsDataURL(audioBlob);
            reader.onloadend = () => {
                const base64Audio = reader.result; // you can send this to your API
                console.log("Base64 audio:", base64Audio);
            };
        }
    };

    const convertToBase64 = () => {
        if (!audioBlob) return;

        const reader = new FileReader();
        reader.readAsDataURL(audioBlob);
        reader.onloadend = () => {
            const base64Audio = reader.result; // you can send this to your API
            console.log("Base64 audio:", base64Audio);
        };
    };

    useEffect(() => {
        if (image) {
            setMaskImage(null)
        }
    }, [image])

    const location = useLocation();

    useEffect(() => {
        // Handle prompt history navigation
        if (location.state?.prompt) {
            setSubmitPrompt(location.state.prompt);
            if (location.state.seed) {
                setSeed(location.state.seed);
            }
        }
    }, [location]);

    // After the other useEffects but before the return statement
    useEffect(() => {
        // This effect runs once when component mounts
        console.log("PromptHeader mounted, checking for images");

        // Check for images in collection context
        if (collectionContext.collectionImage) {
            console.log("Found image in collection context on mount:", collectionContext.collectionImage);
            // Handle different forms of the collection image
            if (typeof collectionContext.collectionImage === 'string') {
                setImage(collectionContext.collectionImage);
            } else if (collectionContext.collectionImage.image && typeof collectionContext.collectionImage.image === 'string') {
                setImage(collectionContext.collectionImage.image);
            } else {
                console.log("Unknown collectionImage format:", collectionContext.collectionImage);
            }
        }

        // Check for image data in localStorage
        const transferActive = localStorage.getItem('image_transfer_active');
        if (transferActive === 'true') {
            const imageData = localStorage.getItem('temp_image_data');
            if (imageData) {
                console.log("Found image data in localStorage");
                setImage(imageData);

                // Also update the driver mode for image usage
                driverContextDispatch({ type: 'controlNet' });

                // Clear the localStorage flags once used
                localStorage.removeItem('image_transfer_active');
                localStorage.removeItem('temp_image_data');
                localStorage.removeItem('image_transfer_timestamp');
            }
        }
    }, []);

    useEffect(() => {
        // Check if there's a model selected from an image click
        const selectedModelFromImage = localStorage.getItem('selected_model');
        if (selectedModelFromImage) {
            console.log("Setting model from localStorage:", selectedModelFromImage);

            // Ensure we have the models fetched before trying to select one
            (async () => {
                // If we don't have models loaded yet, fetch them
                if (!promptusAPIState.models || promptusAPIState.models.length === 0) {
                    console.log("Fetching models before setting selected model");
                    await fetchModels();
                }

                // Set the model directly
                setSelectedModel(selectedModelFromImage);

                // Manually set up the options if they don't exist yet
                if (!options || options.length === 0) {
                    setOptions([{ value: selectedModelFromImage, label: selectedModelFromImage }, ...(options || [])]);
                } else if (!options.some(opt => opt.value === selectedModelFromImage)) {
                    // Add this model to options if it doesn't exist
                    setOptions([{ value: selectedModelFromImage, label: selectedModelFromImage }, ...options]);
                }

                // Don't automatically open advanced settings when model is selected from image
                // User can manually open if they want to see/change the model
                // if (!settingsOpen) {
                //     setSettingsOpen(true);
                //     driverContextDispatch({type: 'advanced'});
                // }

                try {
                    // Use handleRecommendedSettings which now loads cosyflows for all models
                    console.log("Loading settings for model from image:", selectedModelFromImage);
                    await handleRecommendedSettings(selectedModelFromImage);
                } catch (error) {
                    console.error("Error getting recommended settings:", error);
                }

                // Clear the localStorage item after using it
                localStorage.removeItem('selected_model');
            })();
        }
    }, []);

    // Listen for model selection events from CollectionImage component
    useEffect(() => {
        const handleModelSelectedEvent = (event) => {
            console.log("Received modelSelected event:", event.detail);
            const modelName = event.detail.model;

            if (modelName) {
                // Make sure modelName is a string
                const modelString = typeof modelName === 'string' ? modelName : String(modelName);

                // Set the model directly
                setSelectedModel(modelString);

                // Ensure the model is in options
                if (!options.some(opt => opt.value === modelString)) {
                    console.log("Adding model to options:", modelString);
                    setOptions([{ value: modelString, label: modelString }, ...options]);
                }

                // Don't automatically open advanced settings when model is selected from image
                // User can manually open if they want to see/change the model
                // if (!settingsOpen) {
                //     setSettingsOpen(true);
                //     driverContextDispatch({type: 'advanced'});
                // }

                // Get recommended settings
                handleRecommendedSettings(modelString);
            }
        };

        // Add event listener
        window.addEventListener('modelSelected', handleModelSelectedEvent);

        // Clean up event listener
        return () => {
            window.removeEventListener('modelSelected', handleModelSelectedEvent);
        };
    }, [options, settingsOpen]);

    // Check for model selection pending flag
    useEffect(() => {
        // Function to check if there's a pending model selection
        const checkForPendingModelSelection = () => {
            if (localStorage.getItem('model_selection_pending') === 'true') {
                // Clear the flag immediately to prevent multiple processing
                localStorage.removeItem('model_selection_pending');

                // Get the most recent model key (they're timestamped)
                const keys = Object.keys(localStorage).filter(key => key.startsWith('selected_model_'));

                if (keys.length > 0) {
                    // Sort keys by timestamp (newest first)
                    keys.sort().reverse();

                    // Get the model from the most recent key
                    const modelValue = localStorage.getItem(keys[0]);

                    if (modelValue) {
                        // Ensure we have a simple string
                        let modelName = modelValue;

                        // If it's a JSON object, try to parse it and extract the model name
                        if (modelValue.startsWith('{') && modelValue.endsWith('}')) {
                            try {
                                const parsed = JSON.parse(modelValue);
                                if (parsed.model) {
                                    modelName = parsed.model;
                                }
                            } catch (e) {
                                console.error("Error parsing model JSON:", e);
                            }
                        }

                        console.log("Found pending model selection:", modelName);

                        // Set the model
                        setSelectedModel(modelName);

                        // Don't automatically open advanced settings when model is selected from image
                        // User can manually open if they want to see/change the model
                        // if (!settingsOpen) {
                        //     setSettingsOpen(true);
                        //     driverContextDispatch({type: 'advanced'});
                        // }

                        // Clean up all temporary model keys
                        keys.forEach(key => localStorage.removeItem(key));
                    }
                }
            }
        };

        // Check immediately
        checkForPendingModelSelection();

        // Set up interval to check periodically (every 1 second)
        const intervalId = setInterval(checkForPendingModelSelection, 1000);

        // Clean up interval on component unmount
        return () => clearInterval(intervalId);
    }, [settingsOpen]);

    // Listen for prompt update events from CollectionImage component (Re-adding simplified version)
    useEffect(() => {
        const handlePromptUpdateEvent = (event) => {
            console.log("Received promptUpdated event:", event.detail);
            const promptText = event.detail.prompt;

            if (promptText && typeof promptText === 'string') {
                // Update the submitPrompt state directly
                console.log("Setting submitPrompt state to:", promptText);
                setSubmitPrompt(promptText);
            }
        };

        // Add event listener for custom event
        window.addEventListener('promptUpdated', handlePromptUpdateEvent);

        // Clean up event listener
        return () => {
            window.removeEventListener('promptUpdated', handlePromptUpdateEvent);
        };
    }, []); // Keep dependencies empty to only set up listener once

    // Add useEffect to load profile photo from localStorage
    useEffect(() => {
        const storedPhoto = localStorage.getItem("profilePhoto");
        if (storedPhoto) {
            setProfilePhoto(storedPhoto);
        }
    }, []);

    // Update profile photo when localStorage changes
    useEffect(() => {
        const handleStorageChange = () => {
            const storedPhoto = localStorage.getItem("profilePhoto");
            setProfilePhoto(storedPhoto || "");
        };

        // Listen for custom event from Profile page
        const handleProfilePhotoChange = () => {
            const storedPhoto = localStorage.getItem("profilePhoto");
            setProfilePhoto(storedPhoto || "");
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('profilePhotoChanged', handleProfilePhotoChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('profilePhotoChanged', handleProfilePhotoChange);
        };
    }, []);

    // // Handle clicks outside advanced settings to close it
    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (advancedSettingsRef.current && !advancedSettingsRef.current.contains(event.target)) {
    //             setSettingsOpen(false);
    //             driverContextDispatch({ type: 'reset' });
    //         }
    //     };

    //     if (settingsOpen) {
    //         document.addEventListener('mousedown', handleClickOutside);
    //         return () => {
    //             document.removeEventListener('mousedown', handleClickOutside);
    //         };
    //     }
    // }, [settingsOpen, driverContextDispatch]);

    const stableSchema = useMemo(() => promptMappings, [promptMappings]);
    const stableDefaults = useMemo(() => {
        console.log('[PromptHeader] Creating stableDefaults:', {
            scheduler: dynamic_inputs.scheduler,
            hasScheduler: 'scheduler' in dynamic_inputs,
            seed_mode: dynamic_inputs.seed_mode,
            allKeys: Object.keys(dynamic_inputs),
            fullDynamicInputs: dynamic_inputs
        });

        // Ensure any seed_mode fields are set to 'random' if they're 'fixed'
        const cleanedDefaults = { ...dynamic_inputs };
        Object.keys(cleanedDefaults).forEach(key => {
            if (key.endsWith('_mode') && key.includes('seed')) {
                // Always force seed_mode to 'random'
                console.log(`[PromptHeader] Forcing ${key} to 'random' (was: '${cleanedDefaults[key]}')`);
                cleanedDefaults[key] = 'random';
            }
        });

        return cleanedDefaults;
    }, [dynamic_inputs]);

        // Emit schema changes to inform other components about available fields
        useEffect(() => {
            const currentSchema = cosyUI ? promptMappings : stableSchema;
            let hasImageField = false;
            
            // Check if schema has any image input fields
            for (const [key, field] of Object.entries(currentSchema || {})) {
                // Check various ways an image field might be defined
                if (field.type === 'file' || 
                    field.type === 'b64' || 
                    field.type === 'b64data' || 
                    field.type === 'image' || 
                    key.toLowerCase().includes('image') ||
                    key.toLowerCase().includes('img') ||
                    (field.label && field.label.toLowerCase().includes('image')) ||
                    (field.accept && field.accept.includes('image'))) {
                    hasImageField = true;
                    console.log(`[PromptHeader] Found image field: ${key} with type: ${field.type}`);
                    break;
                }
            }
            
            // Emit the schema state
            eventBus.emit('schemaUpdate', { 
                hasImageField,
                isCosyUI: cosyUI,
                schema: currentSchema
            });
            
            console.log('[PromptHeader] Schema update emitted:', { 
                hasImageField, 
                isCosyUI: cosyUI,
                schemaKeys: Object.keys(currentSchema || {})
            });
        }, [cosyUI, promptMappings, stableSchema]);

    const tester = () =>{
        console.log("tester", inputGroupRef.current.getValues());
        
    }

    const selectDefaultMediaModel = (mediaType) => {
        // Update active media type for UI highlighting
        setActiveMediaType(mediaType);

        if (mediaType === 'audio') {
            setSelectedModel(DEFAULT_AUDIO_MODEL[0])
        } else if (mediaType === 'video') {
            setSelectedModel(DEFAULT_VIDEO_MODEL[0])
        } else {
            setSelectedModel(getAvailableDefaultModel(options, promptusAPIState.online))
        }
        setSettingsOpen(true)
    }

    return (
        <header className={`${driverContext.isActive ? '' : 'sticky'} top-0 grid grid-cols-9 gap-2 m-2 mt-4 z-10`} onKeyDown={handleKeyDown}>
            {generateStatus.status === 'canceling' ? <div className={"w-full col-span-3 md:col-span-5 lg:col-span-9 text-white bg-red-900 rounded-lg p-4"}>Cancelling Prompt</div> : null}
            {(generateStatus.status === 'error' && generateStatus.message) ? <div className={"w-full col-span-full text-white bg-red-900 rounded-lg p-4"}>{generateStatus.message}</div> : null}
            {/* <button className="border-2 border-cyan/50 rounded-lg min-middle:hidden max-lg-inclusive:col-span-1 p-1 cursor-pointer" onClick={() => eventBus.emit('show_nav_menu')}><img src={Logo} className="mx-auto text-black" /></button> */}
            {/* Top prompt bar removed - using only dynamic prompt field now */}
            {/* Enhance and Meme prompt toggles moved to be attached to main prompt box */}
            {localStorage.getItem('user_trial_sub') && localStorage.getItem('user_trial_sub') == "true" && !electronBridge.isElectron ?
                <div className={`bg-yellow/90 rounded-xl col-span-full p-5 backdrop-blur text-center font-semibold text-lg text-border-black z-1`}>
                    You are on a Free plan. Upgrade for more videos, offline unrestricted generations and ComfyUI features without limits. 
                    <a href={`https://login.promptus.ai/auto-signin?v=${accountContext.accountDetails.verificationToken}&e=${accountContext.accountDetails.emailHash}&a=${accountContext.accountDetails.accountNo}&r=/subscriptions`} target="_blank" className="font-bold underline">Upgrade</a>
                    .
                </div>
            : 
                null    
            }
            <div ref={advancedSettingsRef} className="col-span-full contents">

                <div className={`bg-dark-blue/80 rounded-xl col-span-full px-5 backdrop-blur h-auto transition border border-cyan/50`}>
                    <button className={`w-full flex flex-row items-center justify-center gap-2 text-lg transition duration-300 p-1 lg:p-2`} onClick={handleAdvancedSettings}>Generation Settings:<span className="text-yellow font-bold capitalize">{controlnetDisplay}</span>
                        <span className={`text-yellow font-bold capitalize ${imageNets === "" ? 'hidden' : ''}`}>{imageNets}</span>
                        <AdvancedSettingsIcon className={`${settingsOpen ? 'rotate-0' : 'rotate-180'} transition duration-300`} alt={"Advanced Settings Icon"} /></button>
                </div>
                <div className={`bg-dark-blue/80 rounded-xl col-span-full max-h-screen overflow-y-auto ${driverContext.isActive ? '' : 'backdrop-blur'} relative`}>
                    <AnimatePresence initial={false}>
                        <motion.div
                            animate="open"
                            initial="collapsed"
                            variants={{
                                open: { opacity: 1, height: "auto", },
                                collapsed: { opacity: 0, height: 0, }
                            }}
                            exit={"collapsed"}
                            transition={{ duration: 0.2, ease: [0.04, 0.62, 0.23, 0.98] }}
                            className={`${settingsOpen ? 'grid' : 'hidden'} gap-2 mt-1 lg:mt-2 ${cosyUI ? '' : 'grid-cols-2 md:grid-cols-4 lg:grid-cols-10'}`}>

                            {/* Online/Offline Toggle - Top Left */}
                            <div id="online" className="absolute top-2 left-2 z-30 bg-dark-blue/80 flex flex-col rounded-xl place-content-center place-items-center gap-1 p-2 border border-cyan/50 w-28">
                                <ToggleInput onChange={(e) => toggleOffline(e.target.checked)} checked={onlineState} disabled={generateStatus.loading} />
                                <span className={`font-bold text-sm xl:whitespace-nowrap ${onlineState ? 'text-yellow' : 'text-white'} transition`}>Online</span>
                            </div>

                            {/* Credits/Tokens Box - Top Right */}
                            <div id="tokens" className="absolute top-2 right-2 z-30 bg-dark-blue/80 flex flex-col items-center justify-center rounded-xl px-3 py-2 border border-cyan/50 w-28">
                                {accountContext.loggedIn ?
                                    <div className="flex items-center mb-1">
                                        {profilePhoto ? (
                                            <div
                                                className="w-6 h-6 rounded-full overflow-hidden border-2 border-amber-500 cursor-pointer hover:opacity-80 transition-opacity"
                                                onClick={() => navigate("/profile")}
                                            >
                                                <img
                                                    src={profilePhoto}
                                                    alt="Profile"
                                                    className="w-full h-full object-cover"
                                                />
                                            </div>
                                        ) : (
                                            <AccountIcon className="w-6 h-6 cursor-pointer hover:opacity-80 transition-opacity" alt="Promptus Account Icon" onClick={() => navigate("/profile")} />
                                        )}
                                    </div>
                                    :
                                    null
                                }
                                <div className="flex flex-row items-center gap-1">
                                    <TokenIcon className="w-5 h-5" alt={"Promptus Token Icon"} />
                                    <span className="font-bold text-sm text-yellow">
                                        {accountContext.loggedIn ? accountContext.tokens : 0}
                                    </span>
                                </div>
                            </div>

                            {/* Media Button Group - Fixed at Top Center */}
                            <div className="col-span-full flex justify-center mb-4 pt-2 sticky top-0 z-20">
                                <div className="flex bg-dark-blue/80 rounded-xl backdrop-blur border border-cyan/50 overflow-hidden shadow-lg">
                                    <button
                                        className={`px-4 py-3 transition duration-200 flex items-center justify-center gap-2 font-medium ${
                                            activeMediaType === 'image'
                                                ? 'bg-cyan/20 text-yellow border-r border-cyan/30'
                                                : 'hover:bg-cyan/10 text-white border-r border-cyan/20'
                                        }`}
                                        onClick={() => selectDefaultMediaModel('image')}
                                    >
                                        <span className="text-lg">🖼️</span>
                                        Image
                                    </button>
                                    <button
                                        className={`px-4 py-3 transition duration-200 flex items-center justify-center gap-2 font-medium ${
                                            activeMediaType === 'video'
                                                ? 'bg-cyan/20 text-yellow border-r border-cyan/30'
                                                : 'hover:bg-cyan/10 text-white border-r border-cyan/20'
                                        }`}
                                        onClick={() => selectDefaultMediaModel('video')}
                                    >
                                        <span className="text-lg">📹</span>
                                        Video
                                    </button>
                                    <button
                                        className={`px-4 py-3 transition duration-200 flex items-center justify-center gap-2 font-medium ${
                                            activeMediaType === 'audio'
                                                ? 'bg-cyan/20 text-yellow'
                                                : 'hover:bg-cyan/10 text-white'
                                        }`}
                                        onClick={() => selectDefaultMediaModel('audio')}
                                    >
                                        <span className="text-lg">🎵</span>
                                        Audio
                                    </button>
                                </div>
                            </div>

                            {console.log("[Select Render] cosyUI:", cosyUI, "- Rendering", cosyUI ? "cosy" : "standard", "Select component")}
                                <>
                                    <div className="col-span-full p-5 overflow-y-visible">
                                        {onlineCosyUI ?
                                            <>
                                                <AnimatedInputGroup
                                                    id="model"
                                                    className={`relative w-[100%] md:w-[55%] xl:w-[35%] mb-10 ${driverContext.isActive ? 'text-black' : ''}`}
                                                >
                                                    <div>
                                                        <label htmlFor={"Model"}
                                                            className="flex justify-between mb-2 text-sm font-medium" >Model <InfoIcon title="Model Input" className="h-6" /></label>
                                                        <Select
                                                            value={(() => {
                                                                const validModel = selectedModel && selectedModel.trim() !== '' ? selectedModel : null;
                                                                const foundOption = validModel ? options?.find(opt => opt.value === validModel) : undefined;
                                                                const fallbackOption = validModel ? { value: validModel, label: validModel } : undefined;
                                                                const finalValue = foundOption || fallbackOption;
                                                                return finalValue;
                                                            })()}
                                                            options={Array.isArray(options) ? options : []}
                                                            components={{ ...animatedComponents, MenuList: CustomMenuList }}
                                                            // onMenuOpen={() => {
                                                            //     // Fetch models when dropdown is opened
                                                            //     if (promptusAPIState.online == false) {
                                                            //         fetchWorkflows()
                                                            //     } else {
                                                            //         fetchModels()
                                                            //     }
                                                            // }}
                                                            onChange={(selectedOption) => {
                                                                console.log("[Select onChange - CosyUI] Selected option:", selectedOption);
                                                                if (selectedOption && selectedOption.value) {
                                                                    console.log("[Select onChange - CosyUI] Setting selectedModel to:", selectedOption.value);
                                                                    setSelectedModel(selectedOption.value);
                                                                    // handleRecommendedSettings will be called by useEffect when selectedModel changes
                                                                } else {
                                                                    console.warn("[Select onChange - CosyUI] No valid option selected");
                                                                }
                                                            }}
                                                            isLoading={logLoading}
                                                            className="text-dark-blue"
                                                            placeholder="Select a model..."
                                                        />
                                                    </div>
                                                </AnimatedInputGroup>
                                            </>
                                            :
                                            <AnimatedInputGroup
                                                id="workflows"
                                                className={`relative w-1/4 mb-10 ${driverContext.isActive ? 'text-black' : ''}`}
                                            >
                                                {/* <label htmlFor={"Workflows"}
                                                    className="block mb-2 text-sm font-medium">Workflows</label>
                                                <Select defaultValue={currentModelSelected} options={allWorkflows} components={animatedComponents} onChange={(e) => handleWorkflow(e.value)} className="text-dark-blue"/>
                                                <img className="absolute top-9 right-5 w-6" src={RefreshIcon} onClick={fetchWorkflows}/> */}

                                                <label htmlFor={"Workflows"}
                                                    className={`w-full flex flex-row gap-4 justify-between mb-2 text-sm font-medium`}>Workflows:</label>
                                                <select
                                                    value={selectedWorkflow}
                                                    onChange={(e) => {
                                                        setSelectedWorkflow(e.target.value);
                                                        handleWorkflow(e.target.value);
                                                    }}
                                                    onMouseEnter={fetchWorkflows} onClick={fetchWorkflows}
                                                    className={`w-full rounded-lg text-dark-blue ${driverContext.isActive ? 'border border-blue-950' : 'border-0'} p-2`}
                                                    disabled={onlineCosyUI}
                                                >
                                                    <option value="">Select a workflow</option>
                                                    {Array.isArray(allWorkflows) && allWorkflows.map((workflow, index) => (
                                                        <option key={index} value={workflow}>{workflow}</option>
                                                    ))}
                                                </select>
                                            </AnimatedInputGroup>
                                        }
                                        <div className="w-full">
                                            {/* Show loader when fetching model data, otherwise show the form */}
                                            {logLoading ? (
                                                <DynamicInputsSkeleton />
                                            ) : (
                                                <>
                                                    <DynamicPromptFormExperiment
                                                        key="cosy-form"
                                                        schema={promptMappings}
                                                        initialValues={(() => {
                                                            console.log('[PromptHeader] Passing to DynamicPromptFormExperiment (Cosy path):', {
                                                                scheduler: dynamic_inputs.scheduler,
                                                                schemaHasScheduler: 'scheduler' in promptMappings,
                                                                schemaScheduler: promptMappings.scheduler,
                                                                allDefaults: dynamic_inputs,
                                                                allSchemaKeys: Object.keys(promptMappings)
                                                            });
                                                            return dynamic_inputs;
                                                        })()}
                                                        ref={inputGroupRef}
                                                        isComfyUIModel={cosyUI}
                                                        selectedModel={selectedModel}
                                                        activeMediaType={activeMediaType}
                                                        onFieldChange={debouncedSaveCosyflowChanges}
                                                        onFetchLatestSeed={fetchLatestSeedFromDB}
                                                        uploadedB64Data={uploadedB64Data}
                                                        onB64Upload={(key, value) => {
                                                            setUploadedB64Data(prev => ({ ...prev, [key]: value }));
                                                        }}
                                                        enhancePrompt={enhancePrompt}
                                                        setEnhancePrompt={setEnhancePrompt}
                                                        memePrompt={memePrompt}
                                                        setMemePromptOptions={setMemePromptOptions}
                                                        generateStatus={generateStatus}
                                                    />
                                                    {/* Save status indicator for cosy models */}
                                                    {cosyUI && saveStatus && (
                                                        <div className={`fixed bottom-4 right-4 px-4 py-2 rounded-lg text-white text-sm font-medium transition-all duration-300 ${saveStatus === 'saved' ? 'bg-green-600' : 'bg-red-600'
                                                            }`}>
                                                            {saveStatus === 'saved' ? '✓ Settings saved' : '✗ Error saving'}
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                        <div className="flex justify-between mt-4">
                                            <button
                                                id="history"
                                                className="bg-dark-blue/90 rounded-lg px-3 py-2 backdrop-blur border border-cyan/50 hover:bg-cyan/10 transition flex items-center justify-center gap-2 shadow-lg"
                                                onClick={() => setOpenHistory(true)}
                                            >
                                                {/* <HistoryIcon alt='Open History' className='h-5 w-5' /> */}
                                                <span className="text-white font-medium hidden md:inline">History</span>
                                            </button>
                                            <button
                                                className="border-2 rounded uppercase px-5 py-2 bg-blue-500/50 hover:bg-blue-500/70 font-bold transition"
                                                onClick={handleRestoreDefaults}
                                            >
                                                Restore Defaults
                                            </button>

                                            <button
                                                type="submit"
                                                onClick={handleTagModal}
                                                id="generate"
                                                disabled={jobRequestPending || props.fetchingUndelivered}
                                                className={`rounded-lg px-7 py-3 backdrop-blur font-bold text-base uppercase transition-all duration-300 border border-cyan/50 w-38 shadow-lg
                                                    ${jobRequestPending ? 'bg-gray-400 cursor-wait' : 'bg-yellow hover:bg-yellow-500'}
                                                    ${props.fetchingUndelivered ? 'opacity-80 pointer-events-none' : ''}
                                                `}
                                            >
                                                {jobRequestPending ? (
                                                    <div className="flex items-center justify-center">
                                                        <svg aria-hidden="true" role="status" className="inline w-4 h-4 mr-2 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffffff" />
                                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                                                        </svg>
                                                    </div>
                                                ) : (
                                                    'Generate'
                                                )}
                                            </button>
                                        </div>
                                        {/* <button onClick={testInputGroupRef}>TESTING</button> */}
                                    </div>
                                </>

                            {image ?
                                <>
                                    <AnimatedInputGroup
                                        className={"col-span-8 flex flex-col items-center justify-between"}>
                                        <div className={"flex flex-col md:flex-row gap-2 w-full"}>
                                            <div id="imgtoimg" className={"flex flex-row items-center flex-grow"}>
                                                <ToggleInput id={"imageImage"} onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setPromptOutput("image-image");
                                                        setUpScale(0)
                                                        setControlNet("");
                                                        setPix2Pix(false);
                                                    } else {
                                                        setPromptOutput("text-image");
                                                        setImageNets("")
                                                    }
                                                }} checked={promptOutput === "image-image"} />
                                                <label htmlFor={"imageImage"}
                                                    className={`inline-block ml-2 text-sm font-medium ${promptOutput === "image-image" ? 'text-yellow' : 'text-gray-400'} transition`}>Image to Image</label>
                                            </div>
                                            <div id="inimg" className={"flex flex-row items-center flex-grow"}>
                                                <ToggleInput id={"imageInPaint"} onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setPromptOutput("image-in-paint")
                                                        setUpScale(0)
                                                        setControlNet("");
                                                        setPix2Pix(false);
                                                    } else {
                                                        setPromptOutput("text-image");
                                                        setImageNets("")
                                                    }
                                                }} checked={promptOutput === "image-in-paint"} />
                                                <label htmlFor={"imageInPaint"}
                                                    className={`inline-block ml-2 text-sm font-medium ${promptOutput === "image-in-paint" ? 'text-yellow' : 'text-gray-400'} transition`}>In-Paint Image</label>
                                            </div>
                                            <div id="guided" className={"flex flex-row items-center"}>
                                                <ToggleInput id={"Pix2Pix"} onChange={(e) => {
                                                    setControlNet("");
                                                    setPix2Pix(e.target.checked);
                                                    setUpScale(0)
                                                    setPromptOutput("text-image");
                                                    setImageNets("Guided")
                                                    setSelectedModel("instruct-pix2pix")
                                                    if (!e.target.checked) {
                                                        setImageNets("")
                                                    }
                                                }} checked={pix2pix} />
                                                <label htmlFor={"Pix2Pix"}
                                                    className={`inline-block ml-2 text-sm font-medium ${pix2pix ? 'text-yellow' : 'text-gray-400'} transition`}>Guided</label>
                                            </div>
                                            <div className={"flex flex-col w-full p-2 border rounded"}>
                                                <div className={"text-xs py-2"}>Control Nets</div>
                                                <div className={"flex flex-row gap-2"}>
                                                    <div id="pose" className={"flex flex-row items-center"}>
                                                        <ToggleInput id={"PoseToImage"} onChange={(e) => handleControlNetToggle(e.target.checked, "pose-to-image")} checked={(controlNet === "pose-to-image")} />
                                                        <label htmlFor={"PoseToImage"}
                                                            className={`inline-block ml-2 text-sm font-medium ${controlNet === "pose-to-image" ? 'text-yellow' : 'text-gray-400'} transition`}>Pose to Image</label>
                                                    </div>
                                                    <div id="canny" className={"flex flex-row items-center"}>
                                                        <ToggleInput id={"Canny"} onChange={(e) => handleControlNetToggle(e.target.checked, "canny")} checked={(controlNet === "canny")} />
                                                        <label htmlFor={"Canny"}
                                                            className={`inline-block ml-2 text-sm font-medium ${controlNet === "canny" ? 'text-yellow' : 'text-gray-400'} transition`}>Canny</label>
                                                    </div>
                                                    <div id="scribble" className={"flex flex-row items-center"}>
                                                        <ToggleInput id={"Scribble"} onChange={(e) => handleControlNetToggle(e.target.checked, "scribble")} checked={(controlNet === "scribble")} />
                                                        <label htmlFor={"Scribble"}
                                                            className={`inline-block ml-2 text-sm font-medium ${controlNet === "scribble" ? 'text-yellow' : 'text-gray-400'} transition`}>Scribble</label>
                                                    </div>
                                                    <div id="straight" className={"flex flex-row items-center"}>
                                                        <ToggleInput id={"StraightLines"} onChange={(e) => handleControlNetToggle(e.target.checked, "mlsd")} checked={(controlNet === "mlsd")} />
                                                        <label htmlFor={"StraightLines"}
                                                            className={`inline-block ml-2 text-sm font-medium ${controlNet === "mlsd" ? 'text-yellow' : 'text-gray-400'} transition`}>Straight Lines</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </AnimatedInputGroup>
                                    <AnimatedInputGroup
                                        className={"flex place-items-center justify-center lg:row-span-2"}
                                    >
                                        <button className={"border-2 rounded uppercase px-5 py-2 bg-red-500 font-bold m-1"} onClick={handleRemoveImage}>Remove Image</button>
                                    </AnimatedInputGroup>
                                    {!generateStatus.loading ?
                                        <>
                                            <AnimatedInputGroup
                                                className={"flex place-items-center justify-center lg:row-span-2"}
                                            >
                                                <button className={"border-2 rounded uppercase px-5 py-2 bg-white/20 font-bold m-1"} onClick={handleClearParams}>clear</button>
                                            </AnimatedInputGroup>
                                        </>
                                        : null}
                                </>
                                : null}
                        </motion.div>
                        {/* {settingsOpen && (
                    )} */}
                    </AnimatePresence>

                </div>
            </div>
            {inPaint ?
                <div className={"fixed top-0 left-0 z-10 flex flex-col justify-center place-items-center h-screen w-screen bg-dark-blue/40 backdrop-blur"}>
                    <div className={"w-full mx-auto max-w-screen-lg bg-gray-500/50 flex flex-row justify-end"}>
                        <button className={"px-5 py-2 rounded bg-dark-blue text-white m-2 hover:text-yellow transition"} onClick={() => setInPaint(false)}>
                            <CloseIcon alt='Close Image' className='h-7' />
                        </button>
                    </div>
                    <DrawingInput image={image && image.includes(":\\") ? toFileUrl(image) : `data:image/*;base64,${image}`} isMask={!!image} setImage={image ? setMaskImage : setImage} closeEvent={() => setInPaint(false)} />
                </div> : null}
            {openHistory ?
                // <div className={"fixed top-0 left-0 z-10 flex flex-col justify-center place-items-center h-screen w-screen bg-dark-blue/40 backdrop-blur"}>
                //     <div className={"w-full mx-auto max-w-screen-lg bg-gray-500/50 flex flex-row justify-between items-center"}>
                //         <h1 className={"text-2xl text-white px-4 font-bold drop-shadow"}>Prompt History</h1>
                //         <div className="flex flex-row">
                //             <button className={"py-2 px-4 m-2 rounded bg-red-600 transition"} onClick={clearHistory}>Delete All</button>
                //             <button className={"px-5 py-2 rounded bg-dark-blue text-white m-2 hover:text-yellow transition"} onClick={() => setOpenHistory(false)}>
                //                 <CloseIcon alt='Close Image' className='h-7'/>
                //             </button>
                //         </div>
                //     </div>
                //     <PromptHistory setPrompt={setWholePrompt} closeEvent={() => setOpenHistory(false)} setSeedWithPrompt={setSeedPrompt}/>
                // </div>
                <PromptHistory setPrompt={setWholePrompt} closeEvent={() => setOpenHistory(false)} setSeedWithPrompt={setSeedPrompt} />
                : null}
            <Modal open={open} onClose={() => setOpen(false)} center container={document.querySelector('.main-content') || undefined} >
                <h2 className="text-2xl mb-5 font-bold">Tag</h2>
                <p>
                    Please type in a tag to easily sort out your images
                </p>
                <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                    <label className="block mb-2 text-sm font-medium" htmlFor="emailAddress">New Tag</label>
                    <input type="text" name="tag" className="w-full rounded-lg text-dark-blue border border-dark-blue p-2" placeholder="Tag"
                        value={inputTag} onChange={(e) => setInputTag(e.target.value)} />
                </div>
                <div className="flex flex-row items-center">
                    <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                    <h1 className="mx-4 font-bold text-xl">OR</h1>
                    <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                </div>
                <p>
                    Please select an existing tag to easily sort out your images
                </p>
                <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                    <label className="block mb-2 text-sm font-medium" htmlFor="existing">Existing Tag</label>
                    <select name="existing" className={"rounded-lg text-dark-blue border border-dark-blue p-2 w-full"} value={tag} onChange={(e) => setTag(e.target.value)}>
                        <option></option>
                        {Array.isArray(collectionContext?.tags) && collectionContext.tags.map((category, i) => (
                            <option key={i} value={`${category}`}>{category}</option>
                        ))}
                    </select>
                </div>
                <div className="flex flex-row justify-center gap-4">
                    <button onClick={addTagToImage} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold">Categorize</button>
                    <button onClick={() => setOpen(false)} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-dark-blue text-yellow shadow font-bold">Cancel</button>
                </div>
            </Modal>
        </header>

    );
}

export function helpOverlays(e, driver) {
    // Help Overlay
    e.stopPropagation();

    const steps = [
        {
            // Step 1
            element: '#prompt',
            popover: {
                title: 'Prompt Input',
                description: 'You will type in a prompt to generate an image with this input.',
                position: 'bottom'
            }
        },
        {// Step 2
            element: '#record',
            popover: {
                title: 'Record',
                description: 'This button will be used to record your voice for a voice prompt then after stopping the recording you will be given the chance to edit anything in the prompt input before generating',
                position: 'bottom'
            }
        },
        {// Step 3
            element: '#history',
            popover: {
                title: 'History',
                description: 'This button will show the history of other inputs you have made',
                position: 'bottom'
            }
        },
        {// Step 4
            element: '#upload',
            popover: {
                title: 'Upload',
                description: 'Here you can upload a image you have generated or an image of your own',
                position: 'bottom'
            }
        },
        {// Step 5
            element: '#edit',
            popover: {
                title: 'Masking',
                description: 'Here you will add a mask to your uploaded image to add/change whatever is in your mask',
                position: 'bottom'
            }
        },
        {// Step 6
            element: '#generate',
            popover: {
                title: 'Generate',
                description: 'Once you are finish with making your prompt, clicking this button will start generating your prompt',
                position: 'bottom'
            }
        },
        {// Step 7
            element: '#enhance',
            popover: {
                title: 'Enhance Prompt',
                description: 'This toggle will make your prompt more detailed to generate a more detailed image',
                position: 'bottom'
            }
        },
        {
            element: '#meme',
            popover: {
                title: 'Meme Prompt',
                description: 'This toggle will turn your prompt into a meme styled image',
                position: 'bottom'
            }
        },
        {
            element: '#online',
            popover: {
                title: 'Online/Offline Toggle',
                description: 'This toggle will switch you to online or offline depending on what you would like to generate on',
                position: 'bottom'
            }
        },
        {// Step 9
            element: '#tokens',
            popover: {
                title: 'Tokens',
                description: 'The tokens decreases everytime you successfully generate a image and you buy tokens to generate more images',
                position: 'left'
            }
        },
        {// Step 10
            element: '#seeds',
            popover: {
                title: 'Seeds',
                description: 'A unique seed number that is generated for each result of the prompt generated.',
                position: 'bottom'
            }
        },
        {// Step 11
            element: '#negative',
            popover: {
                title: 'Negative Keywords',
                description: 'Negative keywords refer to specific terms or phrases that you want to exclude from the generated images. ',
                position: 'bottom'
            }
        },
        {// Step 12
            element: '#steps',
            popover: {
                title: 'Steps',
                description: 'This slider will indicate how detailed you want the image to be the higher you go',
                position: 'bottom'
            }
        },
        {// Step 13
            element: '#guidance',
            popover: {
                title: 'Guidance',
                description: 'This Guidance Scale is a measurement tool used to assess the level of complexity and abstractness of the generated images.This scale ranges from 0 to 20, with higher numbers indicating more complex and abstract images.',
                position: 'bottom'
            }
        },
        {// Step 14
            element: '#number',
            popover: {
                title: 'Number Of Images',
                description: 'You can specify the number of images you would like to generate. This can range from 1 to a large number, depending on the processing power of the source and your preferences.',
                position: 'bottom'
            }
        },
        {// Step 15
            element: '#size',
            popover: {
                title: 'Image Size',
                description: 'You can specify the image size you would like the images to be generated at.',
                position: 'bottom'
            }
        },
        {// Step 16
            element: '#model',
            popover: {
                title: 'Models',
                description: 'The Model is a component of the AI image creation system that selects and processes data to generate images. It samples data from various sources, including image databases, algorithms, and user input, to produce final images. The Model is crucial in determining the quality, complexity, and overall appearance of the generated images and can vary in terms of quality and generation speed based on the algorithms and data sources used.',
                position: 'bottom'
            }
        },
        {// Step 17
            element: '#scheduler',
            popover: {
                title: 'Scheduler',
                description: 'Schedulers can affect the final image generated by controlling how the model is trained during the image generation process. They essentially control the learning rate or step size of the model as it improves over time, and determine how quickly or slowly the model is allowed to learn and adapt to new data. ',
                position: 'bottom'
            }
        },
        {// Step 18
            element: '#tileshuffle',
            popover: {
                title: 'Tile and Shuffle',
                description: 'When tile is enabled, images are generated as s repeatable pattern and when shuffle is enabled, an AI model is randomly selected when images are generated.',
                position: 'bottom'
            }
        },
        {// Step 19
            element: '#scale',
            popover: {
                title: 'Scale',
                description: 'You can scale an uploaded image by 2/4/8 times it\'s original size',
                position: 'bottom'
            }
        },
        {// Step 21
            element: '#imgtoimg',
            popover: {
                title: 'Image To Image',
                description: 'Using an uploaded image you can change this image using it as the base and the prompt will change it however you want it to',
                position: 'bottom'
            }
        },
        {// Step 22
            element: '#inimg',
            popover: {
                title: 'In-Paint Image',
                description: 'Using the mask on an image or using a scribble, in-painting will fill in the missing parts of the image using your prompt as the missing part to present a complete image',
                position: 'bottom'
            }
        },
        {// Step 23
            element: '#guided',
            popover: {
                title: 'Guided',
                description: 'Guided uses the image uploaded and the masking on it to edit the part of the image you masked with the prompt',
                position: 'bottom'
            }
        },
        {// Step 24
            element: '#pose',
            popover: {
                title: 'Pose To Image',
                description: 'This control net maps a human pose of the input image and uses that pose in correspondence with the prompt to create an image with similar poses to the base image',
                position: 'bottom'
            }
        },
        {// Step 25
            element: '#canny',
            popover: {
                title: 'Canny',
                description: 'Canny uses edge detection on your input image and creates a new image with your prompt using the edges it detected',
                position: 'bottom'
            }
        },
        {// Step 26
            element: '#scribble',
            popover: {
                title: 'Scribble',
                description: 'Scribble uses the scribble you made in the mask area or an uploaded scribble and it will use your drawing and prompt as a template to guide the generation',
                position: 'bottom'
            }
        },
        {// Step 27
            element: '#straight',
            popover: {
                title: 'Straight Lines',
                description: 'This control net uses line detection in an input image in addition to a prompt to generate an image',
                position: 'bottom'
            }
        }
    ];


    // Define the steps in the driver
    driver.defineSteps(steps);
};